// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMkAAAAdCAYAAAAAaUg8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKtJREFUeNrs09EKgjAUgOGzEFfv/7CVBceiLiJiLnf7fSAbDoUj/iWnyKgRcXxf9Wtt7Vvntf8854jLY3uN19qzf67nH/e2nmmdZ8xjg2x+sI533qf9g4wM/3GvLPumOHVMWf/4SiWWsUG6/6bG+/NWDgE0iQREAiIBkYBIQCQgEhAJiAQQCYgERAIiAZGASEAkIBJAJCASEAmIBEQCIgGRgEgAkYBIYNAqwAD5oWo3bpsiKwAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/gif;base64,R0lGODdhDAAMAIABAMzMzP///ywAAAAADAAMAAACFoQfqYeabNyDMkBQb81Uat85nxguUAEAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23052c65%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../images/caret_down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../images/caret_up.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../images/icons/communiti_cta_unisciti.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../images/cerca.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../images/icons/communiti_icon_follower.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/communiti-icons.eot?39e9op", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../fonts/communiti-icons.ttf?39e9op", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../fonts/communiti-icons.woff?39e9op", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../fonts/communiti-icons.svg?39e9op", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../images/icons/communiti_icon_event.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../images/icons/communiti_icon_van.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../images/icons/communiti_icon_story.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../images/icons/communiti_icon_bell.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../images/icons/communiti_icon_pencil.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../images/icons/communiti_icon_tag.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../images/icons/communiti_icon_story_new.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../images/box-promo-kit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../images/mobile-actions-nav.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../images/icons/communiti_icon_hand.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../images/icons/communiti_icon_star_off.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../images/icons/communiti_icon_star_on.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../images/wave.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("images/btn-avatar-deselect.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../images/king_ico.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___, { hash: "#communiti-icons" });
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.3.2 (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
/* sass-plugin-1:/Users/maronato/Developer/vue-toastification/src/scss/index.scss */
.Vue-Toastification__container {
  z-index: 9999;
  position: fixed;
  padding: 4px;
  width: 600px;
  box-sizing: border-box;
  display: flex;
  min-height: 100%;
  color: #fff;
  flex-direction: column;
  pointer-events: none;
}
@media only screen and (min-width : 600px) {
  .Vue-Toastification__container.top-left,
  .Vue-Toastification__container.top-right,
  .Vue-Toastification__container.top-center {
    top: 1em;
  }
  .Vue-Toastification__container.bottom-left,
  .Vue-Toastification__container.bottom-right,
  .Vue-Toastification__container.bottom-center {
    bottom: 1em;
    flex-direction: column-reverse;
  }
  .Vue-Toastification__container.top-left,
  .Vue-Toastification__container.bottom-left {
    left: 1em;
  }
  .Vue-Toastification__container.top-left .Vue-Toastification__toast,
  .Vue-Toastification__container.bottom-left .Vue-Toastification__toast {
    margin-right: auto;
  }
  @supports not (-moz-appearance: none) {
    .Vue-Toastification__container.top-left .Vue-Toastification__toast--rtl,
    .Vue-Toastification__container.bottom-left .Vue-Toastification__toast--rtl {
      margin-right: unset;
      margin-left: auto;
    }
  }
  .Vue-Toastification__container.top-right,
  .Vue-Toastification__container.bottom-right {
    right: 1em;
  }
  .Vue-Toastification__container.top-right .Vue-Toastification__toast,
  .Vue-Toastification__container.bottom-right .Vue-Toastification__toast {
    margin-left: auto;
  }
  @supports not (-moz-appearance: none) {
    .Vue-Toastification__container.top-right .Vue-Toastification__toast--rtl,
    .Vue-Toastification__container.bottom-right .Vue-Toastification__toast--rtl {
      margin-left: unset;
      margin-right: auto;
    }
  }
  .Vue-Toastification__container.top-center,
  .Vue-Toastification__container.bottom-center {
    left: 50%;
    margin-left: -300px;
  }
  .Vue-Toastification__container.top-center .Vue-Toastification__toast,
  .Vue-Toastification__container.bottom-center .Vue-Toastification__toast {
    margin-left: auto;
    margin-right: auto;
  }
}
@media only screen and (max-width : 600px) {
  .Vue-Toastification__container {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;
  }
  .Vue-Toastification__container .Vue-Toastification__toast {
    width: 100%;
  }
  .Vue-Toastification__container.top-left,
  .Vue-Toastification__container.top-right,
  .Vue-Toastification__container.top-center {
    top: 0;
  }
  .Vue-Toastification__container.bottom-left,
  .Vue-Toastification__container.bottom-right,
  .Vue-Toastification__container.bottom-center {
    bottom: 0;
    flex-direction: column-reverse;
  }
}
.Vue-Toastification__toast {
  display: inline-flex;
  position: relative;
  max-height: 800px;
  min-height: 64px;
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: 22px 24px;
  border-radius: 8px;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  font-family:
    "Lato",
    Helvetica,
    "Roboto",
    Arial,
    sans-serif;
  max-width: 600px;
  min-width: 326px;
  pointer-events: auto;
  overflow: hidden;
  transform: translateZ(0);
  direction: ltr;
}
.Vue-Toastification__toast--rtl {
  direction: rtl;
}
.Vue-Toastification__toast--default {
  background-color: #1976d2;
  color: #fff;
}
.Vue-Toastification__toast--info {
  background-color: #2196f3;
  color: #fff;
}
.Vue-Toastification__toast--success {
  background-color: #4caf50;
  color: #fff;
}
.Vue-Toastification__toast--error {
  background-color: #ff5252;
  color: #fff;
}
.Vue-Toastification__toast--warning {
  background-color: #ffc107;
  color: #fff;
}
@media only screen and (max-width : 600px) {
  .Vue-Toastification__toast {
    border-radius: 0px;
    margin-bottom: 0.5rem;
  }
}
.Vue-Toastification__toast-body {
  flex: 1;
  line-height: 24px;
  font-size: 16px;
  word-break: break-word;
  white-space: pre-wrap;
}
.Vue-Toastification__toast-component-body {
  flex: 1;
}
.Vue-Toastification__toast.disable-transition {
  animation: none !important;
}
.Vue-Toastification__close-button {
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  padding-left: 10px;
  cursor: pointer;
  transition: 0.3s ease;
  align-items: center;
  color: #fff;
  opacity: 0.3;
  transition: visibility 0s, opacity 0.2s linear;
}
.Vue-Toastification__close-button:hover,
.Vue-Toastification__close-button:focus {
  opacity: 1;
}
.Vue-Toastification__toast:not(:hover) .Vue-Toastification__close-button.show-on-hover {
  opacity: 0;
}
.Vue-Toastification__toast--rtl .Vue-Toastification__close-button {
  padding-left: unset;
  padding-right: 10px;
}
@keyframes scale-x-frames {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}
.Vue-Toastification__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  z-index: 10000;
  background-color: rgba(255, 255, 255, 0.7);
  transform-origin: left;
  animation: scale-x-frames linear 1 forwards;
}
.Vue-Toastification__toast--rtl .Vue-Toastification__progress-bar {
  right: 0;
  left: unset;
  transform-origin: right;
}
.Vue-Toastification__icon {
  margin: auto 18px auto 0px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  transition: 0.3s ease;
  align-items: center;
  width: 20px;
  height: 100%;
}
.Vue-Toastification__toast--rtl .Vue-Toastification__icon {
  margin: auto 0px auto 18px;
}
@keyframes bounceInRight {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes bounceOutRight {
  40% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(1000px, 0, 0);
  }
}
@keyframes bounceInLeft {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes bounceInUp {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes bounceInDown {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}
@keyframes bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.Vue-Toastification__bounce-enter-active.top-left,
.Vue-Toastification__bounce-enter-active.bottom-left {
  animation-name: bounceInLeft;
}
.Vue-Toastification__bounce-enter-active.top-right,
.Vue-Toastification__bounce-enter-active.bottom-right {
  animation-name: bounceInRight;
}
.Vue-Toastification__bounce-enter-active.top-center {
  animation-name: bounceInDown;
}
.Vue-Toastification__bounce-enter-active.bottom-center {
  animation-name: bounceInUp;
}
.Vue-Toastification__bounce-leave-active:not(.disable-transition).top-left,
.Vue-Toastification__bounce-leave-active:not(.disable-transition).bottom-left {
  animation-name: bounceOutLeft;
}
.Vue-Toastification__bounce-leave-active:not(.disable-transition).top-right,
.Vue-Toastification__bounce-leave-active:not(.disable-transition).bottom-right {
  animation-name: bounceOutRight;
}
.Vue-Toastification__bounce-leave-active:not(.disable-transition).top-center {
  animation-name: bounceOutUp;
}
.Vue-Toastification__bounce-leave-active:not(.disable-transition).bottom-center {
  animation-name: bounceOutDown;
}
.Vue-Toastification__bounce-leave-active,
.Vue-Toastification__bounce-enter-active {
  animation-duration: 750ms;
  animation-fill-mode: both;
}
.Vue-Toastification__bounce-move {
  transition-timing-function: ease-in-out;
  transition-property: all;
  transition-duration: 400ms;
}
@keyframes fadeOutTop {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-50px);
    opacity: 0;
  }
}
@keyframes fadeOutLeft {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes fadeOutBottom {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
  }
}
@keyframes fadeOutRight {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(50px);
    opacity: 0;
  }
}
@keyframes fadeInLeft {
  0% {
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes fadeInRight {
  0% {
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes fadeInTop {
  0% {
    transform: translateY(-50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fadeInBottom {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.Vue-Toastification__fade-enter-active.top-left,
.Vue-Toastification__fade-enter-active.bottom-left {
  animation-name: fadeInLeft;
}
.Vue-Toastification__fade-enter-active.top-right,
.Vue-Toastification__fade-enter-active.bottom-right {
  animation-name: fadeInRight;
}
.Vue-Toastification__fade-enter-active.top-center {
  animation-name: fadeInTop;
}
.Vue-Toastification__fade-enter-active.bottom-center {
  animation-name: fadeInBottom;
}
.Vue-Toastification__fade-leave-active:not(.disable-transition).top-left,
.Vue-Toastification__fade-leave-active:not(.disable-transition).bottom-left {
  animation-name: fadeOutLeft;
}
.Vue-Toastification__fade-leave-active:not(.disable-transition).top-right,
.Vue-Toastification__fade-leave-active:not(.disable-transition).bottom-right {
  animation-name: fadeOutRight;
}
.Vue-Toastification__fade-leave-active:not(.disable-transition).top-center {
  animation-name: fadeOutTop;
}
.Vue-Toastification__fade-leave-active:not(.disable-transition).bottom-center {
  animation-name: fadeOutBottom;
}
.Vue-Toastification__fade-leave-active,
.Vue-Toastification__fade-enter-active {
  animation-duration: 750ms;
  animation-fill-mode: both;
}
.Vue-Toastification__fade-move {
  transition-timing-function: ease-in-out;
  transition-property: all;
  transition-duration: 400ms;
}
@keyframes slideInBlurredLeft {
  0% {
    transform: translateX(-1000px) scaleX(2.5) scaleY(0.2);
    transform-origin: 100% 50%;
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    transform: translateX(0) scaleY(1) scaleX(1);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
}
@keyframes slideInBlurredTop {
  0% {
    transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
    transform-origin: 50% 0%;
    filter: blur(240px);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scaleY(1) scaleX(1);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
}
@keyframes slideInBlurredRight {
  0% {
    transform: translateX(1000px) scaleX(2.5) scaleY(0.2);
    transform-origin: 0% 50%;
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    transform: translateX(0) scaleY(1) scaleX(1);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
}
@keyframes slideInBlurredBottom {
  0% {
    transform: translateY(1000px) scaleY(2.5) scaleX(0.2);
    transform-origin: 50% 100%;
    filter: blur(240px);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scaleY(1) scaleX(1);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
}
@keyframes slideOutBlurredTop {
  0% {
    transform: translateY(0) scaleY(1) scaleX(1);
    transform-origin: 50% 0%;
    filter: blur(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-1000px) scaleY(2) scaleX(0.2);
    transform-origin: 50% 0%;
    filter: blur(240px);
    opacity: 0;
  }
}
@keyframes slideOutBlurredBottom {
  0% {
    transform: translateY(0) scaleY(1) scaleX(1);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
  100% {
    transform: translateY(1000px) scaleY(2) scaleX(0.2);
    transform-origin: 50% 100%;
    filter: blur(240px);
    opacity: 0;
  }
}
@keyframes slideOutBlurredLeft {
  0% {
    transform: translateX(0) scaleY(1) scaleX(1);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-1000px) scaleX(2) scaleY(0.2);
    transform-origin: 100% 50%;
    filter: blur(40px);
    opacity: 0;
  }
}
@keyframes slideOutBlurredRight {
  0% {
    transform: translateX(0) scaleY(1) scaleX(1);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
  100% {
    transform: translateX(1000px) scaleX(2) scaleY(0.2);
    transform-origin: 0% 50%;
    filter: blur(40px);
    opacity: 0;
  }
}
.Vue-Toastification__slideBlurred-enter-active.top-left,
.Vue-Toastification__slideBlurred-enter-active.bottom-left {
  animation-name: slideInBlurredLeft;
}
.Vue-Toastification__slideBlurred-enter-active.top-right,
.Vue-Toastification__slideBlurred-enter-active.bottom-right {
  animation-name: slideInBlurredRight;
}
.Vue-Toastification__slideBlurred-enter-active.top-center {
  animation-name: slideInBlurredTop;
}
.Vue-Toastification__slideBlurred-enter-active.bottom-center {
  animation-name: slideInBlurredBottom;
}
.Vue-Toastification__slideBlurred-leave-active:not(.disable-transition).top-left,
.Vue-Toastification__slideBlurred-leave-active:not(.disable-transition).bottom-left {
  animation-name: slideOutBlurredLeft;
}
.Vue-Toastification__slideBlurred-leave-active:not(.disable-transition).top-right,
.Vue-Toastification__slideBlurred-leave-active:not(.disable-transition).bottom-right {
  animation-name: slideOutBlurredRight;
}
.Vue-Toastification__slideBlurred-leave-active:not(.disable-transition).top-center {
  animation-name: slideOutBlurredTop;
}
.Vue-Toastification__slideBlurred-leave-active:not(.disable-transition).bottom-center {
  animation-name: slideOutBlurredBottom;
}
.Vue-Toastification__slideBlurred-leave-active,
.Vue-Toastification__slideBlurred-enter-active {
  animation-duration: 750ms;
  animation-fill-mode: both;
}
.Vue-Toastification__slideBlurred-move {
  transition-timing-function: ease-in-out;
  transition-property: all;
  transition-duration: 400ms;
}
.small-alpha-slider{height:10px!important}
.small-alpha-slider .small-bar{height:10px!important;width:10px!important}
.small-alpha-slider .small-bar div{width:12px!important;height:12px!important;border-radius:5px!important;transform:translate(-6px,-2px);margin-top:1px!important}
.bee-alpha-slider{position:relative;margin-bottom:15px;width:100%;height:14px;box-shadow:2px 0 8px #00000014;border-radius:15px}
.bee-alpha-slider.is-vertical{width:14px;height:100%;display:inline-block;transform:rotate(180deg)}
.bee-alpha-slider.transparent{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.bee-alpha-slider__bar{position:relative;width:100%;height:100%;border-radius:15px}
.bee-alpha-slider__bar-pointer{position:absolute;width:14px;height:14px}
.bee-alpha-slider__bar-handle{width:14px;height:14px;border-radius:6px;transform:translate(-7px,-2px);background-color:#f8f8f8;margin-top:2px;box-shadow:0 1px 4px #0000005e;cursor:pointer}
.bee-alpha-slider__bar-handle.vertical{transform:translateY(-7px);margin-top:0}
.bee-compact{margin-bottom:15px;width:auto;box-shadow:3px 0 5px #00000014;display:inline-block}
.bee-compact__row{position:relative;width:100%;margin:0}
.bee-compact__row>*{display:inline-block;vertical-align:middle}
.bee-compact__color_cube{width:100%;height:100%}
.bee-compact__color_cube.transparent:before{content:"";position:absolute;top:0;left:0;width:100%;height:100%;background:white}
.bee-compact__color_cube.transparent:after{content:"";position:absolute;top:100%;left:0;transform:rotate(-45deg);transform-origin:0 0;width:35px;height:1px;background:red}
.bee-compact__color_cube.advance{background:url(${___CSS_LOADER_URL_REPLACEMENT_1___})}
.bee-compact__color_cube .alpha{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.bee-compact__color-cube--wrap{position:relative;width:25px;height:25px;cursor:pointer;overflow:hidden}
.bee-compact__color-cube--wrap:hover{transform:scale(1.2);z-index:299;transition:transform .2s}
.bee-colorPicker__record{display:flex;align-items:center;margin-top:20px}
.bee-colorPicker__record .text{width:48px;margin-right:10px;text-align:right;font-size:12px;color:#666}
.bee-colorPicker__record .color-list{width:auto;display:flex;position:relative;margin:0}
.bee-colorPicker__record .color-list .color-item{position:relative;width:25px;height:25px;cursor:pointer;overflow:hidden;display:inline-block;vertical-align:middle;margin-right:1px;box-shadow:3px 0 5px #00000014}
.bee-colorPicker__record .color-list .color-item__round{border-radius:50%}
.bee-colorPicker__record .color-list .color-item.transparent{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.bee-colorPicker__record .color-list .color-item:hover{transform:scale(1.2);z-index:299;transition:transform .2s}
.bee-colorPicker__record .color-list .color-item__display{width:100%;height:100%}
.small-hue-slider{height:10px!important}
.small-hue-slider .small-bar{height:10px!important;width:10px!important}
.small-hue-slider .small-bar div{width:12px!important;height:12px!important;border-radius:5px!important;transform:translate(-6px,-2px);margin-top:1px!important}
.bee-hue-colorPicker{position:relative;margin-bottom:15px;width:100%;height:14px;box-shadow:2px 0 8px #00000014;border-radius:15px}
.bee-hue-colorPicker.is-vertical{width:14px;height:100%;display:inline-block;transform:rotate(180deg)}
.bee-hue-colorPicker.transparent{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.bee-hue-colorPicker__inner{position:relative;width:100%;height:100%;border-radius:15px;background-image:url(${___CSS_LOADER_URL_REPLACEMENT_2___});background-size:100%}
.bee-hue-colorPicker__inner-pointer{position:absolute;width:14px;height:14px}
.bee-hue-colorPicker__inner-handle{width:14px;height:14px;border-radius:6px;transform:translate(-7px,-2px);background-color:#f8f8f8;margin-top:2px;box-shadow:0 1px 4px #0000005e;cursor:pointer}
.bee-hue-colorPicker__inner-handle.vertical{transform:translate(-1px,-7px);margin-top:0}
.small-light-slider{height:10px!important}
.small-light-slider .small-bar{height:10px!important;width:10px!important}
.small-light-slider .small-bar div{width:12px!important;height:12px!important;border-radius:5px!important;transform:translate(-6px,-2px);margin-top:1px!important}
.bee-light-colorPicker{position:relative;margin-bottom:15px;width:100%;height:14px;box-shadow:2px 0 8px #00000014;border-radius:15px}
.bee-light-colorPicker.is-vertical{width:14px;height:100%;display:inline-block;transform:rotate(180deg)}
.bee-light-colorPicker.transparent{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.bee-light-colorPicker__inner{position:relative;width:100%;height:100%;border-radius:15px}
.bee-light-colorPicker__inner-pointer{position:absolute;width:14px;height:14px}
.bee-light-colorPicker__inner-handle{width:14px;height:14px;border-radius:6px;transform:translate(-7px,-2px);background-color:#f8f8f8;margin-top:2px;box-shadow:0 1px 4px #0000005e;cursor:pointer}
.bee-light-colorPicker__inner-handle.vertical{transform:translateY(-7px);margin-top:0}
.bee-saturation{position:relative;margin-bottom:15px;width:100%;height:125px}
.bee-saturation__chrome{border-top-left-radius:5px;border-top-right-radius:5px;border-color:transparent}
.bee-saturation__hidden{overflow:hidden}
.bee-saturation__white,.bee-saturation__black{position:absolute;top:0;left:0;right:0;bottom:0}
.bee-saturation__black{background:linear-gradient(0deg,#000,transparent)}
.bee-saturation__white{background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}
.bee-saturation__cursor{position:absolute}
.bee-saturation__cursor div{transform:translate(-5px,-5px);box-shadow:0 1px 4px #0000005e;width:10px;height:10px;border:1px solid white;border-radius:50%;cursor:pointer}
.inputs-controls{display:flex;font-size:16px;margin-bottom:5px}
.inputs-controls .formatBtn{position:relative;display:inline-flex;justify-content:center;align-items:center;padding:1px;border:0;text-align:center;cursor:pointer;background-color:transparent;font-weight:700;outline:none;margin-right:5px}
.inputs-controls .formatBtn:hover{color:#1a3aff}
.inputs-controls .format-group{display:flex;flex-grow:1}
.inputs-controls .format-group input{padding:5px;margin:0 3px;min-width:0;text-align:center;border-width:0 0 1px 0;-webkit-appearance:none;appearance:none;-moz-appearance:textfield;outline:none;flex:1}
.inputs-controls .format-group input::-webkit-outer-spin-button,.inputs-controls .format-group input::-webkit-inner-spin-button{-webkit-appearance:none!important;margin:0}
.bee-fk-colorPicker{position:relative;box-sizing:border-box;border-radius:3px;box-shadow:0 0 10px #00000026;-webkit-user-select:none;user-select:none;background-color:#fff;width:249px;padding-bottom:10px}
.bee-fk-colorPicker__inner{padding:12px}
.bee-fk-colorPicker__header{margin-bottom:12px;z-index:999;text-align:left}
.bee-fk-colorPicker__header .back{border:solid black;border-width:0 1px 1px 0;display:inline-block;padding:4px;margin-left:2px;transform:rotate(135deg);-webkit-transform:rotate(135deg)}
.bee-fk-colorPicker__display{position:relative;width:100%;margin:0;text-align:left}
.bee-fk-colorPicker__display .transparent{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.bee-fk-colorPicker__display .current-color{margin-right:10px;width:50px;height:24px;box-shadow:3px 0 5px #00000014;position:relative;cursor:pointer;overflow:hidden;display:inline-block;vertical-align:middle}
.bee-fk-colorPicker__display .current-color .color-cube{width:100%;height:100%}
.bee-fk-colorPicker__display .hexColor-prefix{position:relative;padding:0 4px;font-size:14px;display:inline-block;vertical-align:middle}
.bee-fk-colorPicker__display input{width:25px;text-align:center;outline:0;border-top:0;border-right:0;border-left:none;display:inline-block;vertical-align:middle;padding-bottom:3px;border-bottom:1px solid #e3e2e8}
.bee-fk-colorPicker__display .hexColor-input{width:64px}
.bee-fk-colorPicker__display .action{float:right;vertical-align:middle}
.bee-fk-colorPicker__display .action .clear-btn{border-color:transparent;color:#409eff;background:transparent;padding-left:0;padding-right:0;display:inline-block;vertical-align:middle;cursor:pointer}
.bee-fk-colorPicker__display .action .copy-btn{border-color:transparent;color:#13ce66cc;background:transparent;padding-left:0;padding-right:0;display:inline-block;margin-left:10px;vertical-align:middle;cursor:pointer}
.bee-ele-colorPicker{position:relative;box-sizing:border-box;border-radius:3px;box-shadow:0 0 10px #00000026;-webkit-user-select:none;user-select:none;background-color:#fff;padding:10px;width:300px}
.bee-ele-colorPicker .bee-ele-row{display:flex}
.bee-ele-colorPicker .bee-ele-row .bee-ele-saturation{width:280px;height:180px}
.bee-ele-colorPicker .bee-ele-row .bee-ele-hue{margin-left:10px;height:180px}
.bee-chrome-colorPicker{position:relative;box-sizing:border-box;border-radius:3px;box-shadow:0 0 10px #00000026;-webkit-user-select:none;user-select:none;background-color:#fff;width:250px;padding-bottom:20px}
.bee-chrome-colorPicker-body{padding:0 12px;background-color:#fff}
.bee-chrome-colorPicker-body .chrome-controls{display:flex}
.bee-chrome-colorPicker-body .chrome-controls .chrome-color-wrap{position:relative;width:36px;height:36px;border-radius:50%;overflow:hidden;z-index:1}
.bee-chrome-colorPicker-body .chrome-controls .chrome-color-wrap .current-color{width:100%;height:100%}
.bee-chrome-colorPicker-body .chrome-controls .chrome-sliders{flex:1;margin-left:10px}
.bee-color-wrap{margin-right:10px;width:50px;height:24px;box-shadow:3px 0 5px #00000014;position:relative;cursor:pointer;overflow:hidden;display:inline-block;vertical-align:middle}
.bee-color-wrap.transparent{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.bee-color-wrap.round{width:22px;height:22px;border-radius:50%;border:1px solid #d8d8d8}
.bee-color-wrap .current-color{width:100%;height:100%}
.vc-alpha-slider[data-v-18925ba6]{position:relative;margin-bottom:15px;width:100%;height:14px;box-shadow:2px 0 8px #00000014;border-radius:15px}
.vc-alpha-slider.is-vertical[data-v-18925ba6]{width:14px;height:100%;display:inline-block;transform:rotate(180deg)}
.vc-alpha-slider.transparent[data-v-18925ba6]{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.vc-alpha-slider__bar[data-v-18925ba6]{position:relative;width:100%;height:100%;border-radius:15px}
.vc-alpha-slider__bar-pointer[data-v-18925ba6]{position:absolute;width:14px;height:14px}
.vc-alpha-slider__bar-handle[data-v-18925ba6]{width:14px;height:14px;border-radius:6px;transform:translate(-7px,-2px);background-color:#f8f8f8;margin-top:2px;box-shadow:0 1px 4px #0000005e;cursor:pointer}
.vc-alpha-slider__bar-handle.vertical[data-v-18925ba6]{transform:translateY(-7px);margin-top:0}
.vc-alpha-slider.small-slider[data-v-18925ba6]{height:10px!important}
.vc-alpha-slider.small-slider .small-bar[data-v-18925ba6]{height:10px!important;width:10px!important}
.vc-alpha-slider.small-slider .small-bar div[data-v-18925ba6]{width:12px!important;height:12px!important;border-radius:5px!important;transform:translate(-6px,-2px);margin-top:1px!important}
.vc-compact[data-v-b969fd48]{margin-bottom:15px;width:auto;box-shadow:3px 0 5px #00000014;display:inline-block}
.vc-compact__row[data-v-b969fd48]{position:relative;width:100%;margin:0;height:27px}
.vc-compact__row>*[data-v-b969fd48]{display:inline-block;vertical-align:middle}
.vc-compact__color_cube[data-v-b969fd48]{width:100%;height:100%}
.vc-compact__color_cube.transparent[data-v-b969fd48]:before{content:"";position:absolute;top:0;left:0;width:100%;height:100%;background:white}
.vc-compact__color_cube.transparent[data-v-b969fd48]:after{content:"";position:absolute;top:100%;left:0;transform:rotate(-45deg);transform-origin:0 0;width:35px;height:1px;background:red}
.vc-compact__color_cube.advance[data-v-b969fd48]{background:url(${___CSS_LOADER_URL_REPLACEMENT_1___})}
.vc-compact__color_cube .alpha[data-v-b969fd48]{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.vc-compact__color-cube--wrap[data-v-b969fd48]{position:relative;width:27px;height:27px;cursor:pointer;overflow:hidden}
.vc-compact__color-cube--wrap[data-v-b969fd48]:hover{transform:scale(1.2);z-index:299;transition:transform .2s}
.vc-saturation[data-v-7f0cdcdf]{position:relative;margin-bottom:15px;width:100%;height:125px}
.vc-saturation__chrome[data-v-7f0cdcdf]{border-top-left-radius:5px;border-top-right-radius:5px;border-color:transparent}
.vc-saturation__hidden[data-v-7f0cdcdf]{overflow:hidden}
.vc-saturation__white[data-v-7f0cdcdf],.vc-saturation__black[data-v-7f0cdcdf]{position:absolute;top:0;left:0;right:0;bottom:0}
.vc-saturation__black[data-v-7f0cdcdf]{background:linear-gradient(0deg,#000,transparent)}
.vc-saturation__white[data-v-7f0cdcdf]{background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}
.vc-saturation__cursor[data-v-7f0cdcdf]{position:absolute}
.vc-saturation__cursor div[data-v-7f0cdcdf]{transform:translate(-5px,-5px);box-shadow:0 1px 4px #0000005e;width:10px;height:10px;border:1px solid white;border-radius:50%;cursor:pointer}
.vc-hue-slider[data-v-e1a08576]{position:relative;margin-bottom:15px;width:100%;height:14px;box-shadow:2px 0 8px #00000014;border-radius:15px}
.vc-hue-slider.is-vertical[data-v-e1a08576]{width:14px;height:100%;display:inline-block;transform:rotate(180deg)}
.vc-hue-slider.transparent[data-v-e1a08576]{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.vc-hue-slider__bar[data-v-e1a08576]{position:relative;width:100%;height:100%;border-radius:15px;background:linear-gradient(to right,rgb(255,0,0) 0%,rgb(255,255,0) 16.66%,rgb(0,255,0) 33.33%,rgb(0,255,255) 50%,rgb(0,0,255) 66.66%,rgb(255,0,255) 83.33%,rgb(255,0,0) 100%);background:-ms-linear-gradient(left,rgb(255,0,0) 0%,rgb(255,255,0) 16.66%,rgb(0,255,0) 33.33%,rgb(0,255,255) 50%,rgb(0,0,255) 66.66%,rgb(255,0,255) 83.33%,rgb(255,0,0) 100%)}
.vc-hue-slider__bar-pointer[data-v-e1a08576]{position:absolute;width:14px;height:14px}
.vc-hue-slider__bar-handle[data-v-e1a08576]{width:14px;height:14px;border-radius:6px;transform:translate(-7px,-2px);background-color:#f8f8f8;margin-top:2px;box-shadow:0 1px 4px #0000005e;cursor:pointer}
.vc-hue-slider__bar-handle.vertical[data-v-e1a08576]{transform:translateY(-7px);margin-top:0}
.vc-hue-slider.small-slider[data-v-e1a08576]{height:10px!important}
.vc-hue-slider.small-slider .small-bar[data-v-e1a08576]{height:10px!important;width:10px!important}
.vc-hue-slider.small-slider .small-bar div[data-v-e1a08576]{width:12px!important;height:12px!important;border-radius:5px!important;transform:translate(-6px,-2px);margin-top:1px!important}
.vc-lightness-slider[data-v-94a50a9e]{position:relative;margin-bottom:15px;width:100%;height:14px;box-shadow:2px 0 8px #00000014;border-radius:15px}
.vc-lightness-slider.is-vertical[data-v-94a50a9e]{width:14px;height:100%;display:inline-block;transform:rotate(180deg)}
.vc-lightness-slider.transparent[data-v-94a50a9e]{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.vc-lightness-slider__bar[data-v-94a50a9e]{position:relative;width:100%;height:100%;border-radius:15px}
.vc-lightness-slider__bar-pointer[data-v-94a50a9e]{position:absolute;width:14px;height:14px}
.vc-lightness-slider__bar-handle[data-v-94a50a9e]{width:14px;height:14px;border-radius:6px;transform:translate(-7px,-2px);background-color:#f8f8f8;margin-top:2px;box-shadow:0 1px 4px #0000005e;cursor:pointer}
.vc-lightness-slider__bar-handle.vertical[data-v-94a50a9e]{transform:translateY(-7px);margin-top:0}
.vc-lightness-slider.small-slider[data-v-94a50a9e]{height:10px!important}
.vc-lightness-slider.small-slider .small-bar[data-v-94a50a9e]{height:10px!important;width:10px!important}
.vc-lightness-slider.small-slider .small-bar div[data-v-94a50a9e]{width:12px!important;height:12px!important;border-radius:5px!important;transform:translate(-6px,-2px);margin-top:1px!important}
.vc-colorPicker__record[data-v-0f657238]{display:flex;align-items:center;margin-top:15px}
.vc-colorPicker__record .text[data-v-0f657238]{width:48px;margin-right:10px;text-align:right;font-size:12px;color:#666}
.vc-colorPicker__record .color-list[data-v-0f657238]{width:100%;display:flex;position:relative;margin:0;gap:2px}
.vc-colorPicker__record .color-list .color-item[data-v-0f657238]{position:relative;flex:1;max-width:26px;height:26px;border-radius:2px;cursor:pointer;overflow:hidden;display:inline-block;vertical-align:middle;box-shadow:3px 0 5px #0000001a}
.vc-colorPicker__record .color-list .color-item__round[data-v-0f657238]{border-radius:50%}
.vc-colorPicker__record .color-list .color-item.transparent[data-v-0f657238]{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.vc-colorPicker__record .color-list .color-item[data-v-0f657238]:hover{transform:scale(1.2);z-index:299;transition:transform .2s}
.vc-colorPicker__record .color-list .color-item__display[data-v-0f657238]{width:100%;height:100%}
.vc-display[data-v-7334ac20]{height:28px;display:flex;align-items:center;gap:8px}
.vc-display .vc-current-color[data-v-7334ac20]{width:50px;height:100%;box-shadow:3px 0 5px #00000014;border-radius:2px;position:relative;cursor:pointer;overflow:hidden;display:inline-block;vertical-align:middle}
.vc-display .vc-current-color.vc-transparent[data-v-7334ac20]{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.vc-display .vc-current-color .color-cube[data-v-7334ac20]{width:100%;height:100%;text-align:center}
.vc-display .vc-color-input[data-v-7334ac20]{height:100%;flex:1;flex-shrink:0;box-sizing:border-box;position:relative}
.vc-display .vc-color-input input[data-v-7334ac20]{padding:0;border:0;outline:none;cursor:pointer;font-size:14px;text-align:center;box-sizing:border-box;background-color:#c8c8c840;color:#666;border-radius:2px;height:100%;width:100%}
.vc-display .vc-rgb-input[data-v-7334ac20]{flex:1;font-size:12px;color:#666;text-align:center}
.vc-display .vc-rgb-input input[data-v-7334ac20]{padding:4px 0;margin-bottom:2px;border:0;outline:none;cursor:pointer;font-size:14px;text-align:center;background-color:#c8c8c840;color:#666;border-radius:2px;width:100%}
.vc-display .vc-alpha-input[data-v-7334ac20]{width:48px;height:100%;border:none;display:flex;justify-content:center;align-items:center;border-radius:2px;font-size:14px;background-color:#c8c8c840;padding:0 2px}
.vc-display .vc-alpha-input>input[data-v-7334ac20]{width:100%;height:100%;padding:0;text-align:center;background-color:transparent;font-size:inherit}
.vc-display .vc-alpha-input__inner[data-v-7334ac20]{padding:10px 12px;border-radius:4px;color:#000;font-size:14px;line-height:20px;outline:none;border:none;display:block;box-sizing:border-box;cursor:pointer}
.vc-display .vc-input-toggle[data-v-7334ac20]{cursor:pointer;font-size:12px;line-height:12px;width:24px;border-radius:4px;padding:2px}
.vc-display .vc-input-toggle[data-v-7334ac20]:hover{background-color:#efefef}
.vc-display .vc-input-toggle[data-v-7334ac20]:before{height:0;width:0;margin:auto auto 2px;content:"";display:block;border-bottom:4px solid #888;border-left:4px solid transparent;border-right:4px solid transparent}
.vc-display .vc-input-toggle[data-v-7334ac20]:after{height:0;width:0;margin:2px auto auto;content:"";display:block;border-top:4px solid #888;border-left:4px solid transparent;border-right:4px solid transparent}
.vc-display .copy-text[data-v-7334ac20]{font-size:12px;line-height:28px;text-align:center;transform:scale(.8);display:inline-block}
.vc-fk-colorPicker[data-v-48e3c224]{position:relative;box-sizing:border-box;border-radius:3px;-webkit-user-select:none;user-select:none;background-color:initial}
.vc-fk-colorPicker__inner[data-v-48e3c224]{position:relative}
.vc-fk-colorPicker__header[data-v-48e3c224]{z-index:999;text-align:left}
.vc-fk-colorPicker__header .back[data-v-48e3c224]{border:2px solid rgba(150,150,150,.6);border-width:0 2px 2px 0;display:inline-block;padding:4px;margin-left:2px;margin-bottom:12px;transform:rotate(135deg)}
.vc-fk-colorPicker__display[data-v-48e3c224]{position:relative;width:100%;margin:0;text-align:left}
.vc-fk-colorPicker__display .transparent[data-v-48e3c224]{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.vc-fk-colorPicker__display .current-color[data-v-48e3c224]{margin-right:10px;width:50px;height:24px;box-shadow:3px 0 5px #00000014;position:relative;cursor:pointer;overflow:hidden;display:inline-block;vertical-align:middle}
.vc-fk-colorPicker__display .current-color .color-cube[data-v-48e3c224]{width:100%;height:100%}
.vc-fk-colorPicker__display .hexColor-prefix[data-v-48e3c224]{position:relative;padding:0 4px;font-size:14px;display:inline-block;vertical-align:middle}
.vc-fk-colorPicker__display input[data-v-48e3c224]{width:25px;text-align:center;outline:0;border-top:0;border-right:0;border-left:none;display:inline-block;vertical-align:middle;padding-bottom:3px;border-bottom:1px solid #e3e2e8}
.vc-fk-colorPicker__display .hexColor-input[data-v-48e3c224]{width:64px}
.vc-fk-colorPicker__display .action[data-v-48e3c224]{float:right;vertical-align:middle}
.vc-fk-colorPicker__display .action .clear-btn[data-v-48e3c224]{border-color:transparent;color:#409eff;background:transparent;padding-left:0;padding-right:0;display:inline-block;vertical-align:middle;cursor:pointer}
.vc-fk-colorPicker__display .action .copy-btn[data-v-48e3c224]{border-color:transparent;color:#13ce66cc;background:transparent;padding-left:0;padding-right:0;display:inline-block;margin-left:10px;vertical-align:middle;cursor:pointer}
.vc-chrome-colorPicker[data-v-2611d66c]{position:relative;box-sizing:border-box;border-radius:3px;-webkit-user-select:none;user-select:none;background-color:initial}
.vc-chrome-colorPicker-body[data-v-2611d66c]{position:relative}
.vc-chrome-colorPicker-body .chrome-controls[data-v-2611d66c]{display:flex}
.vc-chrome-colorPicker-body .chrome-controls .chrome-color-wrap[data-v-2611d66c]{position:relative;width:36px;height:36px;border-radius:50%;overflow:hidden;z-index:1}
.vc-chrome-colorPicker-body .chrome-controls .chrome-color-wrap.transparent[data-v-2611d66c]{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.vc-chrome-colorPicker-body .chrome-controls .chrome-color-wrap .current-color[data-v-2611d66c]{width:100%;height:100%}
.vc-chrome-colorPicker-body .chrome-controls .chrome-sliders[data-v-2611d66c]{flex:1;margin-left:10px}
.bee-angle{transform:rotate(90deg)}
.bee-angle>*{display:inline-block;vertical-align:middle}
.bee-angle.zero-right{transform:rotate(180deg)}
.bee-angle.zero-bottom{transform:rotate(270deg)}
.bee-angle__round{position:relative;width:16px;height:16px;border:1px solid #666;border-radius:50%;cursor:pointer;display:inline-block;vertical-align:middle}
.bee-angle__round:before{content:"";position:absolute;top:50%;left:0;transform:translateY(-50%);width:50%;height:1px;background-color:#666}
.vc-gradient-picker[data-v-c4d6d6ea]{position:relative}
.vc-gradient-picker__header[data-v-c4d6d6ea]{margin-bottom:12px;z-index:999;text-align:left;display:flex;justify-content:space-between;align-items:center}
.vc-gradient-picker__header .back[data-v-c4d6d6ea]{border:2px solid rgba(150,150,150,.65);border-width:0 2px 2px 0;display:inline-block;padding:4px;margin-left:2px;transform:rotate(135deg);margin-right:8px}
.vc-gradient-picker .vc-gradient__types[data-v-c4d6d6ea]{display:flex;width:100%;justify-content:space-between}
.vc-gradient-picker .vc-gradient__types .vc-gradient-wrap__types[data-v-c4d6d6ea]{display:flex;background-color:#c8c8c840;border-radius:4px;overflow:hidden;align-items:center}
.vc-gradient-picker .vc-gradient__types .vc-gradient__type[data-v-c4d6d6ea]{padding:4px 8px;color:#666;cursor:pointer;font-size:12px}
.vc-gradient-picker .vc-gradient__types .vc-gradient__type.active[data-v-c4d6d6ea]{color:#000;background-color:#c8c8c8cc}
.vc-gradient-picker__body[data-v-c4d6d6ea]{margin-bottom:12px;display:flex;align-items:center}
.vc-gradient-picker__body .vc-color-range[data-v-c4d6d6ea]{flex:1}
.vc-gradient-picker__body .vc-color-range__container[data-v-c4d6d6ea]{position:relative;height:16px;border-radius:5px}
.vc-gradient-picker__body .vc-color-range__container .vc-background[data-v-c4d6d6ea]{height:100%;border-radius:4px;box-shadow:inset 0 0 0 1px #0000000f}
.vc-gradient-picker__body .vc-color-range__container .vc-gradient__stop__container[data-v-c4d6d6ea]{position:absolute;width:100%;top:0;height:100%;left:0}
.vc-gradient-picker__body .vc-color-range__container .vc-gradient__stop__container .vc-gradient__stop[data-v-c4d6d6ea]{position:absolute;top:-2px;width:14px;height:16px;overflow:hidden;border:2px solid #fff;border-radius:2px;cursor:pointer;box-shadow:0 0 2px 1px #00000059;box-sizing:content-box;transform:translate(-9px)}
.vc-gradient-picker__body .vc-color-range__container .vc-gradient__stop__container .vc-gradient__stop--inner[data-v-c4d6d6ea]{display:inline-block;height:100%}
.vc-gradient-picker__body .vc-color-range__container .vc-gradient__stop__container .vc-gradient__stop--current[data-v-c4d6d6ea]{position:relative;z-index:1;box-shadow:0 0 2px 2px #2253f4,0 0 1px 1px #2253f480}
.vc-gradient-picker .vc-degree-input[data-v-c4d6d6ea]{position:relative;z-index:2;font-size:12px;border-radius:4px;display:flex}
.vc-gradient-picker .vc-degree-input:hover .vc-degree-input__panel[data-v-c4d6d6ea]{display:block}
.vc-gradient-picker .vc-degree-input__control[data-v-c4d6d6ea]{width:100%;height:100%;display:flex;justify-content:center;align-items:center;border-radius:4px;background-color:#c8c8c840;color:#666;padding:0 6px 0 0}
.vc-gradient-picker .vc-degree-input__control input[data-v-c4d6d6ea]{max-width:28px;text-align:center;border:none;outline:none;background-color:transparent;color:#666;font-size:inherit;overflow:visible}
.vc-gradient-picker .vc-degree-input__panel[data-v-c4d6d6ea]{display:none;z-index:10;position:absolute;top:20px;left:0}
.vc-gradient-picker .vc-degree-input__panel .vc-degree-input__disk[data-v-c4d6d6ea]{padding:4px;background-color:#f1f1f1;box-shadow:0 0 2px #00000029,0 1px 8px #0000000f,0 4px 12px #00000014;border-radius:4px;display:flex;justify-content:center;align-items:center;position:relative;transform:translate(0)}
.vc-gradient-picker .vc-picker-degree-input[data-v-c4d6d6ea]{margin-left:8px}
.vc-colorpicker[data-v-0492277d]{position:relative;box-sizing:border-box;border-radius:3px;box-shadow:0 0 10px #00000026;-webkit-user-select:none;user-select:none;width:276px;z-index:10000}
.vc-colorpicker *[data-v-0492277d]{outline:none;line-height:1}
.vc-colorpicker--container[data-v-0492277d]{padding:16px}
.vc-colorpicker--tabs[data-v-0492277d]{padding:2px;background:#f6f7f9;border-radius:6px;position:relative;margin-bottom:12px}
.vc-colorpicker--tabs__inner[data-v-0492277d]{display:flex;justify-content:space-between;padding:0;background:#f6f7f9;border-bottom:none;position:relative;box-sizing:border-box}
.vc-colorpicker--tabs__btn[data-v-0492277d]{flex:1;z-index:2;color:#636c78;font-size:14px;border-radius:4px;cursor:pointer}
.vc-colorpicker--tabs__btn.vc-btn-active[data-v-0492277d]{color:#33383e;font-weight:600}
.vc-colorpicker--tabs__btn button[data-v-0492277d]{width:100%;background-color:initial;padding:6px 0;font-size:14px;line-height:20px;color:#636c78;border:0;border-radius:0;outline:0;cursor:pointer;appearance:none;-webkit-appearance:none;font-weight:inherit}
.vc-colorpicker--tabs__btn button .vc-btn__content[data-v-0492277d]{position:relative;white-space:nowrap}
.vc-colorpicker--tabs__bg[data-v-0492277d]{position:absolute;top:0;bottom:0;background:#fff;box-shadow:0 1px 4px #0000001f;border-radius:4px;z-index:1;transition:left .2s ease-in-out}
.vc-colorpicker.black[data-v-0492277d]{background-color:#000;color:#fff}
.vc-colorpicker.white[data-v-0492277d]{background-color:#fff;color:#333}
.vc-color-wrap[data-v-354ca836]{margin-right:10px;width:50px;height:24px;box-shadow:3px 0 5px #00000014;position:relative;cursor:pointer;overflow:hidden;display:inline-block;vertical-align:middle}
.vc-color-wrap.transparent[data-v-354ca836]{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat:repeat}
.vc-color-wrap.round[data-v-354ca836]{width:22px;height:22px;border-radius:50%;border:1px solid #d8d8d8}
.vc-color-wrap .current-color[data-v-354ca836]{width:100%;height:100%}
.vc-color-extra[data-v-354ca836]{margin-top:10px}
.tox {
  box-shadow: none;
  box-sizing: content-box;
  color: #222f3e;
  cursor: auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  -webkit-tap-highlight-color: transparent;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  vertical-align: initial;
  white-space: normal;
}
.tox *:not(svg):not(rect) {
  box-sizing: inherit;
  color: inherit;
  cursor: inherit;
  direction: inherit;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
  -webkit-tap-highlight-color: inherit;
  text-align: inherit;
  text-decoration: inherit;
  text-shadow: inherit;
  text-transform: inherit;
  vertical-align: inherit;
  white-space: inherit;
}
.tox *:not(svg):not(rect) {
  /* stylelint-disable-line no-duplicate-selectors */
  background: transparent;
  border: 0;
  box-shadow: none;
  float: none;
  height: auto;
  margin: 0;
  max-width: none;
  outline: 0;
  padding: 0;
  position: static;
  width: auto;
}
.tox:not([dir=rtl]) {
  direction: ltr;
  text-align: left;
}
.tox[dir=rtl] {
  direction: rtl;
  text-align: right;
}
.tox-tinymce {
  border: 2px solid #eeeeee;
  border-radius: 10px;
  box-shadow: none;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  overflow: hidden;
  position: relative;
  visibility: inherit !important;
}
.tox.tox-tinymce-inline {
  border: none;
  box-shadow: none;
  overflow: initial;
}
.tox.tox-tinymce-inline .tox-editor-container {
  overflow: initial;
}
.tox.tox-tinymce-inline .tox-editor-header {
  background-color: #fff;
  border: 2px solid #eeeeee;
  border-radius: 10px;
  box-shadow: none;
  overflow: hidden;
}
.tox-tinymce-aux {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  z-index: 1300;
}
.tox-tinymce *:focus,
.tox-tinymce-aux *:focus {
  outline: none;
}
button::-moz-focus-inner {
  border: 0;
}
.tox[dir=rtl] .tox-icon--flip svg {
  transform: rotateY(180deg);
}
.tox .accessibility-issue__header {
  align-items: center;
  display: flex;
  margin-bottom: 4px;
}
.tox .accessibility-issue__description {
  align-items: stretch;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
}
.tox .accessibility-issue__description > div {
  padding-bottom: 4px;
}
.tox .accessibility-issue__description > div > div {
  align-items: center;
  display: flex;
  margin-bottom: 4px;
}
.tox .accessibility-issue__description > div > div .tox-icon svg {
  display: block;
}
.tox .accessibility-issue__repair {
  margin-top: 16px;
}
.tox .tox-dialog__body-content .accessibility-issue--info .accessibility-issue__description {
  background-color: rgba(0, 101, 216, 0.1);
  color: #222f3e;
}
.tox .tox-dialog__body-content .accessibility-issue--info .tox-form__group h2 {
  color: #006ce7;
}
.tox .tox-dialog__body-content .accessibility-issue--info .tox-icon svg {
  fill: #006ce7;
}
.tox .tox-dialog__body-content .accessibility-issue--info a.tox-button--naked.tox-button--icon {
  background-color: #006ce7;
  color: #fff;
}
.tox .tox-dialog__body-content .accessibility-issue--info a.tox-button--naked.tox-button--icon:hover,
.tox .tox-dialog__body-content .accessibility-issue--info a.tox-button--naked.tox-button--icon:focus {
  background-color: #0060ce;
}
.tox .tox-dialog__body-content .accessibility-issue--info a.tox-button--naked.tox-button--icon:active {
  background-color: #0054b4;
}
.tox .tox-dialog__body-content .accessibility-issue--warn {
  /* stylelint-disable-next-line no-descending-specificity */
}
.tox .tox-dialog__body-content .accessibility-issue--warn .accessibility-issue__description {
  background-color: rgba(255, 165, 0, 0.08);
  color: #222f3e;
}
.tox .tox-dialog__body-content .accessibility-issue--warn .tox-form__group h2 {
  color: #8f5d00;
}
.tox .tox-dialog__body-content .accessibility-issue--warn .tox-icon svg {
  fill: #8f5d00;
}
.tox .tox-dialog__body-content .accessibility-issue--warn a.tox-button--naked.tox-button--icon {
  background-color: #FFE89D;
  color: #222f3e;
}
.tox .tox-dialog__body-content .accessibility-issue--warn a.tox-button--naked.tox-button--icon:hover,
.tox .tox-dialog__body-content .accessibility-issue--warn a.tox-button--naked.tox-button--icon:focus {
  background-color: #F2D574;
  color: #222f3e;
}
.tox .tox-dialog__body-content .accessibility-issue--warn a.tox-button--naked.tox-button--icon:active {
  background-color: #E8C657;
  color: #222f3e;
}
.tox .tox-dialog__body-content .accessibility-issue--error {
  /* stylelint-disable-next-line no-descending-specificity */
}
.tox .tox-dialog__body-content .accessibility-issue--error .accessibility-issue__description {
  background-color: rgba(204, 0, 0, 0.1);
  color: #222f3e;
}
.tox .tox-dialog__body-content .accessibility-issue--error .tox-form__group h2 {
  color: #c00;
}
.tox .tox-dialog__body-content .accessibility-issue--error .tox-icon svg {
  fill: #c00;
}
.tox .tox-dialog__body-content .accessibility-issue--error a.tox-button--naked.tox-button--icon {
  background-color: #F2BFBF;
  color: #222f3e;
}
.tox .tox-dialog__body-content .accessibility-issue--error a.tox-button--naked.tox-button--icon:hover,
.tox .tox-dialog__body-content .accessibility-issue--error a.tox-button--naked.tox-button--icon:focus {
  background-color: #E9A4A4;
  color: #222f3e;
}
.tox .tox-dialog__body-content .accessibility-issue--error a.tox-button--naked.tox-button--icon:active {
  background-color: #EE9494;
  color: #222f3e;
}
.tox .tox-dialog__body-content .accessibility-issue--success .accessibility-issue__description {
  background-color: rgba(120, 171, 70, 0.1);
  color: #222f3e;
}
.tox .tox-dialog__body-content .accessibility-issue--success .accessibility-issue__description > *:last-child {
  display: none;
}
.tox .tox-dialog__body-content .accessibility-issue--success .tox-form__group h2 {
  color: #527530;
}
.tox .tox-dialog__body-content .accessibility-issue--success .tox-icon svg {
  fill: #527530;
}
.tox .tox-dialog__body-content .accessibility-issue__header .tox-form__group h1,
.tox .tox-dialog__body-content .tox-form__group .accessibility-issue__description h2 {
  font-size: 14px;
  margin-top: 0;
}
.tox:not([dir=rtl]) .tox-dialog__body-content .accessibility-issue__header .tox-button {
  margin-left: 4px;
}
.tox:not([dir=rtl]) .tox-dialog__body-content .accessibility-issue__header > *:nth-last-child(2) {
  margin-left: auto;
}
.tox:not([dir=rtl]) .tox-dialog__body-content .accessibility-issue__description {
  padding: 4px 4px 4px 8px;
}
.tox[dir=rtl] .tox-dialog__body-content .accessibility-issue__header .tox-button {
  margin-right: 4px;
}
.tox[dir=rtl] .tox-dialog__body-content .accessibility-issue__header > *:nth-last-child(2) {
  margin-right: auto;
}
.tox[dir=rtl] .tox-dialog__body-content .accessibility-issue__description {
  padding: 4px 8px 4px 4px;
}
.tox .tox-advtemplate .tox-form__grid {
  flex: 1;
}
.tox .tox-advtemplate .tox-form__grid > div:first-child {
  display: flex;
  flex-direction: column;
  width: 30%;
}
.tox .tox-advtemplate .tox-form__grid > div:first-child > div:nth-child(2) {
  flex-basis: 0;
  flex-grow: 1;
  overflow: auto;
}
@media only screen and (max-width: 767px ) {
  body:not(.tox-force-desktop) .tox .tox-advtemplate .tox-form__grid > div:first-child {
    width: 100%;
  }
}
.tox .tox-advtemplate iframe {
  border-color: #eeeeee;
  border-radius: 10px;
  border-style: solid;
  border-width: 1px;
  margin: 0 10px;
}
.tox .tox-anchorbar {
  display: flex;
  flex: 0 0 auto;
}
.tox .tox-bottom-anchorbar {
  display: flex;
  flex: 0 0 auto;
}
.tox .tox-bar {
  display: flex;
  flex: 0 0 auto;
}
.tox .tox-button {
  background-color: #006ce7;
  background-image: none;
  background-position: 0 0;
  background-repeat: repeat;
  border-color: #006ce7;
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: normal;
  line-height: 24px;
  margin: 0;
  outline: none;
  padding: 4px 16px;
  position: relative;
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-transform: none;
  white-space: nowrap;
}
.tox .tox-button::before {
  border-radius: 6px;
  bottom: -1px;
  box-shadow: inset 0 0 0 2px #fff, 0 0 0 1px #006ce7, 0 0 0 3px rgba(0, 108, 231, 0.25);
  content: '';
  left: -1px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
}
.tox .tox-button[disabled] {
  background-color: #006ce7;
  background-image: none;
  border-color: #006ce7;
  box-shadow: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
}
.tox .tox-button:focus:not(:disabled) {
  background-color: #0060ce;
  background-image: none;
  border-color: #0060ce;
  box-shadow: none;
  color: #fff;
}
.tox .tox-button:focus-visible:not(:disabled)::before {
  opacity: 1;
}
.tox .tox-button:hover:not(:disabled) {
  background-color: #0060ce;
  background-image: none;
  border-color: #0060ce;
  box-shadow: none;
  color: #fff;
}
.tox .tox-button:active:not(:disabled) {
  background-color: #0054b4;
  background-image: none;
  border-color: #0054b4;
  box-shadow: none;
  color: #fff;
}
.tox .tox-button.tox-button--enabled {
  background-color: #0054b4;
  background-image: none;
  border-color: #0054b4;
  box-shadow: none;
  color: #fff;
}
.tox .tox-button.tox-button--enabled[disabled] {
  background-color: #0054b4;
  background-image: none;
  border-color: #0054b4;
  box-shadow: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
}
.tox .tox-button.tox-button--enabled:focus:not(:disabled) {
  background-color: #00489b;
  background-image: none;
  border-color: #00489b;
  box-shadow: none;
  color: #fff;
}
.tox .tox-button.tox-button--enabled:hover:not(:disabled) {
  background-color: #00489b;
  background-image: none;
  border-color: #00489b;
  box-shadow: none;
  color: #fff;
}
.tox .tox-button.tox-button--enabled:active:not(:disabled) {
  background-color: #003c81;
  background-image: none;
  border-color: #003c81;
  box-shadow: none;
  color: #fff;
}
.tox .tox-button--icon-and-text,
.tox .tox-button.tox-button--icon-and-text,
.tox .tox-button.tox-button--secondary.tox-button--icon-and-text {
  display: flex;
  padding: 5px 4px;
}
.tox .tox-button--icon-and-text .tox-icon svg,
.tox .tox-button.tox-button--icon-and-text .tox-icon svg,
.tox .tox-button.tox-button--secondary.tox-button--icon-and-text .tox-icon svg {
  display: block;
  fill: currentColor;
}
.tox .tox-button--secondary {
  background-color: #f0f0f0;
  background-image: none;
  background-position: 0 0;
  background-repeat: repeat;
  border-color: #f0f0f0;
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  color: #222f3e;
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: normal;
  outline: none;
  padding: 4px 16px;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-transform: none;
}
.tox .tox-button--secondary[disabled] {
  background-color: #f0f0f0;
  background-image: none;
  border-color: #f0f0f0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
}
.tox .tox-button--secondary:focus:not(:disabled) {
  background-color: #e3e3e3;
  background-image: none;
  border-color: #e3e3e3;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--secondary:hover:not(:disabled) {
  background-color: #e3e3e3;
  background-image: none;
  border-color: #e3e3e3;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--secondary:active:not(:disabled) {
  background-color: #d6d6d6;
  background-image: none;
  border-color: #d6d6d6;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--secondary.tox-button--enabled {
  background-color: #a8c8ed;
  background-image: none;
  border-color: #a8c8ed;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--secondary.tox-button--enabled[disabled] {
  background-color: #a8c8ed;
  background-image: none;
  border-color: #a8c8ed;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
}
.tox .tox-button--secondary.tox-button--enabled:focus:not(:disabled) {
  background-color: #93bbe9;
  background-image: none;
  border-color: #93bbe9;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--secondary.tox-button--enabled:hover:not(:disabled) {
  background-color: #93bbe9;
  background-image: none;
  border-color: #93bbe9;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--secondary.tox-button--enabled:active:not(:disabled) {
  background-color: #7daee4;
  background-image: none;
  border-color: #7daee4;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-button--icon,
.tox .tox-button.tox-button--icon,
.tox .tox-button.tox-button--secondary.tox-button--icon {
  padding: 4px;
}
.tox .tox-button--icon .tox-icon svg,
.tox .tox-button.tox-button--icon .tox-icon svg,
.tox .tox-button.tox-button--secondary.tox-button--icon .tox-icon svg {
  display: block;
  fill: currentColor;
}
.tox .tox-button-link {
  background: 0;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.3;
  margin: 0;
  padding: 0;
  white-space: nowrap;
}
.tox .tox-button-link--sm {
  font-size: 14px;
}
.tox .tox-button--naked {
  background-color: transparent;
  border-color: transparent;
  box-shadow: unset;
  color: #222f3e;
}
.tox .tox-button--naked[disabled] {
  background-color: rgba(34, 47, 62, 0.12);
  border-color: transparent;
  box-shadow: unset;
  color: rgba(34, 47, 62, 0.5);
}
.tox .tox-button--naked:hover:not(:disabled) {
  background-color: rgba(34, 47, 62, 0.12);
  border-color: transparent;
  box-shadow: unset;
  color: #222f3e;
}
.tox .tox-button--naked:focus:not(:disabled) {
  background-color: rgba(34, 47, 62, 0.12);
  border-color: transparent;
  box-shadow: unset;
  color: #222f3e;
}
.tox .tox-button--naked:active:not(:disabled) {
  background-color: rgba(34, 47, 62, 0.18);
  border-color: transparent;
  box-shadow: unset;
  color: #222f3e;
}
.tox .tox-button--naked .tox-icon svg {
  fill: currentColor;
}
.tox .tox-button--naked.tox-button--icon:hover:not(:disabled) {
  color: #222f3e;
}
.tox .tox-checkbox {
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  height: 36px;
  min-width: 36px;
}
.tox .tox-checkbox__input {
  /* Hide from view but visible to screen readers */
  height: 1px;
  overflow: hidden;
  position: absolute;
  top: auto;
  width: 1px;
}
.tox .tox-checkbox__icons {
  align-items: center;
  border-radius: 6px;
  box-shadow: 0 0 0 2px transparent;
  box-sizing: content-box;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: calc(4px - 1px);
  width: 24px;
}
.tox .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {
  display: block;
  fill: rgba(34, 47, 62, 0.3);
}
.tox .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {
  display: none;
  fill: #006ce7;
}
.tox .tox-checkbox__icons .tox-checkbox-icon__checked svg {
  display: none;
  fill: #006ce7;
}
.tox .tox-checkbox--disabled {
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__checked svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox input.tox-checkbox__input:checked + .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {
  display: none;
}
.tox input.tox-checkbox__input:checked + .tox-checkbox__icons .tox-checkbox-icon__checked svg {
  display: block;
}
.tox input.tox-checkbox__input:indeterminate + .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {
  display: none;
}
.tox input.tox-checkbox__input:indeterminate + .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {
  display: block;
}
.tox input.tox-checkbox__input:focus + .tox-checkbox__icons {
  border-radius: 6px;
  box-shadow: inset 0 0 0 1px #006ce7;
  padding: calc(4px - 1px);
}
.tox:not([dir=rtl]) .tox-checkbox__label {
  margin-left: 4px;
}
.tox:not([dir=rtl]) .tox-checkbox__input {
  left: -10000px;
}
.tox:not([dir=rtl]) .tox-bar .tox-checkbox {
  margin-left: 4px;
}
.tox[dir=rtl] .tox-checkbox__label {
  margin-right: 4px;
}
.tox[dir=rtl] .tox-checkbox__input {
  right: -10000px;
}
.tox[dir=rtl] .tox-bar .tox-checkbox {
  margin-right: 4px;
}
.tox {
  /* stylelint-disable-next-line no-descending-specificity */
}
.tox .tox-collection--toolbar .tox-collection__group {
  display: flex;
  padding: 0;
}
.tox .tox-collection--grid .tox-collection__group {
  display: flex;
  flex-wrap: wrap;
  max-height: 208px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0;
}
.tox .tox-collection--list .tox-collection__group {
  border-bottom-width: 0;
  border-color: #e3e3e3;
  border-left-width: 0;
  border-right-width: 0;
  border-style: solid;
  border-top-width: 1px;
  padding: 4px 0;
}
.tox .tox-collection--list .tox-collection__group:first-child {
  border-top-width: 0;
}
.tox .tox-collection__group-heading {
  background-color: #fcfcfc;
  color: rgba(34, 47, 62, 0.7);
  cursor: default;
  font-size: 12px;
  font-style: normal;
  font-weight: normal;
  margin-bottom: 4px;
  margin-top: -4px;
  padding: 4px 8px;
  text-transform: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}
.tox .tox-collection__item {
  align-items: center;
  border-radius: 3px;
  color: #222f3e;
  display: flex;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}
.tox .tox-collection--list .tox-collection__item {
  padding: 4px 8px;
}
.tox .tox-collection--toolbar .tox-collection__item {
  border-radius: 3px;
  padding: 4px;
}
.tox .tox-collection--grid .tox-collection__item {
  border-radius: 3px;
  padding: 4px;
}
.tox .tox-collection--list .tox-collection__item--enabled {
  background-color: #fff;
  color: #222f3e;
}
.tox .tox-collection--list .tox-collection__item--active {
  background-color: #cce2fa;
}
.tox .tox-collection--toolbar .tox-collection__item--enabled {
  background-color: #a6ccf7;
  color: #222f3e;
}
.tox .tox-collection--toolbar .tox-collection__item--active {
  background-color: #cce2fa;
}
.tox .tox-collection--grid .tox-collection__item--enabled {
  background-color: #a6ccf7;
  color: #222f3e;
}
.tox .tox-collection--grid .tox-collection__item--active:not(.tox-collection__item--state-disabled) {
  background-color: #cce2fa;
  color: #222f3e;
}
.tox .tox-collection--list .tox-collection__item--active:not(.tox-collection__item--state-disabled) {
  color: #222f3e;
}
.tox .tox-collection--toolbar .tox-collection__item--active:not(.tox-collection__item--state-disabled) {
  color: #222f3e;
}
.tox .tox-collection__item-icon,
.tox .tox-collection__item-checkmark {
  align-items: center;
  display: flex;
  height: 24px;
  justify-content: center;
  width: 24px;
}
.tox .tox-collection__item-icon svg,
.tox .tox-collection__item-checkmark svg {
  fill: currentColor;
}
.tox .tox-collection--toolbar-lg .tox-collection__item-icon {
  height: 48px;
  width: 48px;
}
.tox .tox-collection__item-label {
  color: currentColor;
  display: inline-block;
  flex: 1;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  max-width: 100%;
  text-transform: none;
  word-break: break-all;
}
.tox .tox-collection__item-accessory {
  color: rgba(34, 47, 62, 0.7);
  display: inline-block;
  font-size: 14px;
  height: 24px;
  line-height: 24px;
  text-transform: none;
}
.tox .tox-collection__item-caret {
  align-items: center;
  display: flex;
  min-height: 24px;
}
.tox .tox-collection__item-caret::after {
  content: '';
  font-size: 0;
  min-height: inherit;
}
.tox .tox-collection__item-caret svg {
  fill: #222f3e;
}
.tox .tox-collection__item--state-disabled {
  background-color: transparent;
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox .tox-collection__item--state-disabled .tox-collection__item-caret svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-collection--list .tox-collection__item:not(.tox-collection__item--enabled) .tox-collection__item-checkmark svg {
  display: none;
}
.tox .tox-collection--list .tox-collection__item:not(.tox-collection__item--enabled) .tox-collection__item-accessory + .tox-collection__item-checkmark {
  display: none;
}
.tox .tox-collection--horizontal {
  background-color: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  box-shadow: 0 0 2px 0 rgba(34, 47, 62, 0.2), 0 4px 8px 0 rgba(34, 47, 62, 0.15);
  display: flex;
  flex: 0 0 auto;
  flex-shrink: 0;
  flex-wrap: nowrap;
  margin-bottom: 0;
  overflow-x: auto;
  padding: 0;
}
.tox .tox-collection--horizontal .tox-collection__group {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0 4px;
}
.tox .tox-collection--horizontal .tox-collection__item {
  height: 28px;
  margin: 6px 1px 5px 0;
  padding: 0 4px;
}
.tox .tox-collection--horizontal .tox-collection__item-label {
  white-space: nowrap;
}
.tox .tox-collection--horizontal .tox-collection__item-caret {
  margin-left: 4px;
}
.tox .tox-collection__item-container {
  display: flex;
}
.tox .tox-collection__item-container--row {
  align-items: center;
  flex: 1 1 auto;
  flex-direction: row;
}
.tox .tox-collection__item-container--row.tox-collection__item-container--align-left {
  margin-right: auto;
}
.tox .tox-collection__item-container--row.tox-collection__item-container--align-right {
  justify-content: flex-end;
  margin-left: auto;
}
.tox .tox-collection__item-container--row.tox-collection__item-container--valign-top {
  align-items: flex-start;
  margin-bottom: auto;
}
.tox .tox-collection__item-container--row.tox-collection__item-container--valign-middle {
  align-items: center;
}
.tox .tox-collection__item-container--row.tox-collection__item-container--valign-bottom {
  align-items: flex-end;
  margin-top: auto;
}
.tox .tox-collection__item-container--column {
  align-self: center;
  flex: 1 1 auto;
  flex-direction: column;
}
.tox .tox-collection__item-container--column.tox-collection__item-container--align-left {
  align-items: flex-start;
}
.tox .tox-collection__item-container--column.tox-collection__item-container--align-right {
  align-items: flex-end;
}
.tox .tox-collection__item-container--column.tox-collection__item-container--valign-top {
  align-self: flex-start;
}
.tox .tox-collection__item-container--column.tox-collection__item-container--valign-middle {
  align-self: center;
}
.tox .tox-collection__item-container--column.tox-collection__item-container--valign-bottom {
  align-self: flex-end;
}
.tox:not([dir=rtl]) .tox-collection--horizontal .tox-collection__group:not(:last-of-type) {
  border-right: 1px solid transparent;
}
.tox:not([dir=rtl]) .tox-collection--list .tox-collection__item > *:not(:first-child) {
  margin-left: 8px;
}
.tox:not([dir=rtl]) .tox-collection--list .tox-collection__item > .tox-collection__item-label:first-child {
  margin-left: 4px;
}
.tox:not([dir=rtl]) .tox-collection__item-accessory {
  margin-left: 16px;
  text-align: right;
}
.tox:not([dir=rtl]) .tox-collection .tox-collection__item-caret {
  margin-left: 16px;
}
.tox[dir=rtl] .tox-collection--horizontal .tox-collection__group:not(:last-of-type) {
  border-left: 1px solid transparent;
}
.tox[dir=rtl] .tox-collection--list .tox-collection__item > *:not(:first-child) {
  margin-right: 8px;
}
.tox[dir=rtl] .tox-collection--list .tox-collection__item > .tox-collection__item-label:first-child {
  margin-right: 4px;
}
.tox[dir=rtl] .tox-collection__item-accessory {
  margin-right: 16px;
  text-align: left;
}
.tox[dir=rtl] .tox-collection .tox-collection__item-caret {
  margin-right: 16px;
  transform: rotateY(180deg);
}
.tox[dir=rtl] .tox-collection--horizontal .tox-collection__item-caret {
  margin-right: 4px;
}
.tox .tox-color-picker-container {
  display: flex;
  flex-direction: row;
  height: 225px;
  margin: 0;
}
.tox .tox-sv-palette {
  box-sizing: border-box;
  display: flex;
  height: 100%;
}
.tox .tox-sv-palette-spectrum {
  height: 100%;
}
.tox .tox-sv-palette,
.tox .tox-sv-palette-spectrum {
  width: 225px;
}
.tox .tox-sv-palette-thumb {
  background: none;
  border: 1px solid black;
  border-radius: 50%;
  box-sizing: content-box;
  height: 12px;
  position: absolute;
  width: 12px;
}
.tox .tox-sv-palette-inner-thumb {
  border: 1px solid white;
  border-radius: 50%;
  height: 10px;
  position: absolute;
  width: 10px;
}
.tox .tox-hue-slider {
  box-sizing: border-box;
  height: 100%;
  width: 25px;
}
.tox .tox-hue-slider-spectrum {
  background: linear-gradient(to bottom, #f00, #ff0080, #f0f, #8000ff, #00f, #0080ff, #0ff, #00ff80, #0f0, #80ff00, #ff0, #ff8000, #f00);
  height: 100%;
  width: 100%;
}
.tox .tox-hue-slider,
.tox .tox-hue-slider-spectrum {
  width: 20px;
}
.tox .tox-hue-slider-spectrum:focus,
.tox .tox-sv-palette-spectrum:focus {
  outline: #08f solid;
}
.tox .tox-hue-slider-thumb {
  background: white;
  border: 1px solid black;
  box-sizing: content-box;
  height: 4px;
  width: 100%;
}
.tox .tox-rgb-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.tox .tox-rgb-form div {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  width: inherit;
}
.tox .tox-rgb-form input {
  width: 6em;
}
.tox .tox-rgb-form input.tox-invalid {
  /* Need !important to override Chrome's focus styling unfortunately */
  border: 1px solid red !important;
}
.tox .tox-rgb-form .tox-rgba-preview {
  border: 1px solid black;
  flex-grow: 2;
  margin-bottom: 0;
}
.tox:not([dir=rtl]) .tox-sv-palette {
  margin-right: 15px;
}
.tox:not([dir=rtl]) .tox-hue-slider {
  margin-right: 15px;
}
.tox:not([dir=rtl]) .tox-hue-slider-thumb {
  margin-left: -1px;
}
.tox:not([dir=rtl]) .tox-rgb-form label {
  margin-right: 0.5em;
}
.tox[dir=rtl] .tox-sv-palette {
  margin-left: 15px;
}
.tox[dir=rtl] .tox-hue-slider {
  margin-left: 15px;
}
.tox[dir=rtl] .tox-hue-slider-thumb {
  margin-right: -1px;
}
.tox[dir=rtl] .tox-rgb-form label {
  margin-left: 0.5em;
}
.tox .tox-toolbar .tox-swatches,
.tox .tox-toolbar__primary .tox-swatches,
.tox .tox-toolbar__overflow .tox-swatches {
  margin: 5px 0 6px 11px;
}
.tox .tox-collection--list .tox-collection__group .tox-swatches-menu {
  border: 0;
  margin: -4px -4px;
}
.tox .tox-swatches__row {
  display: flex;
}
.tox .tox-swatch {
  height: 30px;
  transition: transform 0.15s, box-shadow 0.15s;
  width: 30px;
}
.tox .tox-swatch:hover,
.tox .tox-swatch:focus {
  box-shadow: 0 0 0 1px rgba(127, 127, 127, 0.3) inset;
  transform: scale(0.8);
}
.tox .tox-swatch--remove {
  align-items: center;
  display: flex;
  justify-content: center;
}
.tox .tox-swatch--remove svg path {
  stroke: #e74c3c;
}
.tox .tox-swatches__picker-btn {
  align-items: center;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 30px;
  justify-content: center;
  outline: none;
  padding: 0;
  width: 30px;
}
.tox .tox-swatches__picker-btn svg {
  fill: #222f3e;
  height: 24px;
  width: 24px;
}
.tox .tox-swatches__picker-btn:hover {
  background: #cce2fa;
}
.tox div.tox-swatch:not(.tox-swatch--remove) svg {
  display: none;
  fill: #222f3e;
  height: 24px;
  margin: calc((30px - 24px) / 2) calc((30px - 24px) / 2);
  width: 24px;
}
.tox div.tox-swatch:not(.tox-swatch--remove) svg path {
  fill: #fff;
  paint-order: stroke;
  stroke: #222f3e;
  stroke-width: 2px;
}
.tox div.tox-swatch:not(.tox-swatch--remove).tox-collection__item--enabled svg {
  display: block;
}
.tox:not([dir=rtl]) .tox-swatches__picker-btn {
  margin-left: auto;
}
.tox[dir=rtl] .tox-swatches__picker-btn {
  margin-right: auto;
}
.tox .tox-comment-thread {
  background: #fff;
  position: relative;
}
.tox .tox-comment-thread > *:not(:first-child) {
  margin-top: 8px;
}
.tox .tox-comment {
  background: #fff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);
  padding: 8px 8px 16px 8px;
  position: relative;
}
.tox .tox-comment__header {
  align-items: center;
  color: #222f3e;
  display: flex;
  justify-content: space-between;
}
.tox .tox-comment__date {
  color: #222f3e;
  font-size: 12px;
  line-height: 18px;
}
.tox .tox-comment__body {
  color: #222f3e;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.3;
  margin-top: 8px;
  position: relative;
  text-transform: initial;
}
.tox .tox-comment__body textarea {
  resize: none;
  white-space: normal;
  width: 100%;
}
.tox .tox-comment__expander {
  padding-top: 8px;
}
.tox .tox-comment__expander p {
  color: rgba(34, 47, 62, 0.7);
  font-size: 14px;
  font-style: normal;
}
.tox .tox-comment__body p {
  margin: 0;
}
.tox .tox-comment__buttonspacing {
  padding-top: 16px;
  text-align: center;
}
.tox .tox-comment-thread__overlay::after {
  background: #fff;
  bottom: 0;
  content: "";
  display: flex;
  left: 0;
  opacity: 0.9;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
}
.tox .tox-comment__reply {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 8px;
}
.tox .tox-comment__reply > *:first-child {
  margin-bottom: 8px;
  width: 100%;
}
.tox .tox-comment__edit {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 16px;
}
.tox .tox-comment__gradient::after {
  background: linear-gradient(rgba(255, 255, 255, 0), #fff);
  bottom: 0;
  content: "";
  display: block;
  height: 5em;
  margin-top: -40px;
  position: absolute;
  width: 100%;
}
.tox .tox-comment__overlay {
  background: #fff;
  bottom: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  left: 0;
  opacity: 0.9;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 5;
}
.tox .tox-comment__loading-text {
  align-items: center;
  color: #222f3e;
  display: flex;
  flex-direction: column;
  position: relative;
}
.tox .tox-comment__loading-text > div {
  padding-bottom: 16px;
}
.tox .tox-comment__overlaytext {
  bottom: 0;
  flex-direction: column;
  font-size: 14px;
  left: 0;
  padding: 1em;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}
.tox .tox-comment__overlaytext p {
  background-color: #fff;
  box-shadow: 0 0 8px 8px #fff;
  color: #222f3e;
  text-align: center;
}
.tox .tox-comment__overlaytext div:nth-of-type(2) {
  font-size: 0.8em;
}
.tox .tox-comment__busy-spinner {
  align-items: center;
  background-color: #fff;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 20;
}
.tox .tox-comment__scroll {
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  overflow: auto;
}
.tox .tox-conversations {
  margin: 8px;
}
.tox:not([dir=rtl]) .tox-comment__edit {
  margin-left: 8px;
}
.tox:not([dir=rtl]) .tox-comment__buttonspacing > *:last-child,
.tox:not([dir=rtl]) .tox-comment__edit > *:last-child,
.tox:not([dir=rtl]) .tox-comment__reply > *:last-child {
  margin-left: 8px;
}
.tox[dir=rtl] .tox-comment__edit {
  margin-right: 8px;
}
.tox[dir=rtl] .tox-comment__buttonspacing > *:last-child,
.tox[dir=rtl] .tox-comment__edit > *:last-child,
.tox[dir=rtl] .tox-comment__reply > *:last-child {
  margin-right: 8px;
}
.tox .tox-user {
  align-items: center;
  display: flex;
}
.tox .tox-user__avatar svg {
  fill: rgba(34, 47, 62, 0.7);
}
.tox .tox-user__avatar img {
  border-radius: 50%;
  height: 36px;
  object-fit: cover;
  vertical-align: middle;
  width: 36px;
}
.tox .tox-user__name {
  color: #222f3e;
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  line-height: 18px;
  text-transform: none;
}
.tox:not([dir=rtl]) .tox-user__avatar svg,
.tox:not([dir=rtl]) .tox-user__avatar img {
  margin-right: 8px;
}
.tox:not([dir=rtl]) .tox-user__avatar + .tox-user__name {
  margin-left: 8px;
}
.tox[dir=rtl] .tox-user__avatar svg,
.tox[dir=rtl] .tox-user__avatar img {
  margin-left: 8px;
}
.tox[dir=rtl] .tox-user__avatar + .tox-user__name {
  margin-right: 8px;
}
.tox .tox-dialog-wrap {
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1100;
}
.tox .tox-dialog-wrap__backdrop {
  background-color: rgba(255, 255, 255, 0.75);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
.tox .tox-dialog-wrap__backdrop--opaque {
  background-color: #fff;
}
.tox .tox-dialog {
  background-color: #fff;
  border-color: #eeeeee;
  border-radius: 10px;
  border-style: solid;
  border-width: 0px;
  box-shadow: 0 16px 16px -10px rgba(34, 47, 62, 0.15), 0 0 40px 1px rgba(34, 47, 62, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 100%;
  max-width: 480px;
  overflow: hidden;
  position: relative;
  width: 95vw;
  z-index: 2;
}
@media only screen and (max-width: 767px ) {
  body:not(.tox-force-desktop) .tox .tox-dialog {
    align-self: flex-start;
    margin: 8px auto;
    max-height: calc(100vh - 8px * 2);
    width: calc(100vw - 16px);
  }
}
.tox .tox-dialog-inline {
  z-index: 1100;
}
.tox .tox-dialog__header {
  align-items: center;
  background-color: #fff;
  border-bottom: none;
  color: #222f3e;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  padding: 8px 16px 0 16px;
  position: relative;
}
.tox .tox-dialog__header .tox-button {
  z-index: 1;
}
.tox .tox-dialog__draghandle {
  cursor: grab;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.tox .tox-dialog__draghandle:active {
  cursor: grabbing;
}
.tox .tox-dialog__dismiss {
  margin-left: auto;
}
.tox .tox-dialog__title {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.3;
  margin: 0;
  text-transform: none;
}
.tox .tox-dialog__body {
  color: #222f3e;
  display: flex;
  flex: 1;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.3;
  min-width: 0;
  text-align: left;
  text-transform: none;
}
@media only screen and (max-width: 767px ) {
  body:not(.tox-force-desktop) .tox .tox-dialog__body {
    flex-direction: column;
  }
}
.tox .tox-dialog__body-nav {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: 16px 16px;
}
@media only screen and (min-width: 768px ) {
  .tox .tox-dialog__body-nav {
    max-width: 11em;
  }
}
@media only screen and (max-width: 767px ) {
  body:not(.tox-force-desktop) .tox .tox-dialog__body-nav {
    flex-direction: row;
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    padding-bottom: 0;
  }
}
.tox .tox-dialog__body-nav-item {
  border-bottom: 2px solid transparent;
  color: rgba(34, 47, 62, 0.7);
  display: inline-block;
  flex-shrink: 0;
  font-size: 14px;
  line-height: 1.3;
  margin-bottom: 8px;
  max-width: 13em;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.tox .tox-dialog__body-nav-item:focus {
  background-color: rgba(0, 108, 231, 0.1);
}
.tox .tox-dialog__body-nav-item--active {
  border-bottom: 2px solid #006ce7;
  color: #006ce7;
}
.tox .tox-dialog__body-content {
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: min(650px, calc(100vh - 110px));
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px 16px;
}
.tox .tox-dialog__body-content > * {
  margin-bottom: 0;
  margin-top: 16px;
}
.tox .tox-dialog__body-content > *:first-child {
  margin-top: 0;
}
.tox .tox-dialog__body-content > *:last-child {
  margin-bottom: 0;
}
.tox .tox-dialog__body-content > *:only-child {
  margin-bottom: 0;
  margin-top: 0;
}
.tox .tox-dialog__body-content a {
  color: #006ce7;
  cursor: pointer;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.tox .tox-dialog__body-content a:hover,
.tox .tox-dialog__body-content a:focus {
  color: #003c81;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.tox .tox-dialog__body-content a:focus-visible {
  border-radius: 1px;
  outline: 2px solid #006ce7;
  outline-offset: 2px;
}
.tox .tox-dialog__body-content a:active {
  color: #00244e;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.tox .tox-dialog__body-content svg {
  fill: #222f3e;
}
.tox .tox-dialog__body-content strong {
  font-weight: bold;
}
.tox .tox-dialog__body-content ul {
  list-style-type: disc;
}
.tox .tox-dialog__body-content ul,
.tox .tox-dialog__body-content ol,
.tox .tox-dialog__body-content dd {
  padding-inline-start: 2.5rem;
}
.tox .tox-dialog__body-content ul,
.tox .tox-dialog__body-content ol,
.tox .tox-dialog__body-content dl {
  margin-bottom: 16px;
}
.tox .tox-dialog__body-content ul,
.tox .tox-dialog__body-content ol,
.tox .tox-dialog__body-content dl,
.tox .tox-dialog__body-content dd,
.tox .tox-dialog__body-content dt {
  display: block;
  margin-inline-end: 0;
  margin-inline-start: 0;
}
.tox .tox-dialog__body-content .tox-form__group h1 {
  color: #222f3e;
  font-size: 20px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: normal;
  margin-bottom: 16px;
  margin-top: 2rem;
  text-transform: none;
}
.tox .tox-dialog__body-content .tox-form__group h2 {
  color: #222f3e;
  font-size: 16px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: normal;
  margin-bottom: 16px;
  margin-top: 2rem;
  text-transform: none;
}
.tox .tox-dialog__body-content .tox-form__group p {
  margin-bottom: 16px;
}
.tox .tox-dialog__body-content .tox-form__group h1:first-child,
.tox .tox-dialog__body-content .tox-form__group h2:first-child,
.tox .tox-dialog__body-content .tox-form__group p:first-child {
  margin-top: 0;
}
.tox .tox-dialog__body-content .tox-form__group h1:last-child,
.tox .tox-dialog__body-content .tox-form__group h2:last-child,
.tox .tox-dialog__body-content .tox-form__group p:last-child {
  margin-bottom: 0;
}
.tox .tox-dialog__body-content .tox-form__group h1:only-child,
.tox .tox-dialog__body-content .tox-form__group h2:only-child,
.tox .tox-dialog__body-content .tox-form__group p:only-child {
  margin-bottom: 0;
  margin-top: 0;
}
.tox .tox-dialog__body-content .tox-form__group .tox-label.tox-label--center {
  text-align: center;
}
.tox .tox-dialog__body-content .tox-form__group .tox-label.tox-label--end {
  text-align: end;
}
.tox .tox-dialog--width-lg {
  height: 650px;
  max-width: 1200px;
}
.tox .tox-dialog--fullscreen {
  height: 100%;
  max-width: 100%;
}
.tox .tox-dialog--fullscreen .tox-dialog__body-content {
  max-height: 100%;
}
.tox .tox-dialog--width-md {
  max-width: 800px;
}
.tox .tox-dialog--width-md .tox-dialog__body-content {
  overflow: auto;
}
.tox .tox-dialog__body-content--centered {
  text-align: center;
}
.tox .tox-dialog__footer {
  align-items: center;
  background-color: #fff;
  border-top: none;
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
}
.tox .tox-dialog__footer-start,
.tox .tox-dialog__footer-end {
  display: flex;
}
.tox .tox-dialog__busy-spinner {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.75);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 3;
}
.tox .tox-dialog__table {
  border-collapse: collapse;
  width: 100%;
}
.tox .tox-dialog__table thead th {
  font-weight: bold;
  padding-bottom: 8px;
}
.tox .tox-dialog__table thead th:first-child {
  padding-right: 8px;
}
.tox .tox-dialog__table tbody tr {
  border-bottom: 1px solid #626262;
}
.tox .tox-dialog__table tbody tr:last-child {
  border-bottom: none;
}
.tox .tox-dialog__table td {
  padding-bottom: 8px;
  padding-top: 8px;
}
.tox .tox-dialog__table td:first-child {
  padding-right: 8px;
}
.tox .tox-dialog__iframe {
  min-height: 200px;
}
.tox .tox-dialog__iframe.tox-dialog__iframe--opaque {
  background: #fff;
}
.tox .tox-navobj-bordered {
  position: relative;
}
.tox .tox-navobj-bordered::before {
  border: 1px solid #eeeeee;
  border-radius: 6px;
  content: '';
  inset: 0;
  opacity: 1;
  pointer-events: none;
  position: absolute;
  z-index: 1;
}
.tox .tox-navobj-bordered-focus.tox-navobj-bordered::before {
  border-color: #006ce7;
  box-shadow: 0 0 0 2px rgba(0, 108, 231, 0.25);
  outline: none;
}
.tox .tox-dialog__popups {
  position: absolute;
  width: 100%;
  z-index: 1100;
}
.tox .tox-dialog__body-iframe {
  display: flex;
  flex: 1;
  flex-direction: column;
}
.tox .tox-dialog__body-iframe .tox-navobj {
  display: flex;
  flex: 1;
}
.tox .tox-dialog__body-iframe .tox-navobj :nth-child(2) {
  flex: 1;
  height: 100%;
}
.tox .tox-dialog-dock-fadeout {
  opacity: 0;
  visibility: hidden;
}
.tox .tox-dialog-dock-fadein {
  opacity: 1;
  visibility: visible;
}
.tox .tox-dialog-dock-transition {
  transition: visibility 0s linear 0.3s, opacity 0.3s ease;
}
.tox .tox-dialog-dock-transition.tox-dialog-dock-fadein {
  transition-delay: 0s;
}
@media only screen and (max-width: 767px ) {
  body:not(.tox-force-desktop) .tox:not([dir=rtl]) .tox-dialog__body-nav {
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px ) {
  body:not(.tox-force-desktop) .tox:not([dir=rtl]) .tox-dialog__body-nav-item:not(:first-child) {
    margin-left: 8px;
  }
}
.tox:not([dir=rtl]) .tox-dialog__footer .tox-dialog__footer-start > *,
.tox:not([dir=rtl]) .tox-dialog__footer .tox-dialog__footer-end > * {
  margin-left: 8px;
}
.tox[dir=rtl] .tox-dialog__body {
  text-align: right;
}
@media only screen and (max-width: 767px ) {
  body:not(.tox-force-desktop) .tox[dir=rtl] .tox-dialog__body-nav {
    margin-left: 0;
  }
}
@media only screen and (max-width: 767px ) {
  body:not(.tox-force-desktop) .tox[dir=rtl] .tox-dialog__body-nav-item:not(:first-child) {
    margin-right: 8px;
  }
}
.tox[dir=rtl] .tox-dialog__footer .tox-dialog__footer-start > *,
.tox[dir=rtl] .tox-dialog__footer .tox-dialog__footer-end > * {
  margin-right: 8px;
}
body.tox-dialog__disable-scroll {
  overflow: hidden;
}
.tox .tox-dropzone-container {
  display: flex;
  flex: 1;
}
.tox .tox-dropzone {
  align-items: center;
  background: #fff;
  border: 2px dashed #eeeeee;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  min-height: 100px;
  padding: 10px;
}
.tox .tox-dropzone p {
  color: rgba(34, 47, 62, 0.7);
  margin: 0 0 16px 0;
}
.tox .tox-edit-area {
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;
}
.tox .tox-edit-area::before {
  border: 2px solid #2D6ADF;
  border-radius: 4px;
  content: '';
  inset: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 0.15s;
  z-index: 1;
}
.tox .tox-edit-area__iframe {
  background-color: #fff;
  border: 0;
  box-sizing: border-box;
  flex: 1;
  height: 100%;
  position: absolute;
  width: 100%;
}
.tox.tox-edit-focus .tox-edit-area::before {
  opacity: 1;
}
.tox.tox-inline-edit-area {
  border: 1px dotted #eeeeee;
}
.tox .tox-editor-container {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
}
.tox .tox-editor-header {
  display: grid;
  grid-template-columns: 1fr min-content;
  z-index: 2;
}
.tox:not(.tox-tinymce-inline) .tox-editor-header {
  background-color: #fff;
  border-bottom: none;
  box-shadow: 0 2px 2px -2px rgba(34, 47, 62, 0.1), 0 8px 8px -4px rgba(34, 47, 62, 0.07);
  padding: 4px 0;
}
.tox:not(.tox-tinymce-inline) .tox-editor-header:not(.tox-editor-dock-transition) {
  transition: box-shadow 0.5s;
}
.tox:not(.tox-tinymce-inline).tox-tinymce--toolbar-bottom .tox-editor-header {
  border-top: 1px solid #e3e3e3;
  box-shadow: none;
}
.tox:not(.tox-tinymce-inline).tox-tinymce--toolbar-sticky-on .tox-editor-header {
  background-color: #fff;
  box-shadow: 0 2px 2px -2px rgba(34, 47, 62, 0.2), 0 8px 8px -4px rgba(34, 47, 62, 0.15);
  padding: 4px 0;
}
.tox:not(.tox-tinymce-inline).tox-tinymce--toolbar-sticky-on.tox-tinymce--toolbar-bottom .tox-editor-header {
  box-shadow: 0 2px 2px -2px rgba(34, 47, 62, 0.2), 0 8px 8px -4px rgba(34, 47, 62, 0.15);
}
.tox.tox:not(.tox-tinymce-inline) .tox-editor-header.tox-editor-header--empty {
  background: none;
  border: none;
  box-shadow: none;
  padding: 0;
}
.tox-editor-dock-fadeout {
  opacity: 0;
  visibility: hidden;
}
.tox-editor-dock-fadein {
  opacity: 1;
  visibility: visible;
}
.tox-editor-dock-transition {
  transition: visibility 0s linear 0.25s, opacity 0.25s ease;
}
.tox-editor-dock-transition.tox-editor-dock-fadein {
  transition-delay: 0s;
}
.tox .tox-control-wrap {
  flex: 1;
  position: relative;
}
.tox .tox-control-wrap:not(.tox-control-wrap--status-invalid) .tox-control-wrap__status-icon-invalid,
.tox .tox-control-wrap:not(.tox-control-wrap--status-unknown) .tox-control-wrap__status-icon-unknown,
.tox .tox-control-wrap:not(.tox-control-wrap--status-valid) .tox-control-wrap__status-icon-valid {
  display: none;
}
.tox .tox-control-wrap svg {
  display: block;
}
.tox .tox-control-wrap__status-icon-wrap {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.tox .tox-control-wrap__status-icon-invalid svg {
  fill: #c00;
}
.tox .tox-control-wrap__status-icon-unknown svg {
  fill: orange;
}
.tox .tox-control-wrap__status-icon-valid svg {
  fill: green;
}
.tox:not([dir=rtl]) .tox-control-wrap--status-invalid .tox-textfield,
.tox:not([dir=rtl]) .tox-control-wrap--status-unknown .tox-textfield,
.tox:not([dir=rtl]) .tox-control-wrap--status-valid .tox-textfield {
  padding-right: 32px;
}
.tox:not([dir=rtl]) .tox-control-wrap__status-icon-wrap {
  right: 4px;
}
.tox[dir=rtl] .tox-control-wrap--status-invalid .tox-textfield,
.tox[dir=rtl] .tox-control-wrap--status-unknown .tox-textfield,
.tox[dir=rtl] .tox-control-wrap--status-valid .tox-textfield {
  padding-left: 32px;
}
.tox[dir=rtl] .tox-control-wrap__status-icon-wrap {
  left: 4px;
}
.tox .tox-autocompleter {
  max-width: 25em;
}
.tox .tox-autocompleter .tox-menu {
  box-sizing: border-box;
  max-width: 25em;
}
.tox .tox-autocompleter .tox-autocompleter-highlight {
  font-weight: bold;
}
.tox .tox-color-input {
  display: flex;
  position: relative;
  z-index: 1;
}
.tox .tox-color-input .tox-textfield {
  z-index: -1;
}
.tox .tox-color-input span {
  border-color: rgba(34, 47, 62, 0.2);
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  height: 24px;
  position: absolute;
  top: 6px;
  width: 24px;
}
.tox .tox-color-input span:hover:not([aria-disabled=true]),
.tox .tox-color-input span:focus:not([aria-disabled=true]) {
  border-color: #006ce7;
  cursor: pointer;
}
.tox .tox-color-input span::before {
  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%), linear-gradient(-45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%), linear-gradient(-45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%);
  background-position: 0 0, 0 6px, 6px -6px, -6px 0;
  background-size: 12px 12px;
  border: 1px solid #fff;
  border-radius: 6px;
  box-sizing: border-box;
  content: '';
  height: 24px;
  left: -1px;
  position: absolute;
  top: -1px;
  width: 24px;
  z-index: -1;
}
.tox .tox-color-input span[aria-disabled=true] {
  cursor: not-allowed;
}
.tox:not([dir=rtl]) .tox-color-input {
  /* stylelint-disable-next-line no-descending-specificity */
}
.tox:not([dir=rtl]) .tox-color-input .tox-textfield {
  padding-left: 36px;
}
.tox:not([dir=rtl]) .tox-color-input span {
  left: 6px;
}
.tox[dir="rtl"] .tox-color-input {
  /* stylelint-disable-next-line no-descending-specificity */
}
.tox[dir="rtl"] .tox-color-input .tox-textfield {
  padding-right: 36px;
}
.tox[dir="rtl"] .tox-color-input span {
  right: 6px;
}
.tox .tox-label,
.tox .tox-toolbar-label {
  color: rgba(34, 47, 62, 0.7);
  display: block;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.3;
  padding: 0 8px 0 0;
  text-transform: none;
  white-space: nowrap;
}
.tox .tox-toolbar-label {
  padding: 0 8px;
}
.tox[dir=rtl] .tox-label {
  padding: 0 0 0 8px;
}
.tox .tox-form {
  display: flex;
  flex: 1;
  flex-direction: column;
}
.tox .tox-form__group {
  box-sizing: border-box;
  margin-bottom: 4px;
}
.tox .tox-form-group--maximize {
  flex: 1;
}
.tox .tox-form__group--error {
  color: #c00;
}
.tox .tox-form__group--collection {
  display: flex;
}
.tox .tox-form__grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.tox .tox-form__grid--2col > .tox-form__group {
  width: calc(50% - (8px / 2));
}
.tox .tox-form__grid--3col > .tox-form__group {
  width: calc(100% / 3 - (8px / 2));
}
.tox .tox-form__grid--4col > .tox-form__group {
  width: calc(25% - (8px / 2));
}
.tox .tox-form__controls-h-stack {
  align-items: center;
  display: flex;
}
.tox .tox-form__group--inline {
  align-items: center;
  display: flex;
}
.tox .tox-form__group--stretched {
  display: flex;
  flex: 1;
  flex-direction: column;
}
.tox .tox-form__group--stretched .tox-textarea {
  flex: 1;
}
.tox .tox-form__group--stretched .tox-navobj {
  display: flex;
  flex: 1;
}
.tox .tox-form__group--stretched .tox-navobj :nth-child(2) {
  flex: 1;
  height: 100%;
}
.tox:not([dir=rtl]) .tox-form__controls-h-stack > *:not(:first-child) {
  margin-left: 4px;
}
.tox[dir=rtl] .tox-form__controls-h-stack > *:not(:first-child) {
  margin-right: 4px;
}
.tox .tox-lock.tox-locked .tox-lock-icon__unlock,
.tox .tox-lock:not(.tox-locked) .tox-lock-icon__lock {
  display: none;
}
.tox .tox-textfield,
.tox .tox-toolbar-textfield,
.tox .tox-listboxfield .tox-listbox--select,
.tox .tox-textarea,
.tox .tox-textarea-wrap .tox-textarea:focus {
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #eeeeee;
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  color: #222f3e;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  min-height: 34px;
  outline: none;
  padding: 5px 5.5px;
  resize: none;
  width: 100%;
}
.tox .tox-textfield[disabled],
.tox .tox-textarea[disabled] {
  background-color: #f2f2f2;
  color: rgba(34, 47, 62, 0.85);
  cursor: not-allowed;
}
.tox .tox-textfield:focus,
.tox .tox-listboxfield .tox-listbox--select:focus,
.tox .tox-textarea-wrap:focus-within,
.tox .tox-textarea:focus,
.tox .tox-custom-editor:focus-within {
  background-color: #fff;
  border-color: #006ce7;
  box-shadow: 0 0 0 2px rgba(0, 108, 231, 0.25);
  outline: none;
}
.tox .tox-toolbar-textfield {
  border-width: 0;
  margin-bottom: 3px;
  margin-top: 2px;
  max-width: 250px;
}
.tox .tox-naked-btn {
  background-color: transparent;
  border: 0;
  border-color: transparent;
  box-shadow: unset;
  color: #006ce7;
  cursor: pointer;
  display: block;
  margin: 0;
  padding: 0;
}
.tox .tox-naked-btn svg {
  display: block;
  fill: #222f3e;
}
.tox:not([dir=rtl]) .tox-toolbar-textfield + * {
  margin-left: 4px;
}
.tox[dir=rtl] .tox-toolbar-textfield + * {
  margin-right: 4px;
}
.tox .tox-listboxfield {
  cursor: pointer;
  position: relative;
}
.tox .tox-listboxfield .tox-listbox--select[disabled] {
  background-color: #f2f2f2;
  color: rgba(34, 47, 62, 0.85);
  cursor: not-allowed;
}
.tox .tox-listbox__select-label {
  cursor: default;
  flex: 1;
  margin: 0 4px;
}
.tox .tox-listbox__select-chevron {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 16px;
}
.tox .tox-listbox__select-chevron svg {
  fill: #222f3e;
}
.tox .tox-listboxfield .tox-listbox--select {
  align-items: center;
  display: flex;
}
.tox:not([dir=rtl]) .tox-listboxfield svg {
  right: 8px;
}
.tox[dir=rtl] .tox-listboxfield svg {
  left: 8px;
}
.tox .tox-selectfield {
  cursor: pointer;
  position: relative;
}
.tox .tox-selectfield select {
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #eeeeee;
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  color: #222f3e;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  min-height: 34px;
  outline: none;
  padding: 5px 5.5px;
  resize: none;
  width: 100%;
}
.tox .tox-selectfield select[disabled] {
  background-color: #f2f2f2;
  color: rgba(34, 47, 62, 0.85);
  cursor: not-allowed;
}
.tox .tox-selectfield select::-ms-expand {
  display: none;
}
.tox .tox-selectfield select:focus {
  background-color: #fff;
  border-color: #006ce7;
  box-shadow: 0 0 0 2px rgba(0, 108, 231, 0.25);
  outline: none;
}
.tox .tox-selectfield svg {
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.tox:not([dir=rtl]) .tox-selectfield select[size="0"],
.tox:not([dir=rtl]) .tox-selectfield select[size="1"] {
  padding-right: 24px;
}
.tox:not([dir=rtl]) .tox-selectfield svg {
  right: 8px;
}
.tox[dir=rtl] .tox-selectfield select[size="0"],
.tox[dir=rtl] .tox-selectfield select[size="1"] {
  padding-left: 24px;
}
.tox[dir=rtl] .tox-selectfield svg {
  left: 8px;
}
.tox .tox-textarea-wrap {
  border-color: #eeeeee;
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;
  display: flex;
  flex: 1;
  overflow: hidden;
}
.tox .tox-textarea {
  -webkit-appearance: textarea;
          appearance: textarea;
  white-space: pre-wrap;
}
.tox .tox-textarea-wrap .tox-textarea {
  border: none;
}
.tox .tox-textarea-wrap .tox-textarea:focus {
  border: none;
}
.tox-fullscreen {
  border: 0;
  height: 100%;
  margin: 0;
  overflow: hidden;
  overscroll-behavior: none;
  padding: 0;
  touch-action: pinch-zoom;
  width: 100%;
}
.tox.tox-tinymce.tox-fullscreen .tox-statusbar__resize-handle {
  display: none;
}
.tox.tox-tinymce.tox-fullscreen,
.tox-shadowhost.tox-fullscreen {
  left: 0;
  position: fixed;
  top: 0;
  z-index: 1200;
}
.tox.tox-tinymce.tox-fullscreen {
  background-color: transparent;
}
.tox-fullscreen .tox.tox-tinymce-aux,
.tox-fullscreen ~ .tox.tox-tinymce-aux {
  z-index: 1201;
}
.tox .tox-help__more-link {
  list-style: none;
  margin-top: 1em;
}
.tox .tox-imagepreview {
  background-color: #666;
  height: 380px;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.tox .tox-imagepreview.tox-imagepreview__loaded {
  overflow: auto;
}
.tox .tox-imagepreview__container {
  display: flex;
  left: 100vw;
  position: absolute;
  top: 100vw;
}
.tox .tox-imagepreview__image {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.tox .tox-image-tools .tox-spacer {
  flex: 1;
}
.tox .tox-image-tools .tox-bar {
  align-items: center;
  display: flex;
  height: 60px;
  justify-content: center;
}
.tox .tox-image-tools .tox-imagepreview,
.tox .tox-image-tools .tox-imagepreview + .tox-bar {
  margin-top: 8px;
}
.tox .tox-image-tools .tox-croprect-block {
  background: black;
  filter: alpha(opacity=50);
  opacity: 0.5;
  position: absolute;
  zoom: 1;
}
.tox .tox-image-tools .tox-croprect-handle {
  border: 2px solid white;
  height: 20px;
  left: 0;
  position: absolute;
  top: 0;
  width: 20px;
}
.tox .tox-image-tools .tox-croprect-handle-move {
  border: 0;
  cursor: move;
  position: absolute;
}
.tox .tox-image-tools .tox-croprect-handle-nw {
  border-width: 2px 0 0 2px;
  cursor: nw-resize;
  left: 100px;
  margin: -2px 0 0 -2px;
  top: 100px;
}
.tox .tox-image-tools .tox-croprect-handle-ne {
  border-width: 2px 2px 0 0;
  cursor: ne-resize;
  left: 200px;
  margin: -2px 0 0 -20px;
  top: 100px;
}
.tox .tox-image-tools .tox-croprect-handle-sw {
  border-width: 0 0 2px 2px;
  cursor: sw-resize;
  left: 100px;
  margin: -20px 2px 0 -2px;
  top: 200px;
}
.tox .tox-image-tools .tox-croprect-handle-se {
  border-width: 0 2px 2px 0;
  cursor: se-resize;
  left: 200px;
  margin: -20px 0 0 -20px;
  top: 200px;
}
.tox .tox-insert-table-picker {
  display: flex;
  flex-wrap: wrap;
  width: 170px;
}
.tox .tox-insert-table-picker > div {
  border-color: #eeeeee;
  border-style: solid;
  border-width: 0 1px 1px 0;
  box-sizing: border-box;
  height: 17px;
  width: 17px;
}
.tox .tox-collection--list .tox-collection__group .tox-insert-table-picker {
  margin: -4px -4px;
}
.tox .tox-insert-table-picker .tox-insert-table-picker__selected {
  background-color: rgba(0, 108, 231, 0.5);
  border-color: rgba(0, 108, 231, 0.5);
}
.tox .tox-insert-table-picker__label {
  color: rgba(34, 47, 62, 0.7);
  display: block;
  font-size: 14px;
  padding: 4px;
  text-align: center;
  width: 100%;
}
.tox:not([dir=rtl]) {
  /* stylelint-disable-next-line no-descending-specificity */
}
.tox:not([dir=rtl]) .tox-insert-table-picker > div:nth-child(10n) {
  border-right: 0;
}
.tox[dir=rtl] {
  /* stylelint-disable-next-line no-descending-specificity */
}
.tox[dir=rtl] .tox-insert-table-picker > div:nth-child(10n+1) {
  border-right: 0;
}
.tox {
  /* stylelint-disable */
  /* stylelint-enable */
}
.tox .tox-menu {
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 6px;
  box-shadow: 0 0 2px 0 rgba(34, 47, 62, 0.2), 0 4px 8px 0 rgba(34, 47, 62, 0.15);
  display: inline-block;
  overflow: hidden;
  vertical-align: top;
  z-index: 1150;
}
.tox .tox-menu.tox-collection.tox-collection--list {
  padding: 0 4px;
}
.tox .tox-menu.tox-collection.tox-collection--toolbar {
  padding: 8px;
}
.tox .tox-menu.tox-collection.tox-collection--grid {
  padding: 8px;
}
@media only screen and (min-width: 768px ) {
  .tox .tox-menu .tox-collection__item-label {
    overflow-wrap: break-word;
    word-break: normal;
  }
  .tox .tox-dialog__popups .tox-menu .tox-collection__item-label {
    word-break: break-all;
  }
}
.tox .tox-menu__label h1,
.tox .tox-menu__label h2,
.tox .tox-menu__label h3,
.tox .tox-menu__label h4,
.tox .tox-menu__label h5,
.tox .tox-menu__label h6,
.tox .tox-menu__label p,
.tox .tox-menu__label blockquote,
.tox .tox-menu__label code {
  margin: 0;
}
.tox .tox-menubar {
  background: repeating-linear-gradient(transparent 0px 1px, transparent 1px 39px) center top 39px / 100% calc(100% - 39px) no-repeat;
  background-color: #fff;
  display: flex;
  flex: 0 0 auto;
  flex-shrink: 0;
  flex-wrap: wrap;
  grid-column: 1 / -1;
  grid-row: 1;
  padding: 0 11px 0 12px;
}
.tox .tox-promotion + .tox-menubar {
  grid-column: 1;
}
.tox .tox-promotion {
  background: repeating-linear-gradient(transparent 0px 1px, transparent 1px 39px) center top 39px / 100% calc(100% - 39px) no-repeat;
  background-color: #fff;
  grid-column: 2;
  grid-row: 1;
  padding-inline-end: 8px;
  padding-inline-start: 4px;
  padding-top: 5px;
}
.tox .tox-promotion-link {
  align-items: unsafe center;
  background-color: #E8F1F8;
  border-radius: 5px;
  color: #086BE6;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  height: 26.6px;
  padding: 4px 8px;
  white-space: nowrap;
}
.tox .tox-promotion-link:hover {
  background-color: #B4D7FF;
}
.tox .tox-promotion-link:focus {
  background-color: #D9EDF7;
}
/* Deprecated. Remove in next major release */
.tox .tox-mbtn {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 3px;
  box-shadow: none;
  color: #222f3e;
  display: flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  height: 28px;
  justify-content: center;
  margin: 5px 1px 6px 0;
  outline: none;
  overflow: hidden;
  padding: 0 4px;
  text-transform: none;
  width: auto;
}
.tox .tox-mbtn[disabled] {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox .tox-mbtn:focus:not(:disabled) {
  background: #cce2fa;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-mbtn--active {
  background: #a6ccf7;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {
  background: #cce2fa;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-mbtn__select-label {
  cursor: default;
  font-weight: normal;
  margin: 0 4px;
}
.tox .tox-mbtn[disabled] .tox-mbtn__select-label {
  cursor: not-allowed;
}
.tox .tox-mbtn__select-chevron {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 16px;
  display: none;
}
.tox .tox-notification {
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  display: grid;
  font-size: 14px;
  font-weight: normal;
  grid-template-columns: minmax(40px, 1fr) auto minmax(40px, 1fr);
  margin-top: 4px;
  opacity: 0;
  padding: 4px;
  transition: transform 100ms ease-in, opacity 150ms ease-in;
}
.tox .tox-notification p {
  font-size: 14px;
  font-weight: normal;
}
.tox .tox-notification a {
  cursor: pointer;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.tox .tox-notification--in {
  opacity: 1;
}
.tox .tox-notification--success {
  background-color: #e4eeda;
  border-color: #d7e6c8;
  color: #222f3e;
}
.tox .tox-notification--success p {
  color: #222f3e;
}
.tox .tox-notification--success a {
  color: #517342;
}
.tox .tox-notification--success svg {
  fill: #222f3e;
}
.tox .tox-notification--error {
  background-color: #f5cccc;
  border-color: #f0b3b3;
  color: #222f3e;
}
.tox .tox-notification--error p {
  color: #222f3e;
}
.tox .tox-notification--error a {
  color: #77181f;
}
.tox .tox-notification--error svg {
  fill: #222f3e;
}
.tox .tox-notification--warn,
.tox .tox-notification--warning {
  background-color: #fff5cc;
  border-color: #fff0b3;
  color: #222f3e;
}
.tox .tox-notification--warn p,
.tox .tox-notification--warning p {
  color: #222f3e;
}
.tox .tox-notification--warn a,
.tox .tox-notification--warning a {
  color: #7a6e25;
}
.tox .tox-notification--warn svg,
.tox .tox-notification--warning svg {
  fill: #222f3e;
}
.tox .tox-notification--info {
  background-color: #d6e7fb;
  border-color: #c1dbf9;
  color: #222f3e;
}
.tox .tox-notification--info p {
  color: #222f3e;
}
.tox .tox-notification--info a {
  color: #2a64a6;
}
.tox .tox-notification--info svg {
  fill: #222f3e;
}
.tox .tox-notification__body {
  align-self: center;
  color: #222f3e;
  font-size: 14px;
  grid-column-end: 3;
  grid-column-start: 2;
  grid-row-end: 2;
  grid-row-start: 1;
  text-align: center;
  white-space: normal;
  word-break: break-all;
  word-break: break-word;
}
.tox .tox-notification__body > * {
  margin: 0;
}
.tox .tox-notification__body > * + * {
  margin-top: 1rem;
}
.tox .tox-notification__icon {
  align-self: center;
  grid-column-end: 2;
  grid-column-start: 1;
  grid-row-end: 2;
  grid-row-start: 1;
  justify-self: end;
}
.tox .tox-notification__icon svg {
  display: block;
}
.tox .tox-notification__dismiss {
  align-self: start;
  grid-column-end: 4;
  grid-column-start: 3;
  grid-row-end: 2;
  grid-row-start: 1;
  justify-self: end;
}
.tox .tox-notification .tox-progress-bar {
  grid-column-end: 4;
  grid-column-start: 1;
  grid-row-end: 3;
  grid-row-start: 2;
  justify-self: center;
}
.tox .tox-pop {
  display: inline-block;
  position: relative;
}
.tox .tox-pop--resizing {
  transition: width 0.1s ease;
}
.tox .tox-pop--resizing .tox-toolbar,
.tox .tox-pop--resizing .tox-toolbar__group {
  flex-wrap: nowrap;
}
.tox .tox-pop--transition {
  transition: 0.15s ease;
  transition-property: left, right, top, bottom;
}
.tox .tox-pop--transition::before,
.tox .tox-pop--transition::after {
  transition: all 0.15s, visibility 0s, opacity 0.075s ease 0.075s;
}
.tox .tox-pop__dialog {
  background-color: #fff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  box-shadow: 0 0 2px 0 rgba(34, 47, 62, 0.2), 0 4px 8px 0 rgba(34, 47, 62, 0.15);
  min-width: 0;
  overflow: hidden;
}
.tox .tox-pop__dialog > *:not(.tox-toolbar) {
  margin: 4px 4px 4px 8px;
}
.tox .tox-pop__dialog .tox-toolbar {
  background-color: transparent;
  margin-bottom: -1px;
}
.tox .tox-pop::before,
.tox .tox-pop::after {
  border-style: solid;
  content: '';
  display: block;
  height: 0;
  opacity: 1;
  position: absolute;
  width: 0;
}
.tox .tox-pop.tox-pop--inset::before,
.tox .tox-pop.tox-pop--inset::after {
  opacity: 0;
  transition: all 0s 0.15s, visibility 0s, opacity 0.075s ease;
}
.tox .tox-pop.tox-pop--bottom::before,
.tox .tox-pop.tox-pop--bottom::after {
  left: 50%;
  top: 100%;
}
.tox .tox-pop.tox-pop--bottom::after {
  border-color: #fff transparent transparent transparent;
  border-width: 8px;
  margin-left: -8px;
  margin-top: -1px;
}
.tox .tox-pop.tox-pop--bottom::before {
  border-color: #eeeeee transparent transparent transparent;
  border-width: 9px;
  margin-left: -9px;
}
.tox .tox-pop.tox-pop--top::before,
.tox .tox-pop.tox-pop--top::after {
  left: 50%;
  top: 0;
  transform: translateY(-100%);
}
.tox .tox-pop.tox-pop--top::after {
  border-color: transparent transparent #fff transparent;
  border-width: 8px;
  margin-left: -8px;
  margin-top: 1px;
}
.tox .tox-pop.tox-pop--top::before {
  border-color: transparent transparent #eeeeee transparent;
  border-width: 9px;
  margin-left: -9px;
}
.tox .tox-pop.tox-pop--left::before,
.tox .tox-pop.tox-pop--left::after {
  left: 0;
  top: calc(50% - 1px);
  transform: translateY(-50%);
}
.tox .tox-pop.tox-pop--left::after {
  border-color: transparent #fff transparent transparent;
  border-width: 8px;
  margin-left: -15px;
}
.tox .tox-pop.tox-pop--left::before {
  border-color: transparent #eeeeee transparent transparent;
  border-width: 10px;
  margin-left: -19px;
}
.tox .tox-pop.tox-pop--right::before,
.tox .tox-pop.tox-pop--right::after {
  left: 100%;
  top: calc(50% + 1px);
  transform: translateY(-50%);
}
.tox .tox-pop.tox-pop--right::after {
  border-color: transparent transparent transparent #fff;
  border-width: 8px;
  margin-left: -1px;
}
.tox .tox-pop.tox-pop--right::before {
  border-color: transparent transparent transparent #eeeeee;
  border-width: 10px;
  margin-left: -1px;
}
.tox .tox-pop.tox-pop--align-left::before,
.tox .tox-pop.tox-pop--align-left::after {
  left: 20px;
}
.tox .tox-pop.tox-pop--align-right::before,
.tox .tox-pop.tox-pop--align-right::after {
  left: calc(100% - 20px);
}
.tox .tox-sidebar-wrap {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  min-height: 0;
}
.tox .tox-sidebar {
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.tox .tox-sidebar__slider {
  display: flex;
  overflow: hidden;
}
.tox .tox-sidebar__pane-container {
  display: flex;
}
.tox .tox-sidebar__pane {
  display: flex;
}
.tox .tox-sidebar--sliding-closed {
  opacity: 0;
}
.tox .tox-sidebar--sliding-open {
  opacity: 1;
}
.tox .tox-sidebar--sliding-growing,
.tox .tox-sidebar--sliding-shrinking {
  transition: width 0.5s ease, opacity 0.5s ease;
}
.tox .tox-selector {
  background-color: #4099ff;
  border-color: #4099ff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  display: inline-block;
  height: 10px;
  position: absolute;
  width: 10px;
}
.tox.tox-platform-touch .tox-selector {
  height: 12px;
  width: 12px;
}
.tox .tox-slider {
  align-items: center;
  display: flex;
  flex: 1;
  height: 24px;
  justify-content: center;
  position: relative;
}
.tox .tox-slider__rail {
  background-color: transparent;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  height: 10px;
  min-width: 120px;
  width: 100%;
}
.tox .tox-slider__handle {
  background-color: #006ce7;
  border: 2px solid #0054b4;
  border-radius: 6px;
  box-shadow: none;
  height: 24px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 14px;
}
.tox .tox-form__controls-h-stack > .tox-slider:not(:first-of-type) {
  margin-inline-start: 8px;
}
.tox .tox-form__controls-h-stack > .tox-form__group + .tox-slider {
  margin-inline-start: 32px;
}
.tox .tox-form__controls-h-stack > .tox-slider + .tox-form__group {
  margin-inline-start: 32px;
}
.tox .tox-source-code {
  overflow: auto;
}
.tox .tox-spinner {
  display: flex;
}
.tox .tox-spinner > div {
  animation: tam-bouncing-dots 1.5s ease-in-out 0s infinite both;
  background-color: rgba(34, 47, 62, 0.7);
  border-radius: 100%;
  height: 8px;
  width: 8px;
}
.tox .tox-spinner > div:nth-child(1) {
  animation-delay: -0.32s;
}
.tox .tox-spinner > div:nth-child(2) {
  animation-delay: -0.16s;
}
@keyframes tam-bouncing-dots {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.tox:not([dir=rtl]) .tox-spinner > div:not(:first-child) {
  margin-left: 4px;
}
.tox[dir=rtl] .tox-spinner > div:not(:first-child) {
  margin-right: 4px;
}
.tox .tox-statusbar {
  align-items: center;
  background-color: #fff;
  border-top: 1px solid #e3e3e3;
  color: rgba(34, 47, 62, 0.7);
  display: flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: normal;
  height: 25px;
  overflow: hidden;
  padding: 0 8px;
  position: relative;
  text-transform: none;
}
.tox .tox-statusbar__path {
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tox .tox-statusbar__right-container {
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;
}
.tox .tox-statusbar__help-text {
  text-align: center;
}
.tox .tox-statusbar__text-container {
  display: flex;
  flex: 1 1 auto;
  justify-content: space-between;
  overflow: hidden;
}
@media only screen and (min-width: 768px ) {
  .tox .tox-statusbar__text-container.tox-statusbar__text-container-3-cols > .tox-statusbar__help-text,
  .tox .tox-statusbar__text-container.tox-statusbar__text-container-3-cols > .tox-statusbar__right-container,
  .tox .tox-statusbar__text-container.tox-statusbar__text-container-3-cols > .tox-statusbar__path {
    flex: 0 0 calc(100% / 3);
  }
}
.tox .tox-statusbar__text-container.tox-statusbar__text-container--flex-end {
  justify-content: flex-end;
}
.tox .tox-statusbar__text-container.tox-statusbar__text-container--flex-start {
  justify-content: flex-start;
}
.tox .tox-statusbar__text-container.tox-statusbar__text-container--space-around {
  justify-content: space-around;
}
.tox .tox-statusbar__path > * {
  display: inline;
  white-space: nowrap;
}
.tox .tox-statusbar__wordcount {
  flex: 0 0 auto;
  margin-left: 1ch;
}
@media only screen and (max-width: 767px ) {
  .tox .tox-statusbar__text-container .tox-statusbar__help-text {
    display: none;
  }
  .tox .tox-statusbar__text-container .tox-statusbar__help-text:only-child {
    display: block;
  }
}
.tox .tox-statusbar a,
.tox .tox-statusbar__path-item,
.tox .tox-statusbar__wordcount {
  color: rgba(34, 47, 62, 0.7);
  -webkit-text-decoration: none;
  text-decoration: none;
}
.tox .tox-statusbar a:hover:not(:disabled):not([aria-disabled=true]),
.tox .tox-statusbar__path-item:hover:not(:disabled):not([aria-disabled=true]),
.tox .tox-statusbar__wordcount:hover:not(:disabled):not([aria-disabled=true]),
.tox .tox-statusbar a:focus:not(:disabled):not([aria-disabled=true]),
.tox .tox-statusbar__path-item:focus:not(:disabled):not([aria-disabled=true]),
.tox .tox-statusbar__wordcount:focus:not(:disabled):not([aria-disabled=true]) {
  color: #222f3e;
  cursor: pointer;
}
.tox .tox-statusbar__branding svg {
  fill: rgba(34, 47, 62, 0.8);
  height: 1.14em;
  vertical-align: -0.28em;
  width: 3.6em;
}
.tox .tox-statusbar__branding a:hover:not(:disabled):not([aria-disabled=true]) svg,
.tox .tox-statusbar__branding a:focus:not(:disabled):not([aria-disabled=true]) svg {
  fill: #222f3e;
}
.tox .tox-statusbar__resize-handle {
  align-items: flex-end;
  align-self: stretch;
  cursor: nwse-resize;
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: -8px;
  padding-bottom: 3px;
  padding-left: 1ch;
  padding-right: 3px;
}
.tox .tox-statusbar__resize-handle svg {
  display: block;
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-statusbar__resize-handle:focus svg {
  background-color: #dee0e2;
  border-radius: 1px 1px 5px 1px;
  box-shadow: 0 0 0 2px #dee0e2;
}
.tox:not([dir=rtl]) .tox-statusbar__path > * {
  margin-right: 4px;
}
.tox:not([dir=rtl]) .tox-statusbar__branding {
  margin-left: 2ch;
}
.tox[dir=rtl] .tox-statusbar {
  flex-direction: row-reverse;
}
.tox[dir=rtl] .tox-statusbar__path > * {
  margin-left: 4px;
}
.tox .tox-throbber {
  z-index: 1299;
}
.tox .tox-throbber__busy-spinner {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.tox .tox-tbtn {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 3px;
  box-shadow: none;
  color: #222f3e;
  display: flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  height: 28px;
  justify-content: center;
  margin: 6px 1px 5px 0;
  outline: none;
  overflow: hidden;
  padding: 0;
  text-transform: none;
  width: 34px;
}
.tox .tox-tbtn svg {
  display: block;
  fill: #222f3e;
}
.tox .tox-tbtn.tox-tbtn-more {
  padding-left: 5px;
  padding-right: 5px;
  width: inherit;
}
.tox .tox-tbtn:focus {
  background: #cce2fa;
  border: 0;
  box-shadow: none;
}
.tox .tox-tbtn:hover {
  background: #cce2fa;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-tbtn:hover svg {
  fill: #222f3e;
}
.tox .tox-tbtn:active {
  background: #a6ccf7;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-tbtn:active svg {
  fill: #222f3e;
}
.tox .tox-tbtn--disabled .tox-tbtn--enabled svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-tbtn--disabled,
.tox .tox-tbtn--disabled:hover,
.tox .tox-tbtn:disabled,
.tox .tox-tbtn:disabled:hover {
  background: transparent;
  border: 0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox .tox-tbtn--disabled svg,
.tox .tox-tbtn--disabled:hover svg,
.tox .tox-tbtn:disabled svg,
.tox .tox-tbtn:disabled:hover svg {
  /* stylelint-disable-line no-descending-specificity */
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-tbtn--enabled,
.tox .tox-tbtn--enabled:hover {
  background: #a6ccf7;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-tbtn--enabled > *,
.tox .tox-tbtn--enabled:hover > * {
  transform: none;
}
.tox .tox-tbtn--enabled svg,
.tox .tox-tbtn--enabled:hover svg {
  /* stylelint-disable-line no-descending-specificity */
  fill: #222f3e;
}
.tox .tox-tbtn--enabled.tox-tbtn--disabled svg,
.tox .tox-tbtn--enabled:hover.tox-tbtn--disabled svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) {
  color: #222f3e;
}
.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) svg {
  fill: #222f3e;
}
.tox .tox-tbtn:active > * {
  transform: none;
}
.tox .tox-tbtn--md {
  height: 42px;
  width: 51px;
}
.tox .tox-tbtn--lg {
  flex-direction: column;
  height: 56px;
  width: 68px;
}
.tox .tox-tbtn--return {
  align-self: stretch;
  height: unset;
  width: 16px;
}
.tox .tox-tbtn--labeled {
  padding: 0 4px;
  width: unset;
}
.tox .tox-tbtn__vlabel {
  display: block;
  font-size: 10px;
  font-weight: normal;
  letter-spacing: -0.025em;
  margin-bottom: 4px;
  white-space: nowrap;
}
.tox .tox-number-input {
  border-radius: 3px;
  display: flex;
  margin: 6px 1px 5px 0;
  padding: 0 4px;
  width: auto;
}
.tox .tox-number-input .tox-input-wrapper {
  background: #f7f7f7;
  display: flex;
  pointer-events: none;
  text-align: center;
}
.tox .tox-number-input .tox-input-wrapper:focus {
  background: #cce2fa;
}
.tox .tox-number-input input {
  border-radius: 3px;
  color: #222f3e;
  font-size: 14px;
  margin: 2px 0;
  pointer-events: all;
  width: 60px;
}
.tox .tox-number-input input:hover {
  background: #cce2fa;
  color: #222f3e;
}
.tox .tox-number-input input:focus {
  background: #fff;
  color: #222f3e;
}
.tox .tox-number-input input:disabled {
  background: transparent;
  border: 0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox .tox-number-input button {
  background: #f7f7f7;
  color: #222f3e;
  height: 28px;
  text-align: center;
  width: 24px;
}
.tox .tox-number-input button svg {
  display: block;
  fill: #222f3e;
  margin: 0 auto;
  transform: scale(0.67);
}
.tox .tox-number-input button:focus {
  background: #cce2fa;
}
.tox .tox-number-input button:hover {
  background: #cce2fa;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-number-input button:hover svg {
  fill: #222f3e;
}
.tox .tox-number-input button:active {
  background: #a6ccf7;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-number-input button:active svg {
  fill: #222f3e;
}
.tox .tox-number-input button:disabled {
  background: transparent;
  border: 0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox .tox-number-input button:disabled svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-number-input button.minus {
  border-radius: 3px 0 0 3px;
}
.tox .tox-number-input button.plus {
  border-radius: 0 3px 3px 0;
}
.tox .tox-number-input:focus:not(:active) > button,
.tox .tox-number-input:focus:not(:active) > .tox-input-wrapper {
  background: #cce2fa;
}
.tox .tox-tbtn--select {
  margin: 6px 1px 5px 0;
  padding: 0 4px;
  width: auto;
}
.tox .tox-tbtn__select-label {
  cursor: default;
  font-weight: normal;
  height: initial;
  margin: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tox .tox-tbtn__select-chevron {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 16px;
}
.tox .tox-tbtn__select-chevron svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-tbtn--bespoke {
  background: #f7f7f7;
}
.tox .tox-tbtn--bespoke + .tox-tbtn--bespoke {
  margin-inline-start: 4px;
}
.tox .tox-tbtn--bespoke .tox-tbtn__select-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 7em;
}
.tox .tox-tbtn--disabled .tox-tbtn__select-label,
.tox .tox-tbtn--select:disabled .tox-tbtn__select-label {
  cursor: not-allowed;
}
.tox .tox-split-button {
  border: 0;
  border-radius: 3px;
  box-sizing: border-box;
  display: flex;
  margin: 6px 1px 5px 0;
  overflow: hidden;
}
.tox .tox-split-button:hover {
  box-shadow: 0 0 0 1px #cce2fa inset;
}
.tox .tox-split-button:focus {
  background: #cce2fa;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-split-button > * {
  border-radius: 0;
}
.tox .tox-split-button__chevron {
  width: 16px;
}
.tox .tox-split-button__chevron svg {
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-split-button .tox-tbtn {
  margin: 0;
}
.tox .tox-split-button.tox-tbtn--disabled:hover,
.tox .tox-split-button.tox-tbtn--disabled:focus,
.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:hover,
.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:focus {
  background: transparent;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
}
.tox.tox-platform-touch .tox-split-button .tox-tbtn--select {
  padding: 0 0px;
}
.tox.tox-platform-touch .tox-split-button .tox-tbtn:not(.tox-tbtn--select):first-child {
  width: 30px;
}
.tox.tox-platform-touch .tox-split-button__chevron {
  width: 20px;
}
.tox .tox-split-button.tox-tbtn--disabled svg #tox-icon-text-color__color,
.tox .tox-split-button.tox-tbtn--disabled svg #tox-icon-highlight-bg-color__color {
  opacity: 0.6;
}
.tox .tox-toolbar-overlord {
  background-color: #fff;
}
.tox .tox-toolbar,
.tox .tox-toolbar__primary,
.tox .tox-toolbar__overflow {
  background-attachment: local;
  background-color: #fff;
  background-image: repeating-linear-gradient(#e3e3e3 0px 1px, transparent 1px 39px);
  background-position: center top 40px;
  background-repeat: no-repeat;
  background-size: calc(100% - 11px * 2) calc(100% - 41px);
  display: flex;
  flex: 0 0 auto;
  flex-shrink: 0;
  flex-wrap: wrap;
  padding: 0 0px;
  transform: perspective(1px);
}
.tox .tox-toolbar-overlord > .tox-toolbar,
.tox .tox-toolbar-overlord > .tox-toolbar__primary,
.tox .tox-toolbar-overlord > .tox-toolbar__overflow {
  background-position: center top 0px;
  background-size: calc(100% - 11px * 2) calc(100% - 0px);
}
.tox .tox-toolbar__overflow.tox-toolbar__overflow--closed {
  height: 0;
  opacity: 0;
  padding-bottom: 0;
  padding-top: 0;
  visibility: hidden;
}
.tox .tox-toolbar__overflow--growing {
  transition: height 0.3s ease, opacity 0.2s linear 0.1s;
}
.tox .tox-toolbar__overflow--shrinking {
  transition: opacity 0.3s ease, height 0.2s linear 0.1s, visibility 0s linear 0.3s;
}
.tox .tox-toolbar-overlord,
.tox .tox-anchorbar {
  grid-column: 1 / -1;
}
.tox .tox-menubar + .tox-toolbar,
.tox .tox-menubar + .tox-toolbar-overlord {
  border-top: 1px solid transparent;
  margin-top: -1px;
  padding-bottom: 1px;
  padding-top: 1px;
}
.tox .tox-toolbar--scrolling {
  flex-wrap: nowrap;
  overflow-x: auto;
}
.tox .tox-pop .tox-toolbar {
  border-width: 0;
}
.tox .tox-toolbar--no-divider {
  background-image: none;
}
.tox .tox-toolbar-overlord .tox-toolbar:not(.tox-toolbar--scrolling):first-child,
.tox .tox-toolbar-overlord .tox-toolbar__primary {
  background-position: center top 39px;
}
.tox .tox-editor-header > .tox-toolbar--scrolling,
.tox .tox-toolbar-overlord .tox-toolbar--scrolling:first-child {
  background-image: none;
}
.tox.tox-tinymce-aux .tox-toolbar__overflow {
  background-color: #fff;
  background-position: center top 43px;
  background-size: calc(100% - 8px * 2) calc(100% - 51px);
  border: none;
  border-radius: 6px;
  box-shadow: 0 0 2px 0 rgba(34, 47, 62, 0.2), 0 4px 8px 0 rgba(34, 47, 62, 0.15);
  overscroll-behavior: none;
  padding: 4px 0;
}
.tox-pop .tox-pop__dialog {
  /* stylelint-disable-next-line no-descending-specificity */
}
.tox-pop .tox-pop__dialog .tox-toolbar {
  background-position: center top 43px;
  background-size: calc(100% - 11px * 2) calc(100% - 51px);
  padding: 4px 0;
}
.tox .tox-toolbar__group {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 0 0;
  padding: 0 11px 0 12px;
}
.tox .tox-toolbar__group--pull-right {
  margin-left: auto;
}
.tox .tox-toolbar--scrolling .tox-toolbar__group {
  flex-shrink: 0;
  flex-wrap: nowrap;
}
.tox:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {
  border-right: 1px solid transparent;
}
.tox[dir=rtl] .tox-toolbar__group:not(:last-of-type) {
  border-left: 1px solid transparent;
}
.tox .tox-tooltip {
  display: inline-block;
  padding: 8px;
  position: relative;
}
.tox .tox-tooltip__body {
  background-color: #222f3e;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(34, 47, 62, 0.3);
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  padding: 4px 8px;
  text-transform: none;
}
.tox .tox-tooltip__arrow {
  position: absolute;
}
.tox .tox-tooltip--down .tox-tooltip__arrow {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #222f3e;
  bottom: 0;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}
.tox .tox-tooltip--up .tox-tooltip__arrow {
  border-bottom: 8px solid #222f3e;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  left: 50%;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
}
.tox .tox-tooltip--right .tox-tooltip__arrow {
  border-bottom: 8px solid transparent;
  border-left: 8px solid #222f3e;
  border-top: 8px solid transparent;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.tox .tox-tooltip--left .tox-tooltip__arrow {
  border-bottom: 8px solid transparent;
  border-right: 8px solid #222f3e;
  border-top: 8px solid transparent;
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.tox .tox-tree {
  display: flex;
  flex-direction: column;
}
.tox .tox-tree .tox-trbtn {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 4px;
  box-shadow: none;
  color: #222f3e;
  display: flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  height: 28px;
  margin-bottom: 4px;
  margin-top: 4px;
  outline: none;
  overflow: hidden;
  padding: 0;
  padding-left: 8px;
  text-transform: none;
}
.tox .tox-tree .tox-trbtn .tox-tree__label {
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tox .tox-tree .tox-trbtn svg {
  display: block;
  fill: #222f3e;
}
.tox .tox-tree .tox-trbtn:focus {
  background: #cce2fa;
  border: 0;
  box-shadow: none;
}
.tox .tox-tree .tox-trbtn:hover {
  background: #cce2fa;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-tree .tox-trbtn:hover svg {
  fill: #222f3e;
}
.tox .tox-tree .tox-trbtn:active {
  background: #a6ccf7;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-tree .tox-trbtn:active svg {
  fill: #222f3e;
}
.tox .tox-tree .tox-trbtn--disabled,
.tox .tox-tree .tox-trbtn--disabled:hover,
.tox .tox-tree .tox-trbtn:disabled,
.tox .tox-tree .tox-trbtn:disabled:hover {
  background: transparent;
  border: 0;
  box-shadow: none;
  color: rgba(34, 47, 62, 0.5);
  cursor: not-allowed;
}
.tox .tox-tree .tox-trbtn--disabled svg,
.tox .tox-tree .tox-trbtn--disabled:hover svg,
.tox .tox-tree .tox-trbtn:disabled svg,
.tox .tox-tree .tox-trbtn:disabled:hover svg {
  /* stylelint-disable-line no-descending-specificity */
  fill: rgba(34, 47, 62, 0.5);
}
.tox .tox-tree .tox-trbtn--enabled,
.tox .tox-tree .tox-trbtn--enabled:hover {
  background: #a6ccf7;
  border: 0;
  box-shadow: none;
  color: #222f3e;
}
.tox .tox-tree .tox-trbtn--enabled > *,
.tox .tox-tree .tox-trbtn--enabled:hover > * {
  transform: none;
}
.tox .tox-tree .tox-trbtn--enabled svg,
.tox .tox-tree .tox-trbtn--enabled:hover svg {
  /* stylelint-disable-line no-descending-specificity */
  fill: #222f3e;
}
.tox .tox-tree .tox-trbtn:focus:not(.tox-trbtn--disabled) {
  color: #222f3e;
}
.tox .tox-tree .tox-trbtn:focus:not(.tox-trbtn--disabled) svg {
  fill: #222f3e;
}
.tox .tox-tree .tox-trbtn:active > * {
  transform: none;
}
.tox .tox-tree .tox-trbtn--return {
  align-self: stretch;
  height: unset;
  width: 16px;
}
.tox .tox-tree .tox-trbtn--labeled {
  padding: 0 4px;
  width: unset;
}
.tox .tox-tree .tox-trbtn__vlabel {
  display: block;
  font-size: 10px;
  font-weight: normal;
  letter-spacing: -0.025em;
  margin-bottom: 4px;
  white-space: nowrap;
}
.tox .tox-tree .tox-tree--directory {
  display: flex;
  flex-direction: column;
  /* stylelint-disable no-descending-specificity */
}
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label {
  font-weight: bold;
}
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label .tox-mbtn {
  margin-left: auto;
}
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label .tox-mbtn svg {
  fill: transparent;
}
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label .tox-mbtn.tox-mbtn--active svg,
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label .tox-mbtn:focus svg {
  fill: #222f3e;
}
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label:hover .tox-mbtn svg,
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label:focus .tox-mbtn svg {
  fill: #222f3e;
}
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label:hover:has(.tox-mbtn:hover) {
  background-color: transparent;
  color: #222f3e;
}
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label:hover:has(.tox-mbtn:hover) .tox-chevron svg {
  fill: #222f3e;
}
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label .tox-chevron {
  margin-right: 6px;
}
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label:has(+ .tox-tree--directory__children--growing) .tox-chevron,
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label:has(+ .tox-tree--directory__children--shrinking) .tox-chevron {
  transition: transform 0.5s ease-in-out;
}
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label:has(+ .tox-tree--directory__children--growing) .tox-chevron,
.tox .tox-tree .tox-tree--directory .tox-tree--directory__label:has(+ .tox-tree--directory__children--open) .tox-chevron {
  transform: rotate(90deg);
}
.tox .tox-tree .tox-tree--leaf__label {
  font-weight: normal;
}
.tox .tox-tree .tox-tree--leaf__label .tox-mbtn {
  margin-left: auto;
}
.tox .tox-tree .tox-tree--leaf__label .tox-mbtn svg {
  fill: transparent;
}
.tox .tox-tree .tox-tree--leaf__label .tox-mbtn.tox-mbtn--active svg,
.tox .tox-tree .tox-tree--leaf__label .tox-mbtn:focus svg {
  fill: #222f3e;
}
.tox .tox-tree .tox-tree--leaf__label:hover .tox-mbtn svg {
  fill: #222f3e;
}
.tox .tox-tree .tox-tree--leaf__label:hover:has(.tox-mbtn:hover) {
  background-color: transparent;
  color: #222f3e;
}
.tox .tox-tree .tox-tree--leaf__label:hover:has(.tox-mbtn:hover) .tox-chevron svg {
  fill: #222f3e;
}
.tox .tox-tree .tox-tree--directory__children {
  overflow: hidden;
  padding-left: 16px;
}
.tox .tox-tree .tox-tree--directory__children.tox-tree--directory__children--growing,
.tox .tox-tree .tox-tree--directory__children.tox-tree--directory__children--shrinking {
  transition: height 0.5s ease-in-out;
}
.tox .tox-tree .tox-trbtn.tox-tree--leaf__label {
  display: flex;
  justify-content: space-between;
}
.tox .tox-view-wrap,
.tox .tox-view-wrap__slot-container {
  background-color: #fff;
  display: flex;
  flex: 1;
  flex-direction: column;
}
.tox .tox-view {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
}
.tox .tox-view__header {
  align-items: center;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  padding: 8px 8px 0 8px;
  position: relative;
}
.tox .tox-view--mobile.tox-view__header,
.tox .tox-view--mobile.tox-view__toolbar {
  padding: 8px;
}
.tox .tox-view--scrolling {
  flex-wrap: nowrap;
  overflow-x: auto;
}
.tox .tox-view__toolbar {
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  padding: 8px 8px 0 8px;
}
.tox .tox-view__toolbar__group {
  display: flex;
  flex-direction: row;
  gap: 12px;
}
.tox .tox-view__header-start,
.tox .tox-view__header-end {
  display: flex;
}
.tox .tox-view__pane {
  height: 100%;
  padding: 8px;
  width: 100%;
}
.tox .tox-view__pane_panel {
  border: 1px solid #eeeeee;
  border-radius: 6px;
}
.tox:not([dir=rtl]) .tox-view__header .tox-view__header-start > *,
.tox:not([dir=rtl]) .tox-view__header .tox-view__header-end > * {
  margin-left: 8px;
}
.tox[dir=rtl] .tox-view__header .tox-view__header-start > *,
.tox[dir=rtl] .tox-view__header .tox-view__header-end > * {
  margin-right: 8px;
}
.tox .tox-well {
  border: 1px solid #eeeeee;
  border-radius: 6px;
  padding: 8px;
  width: 100%;
}
.tox .tox-well > *:first-child {
  margin-top: 0;
}
.tox .tox-well > *:last-child {
  margin-bottom: 0;
}
.tox .tox-well > *:only-child {
  margin: 0;
}
.tox .tox-custom-editor {
  border: 1px solid #eeeeee;
  border-radius: 6px;
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;
}
/* stylelint-disable */
.tox {
  /* stylelint-enable */
}
.tox .tox-dialog-loading::before {
  background-color: rgba(0, 0, 0, 0.5);
  content: "";
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1000;
}
.tox .tox-tab {
  cursor: pointer;
}
.tox .tox-dialog__content-js {
  display: flex;
  flex: 1;
}
.tox .tox-dialog__body-content .tox-collection {
  display: flex;
  flex: 1;
}
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #0a58ca;
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}
[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}
body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}
h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}
h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}
h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}
h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}
h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}
h5, .h5 {
  font-size: 1.25rem;
}
h6, .h6 {
  font-size: 1rem;
}
p {
  margin-top: 0;
  margin-bottom: 1rem;
}
abbr[title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}
address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}
ol,
ul {
  padding-left: 2rem;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}
dt {
  font-weight: 700;
}
dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
blockquote {
  margin: 0 0 1rem;
}
b,
strong {
  font-weight: bolder;
}
small, .small {
  font-size: 0.875em;
}
mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}
sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}
a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  -webkit-text-decoration: none;
  text-decoration: none;
}
pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}
pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}
code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}
kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}
figure {
  margin: 0 0 1rem;
}
img,
svg {
  vertical-align: middle;
}
table {
  caption-side: bottom;
  border-collapse: collapse;
}
caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}
th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}
thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}
label {
  display: inline-block;
}
button {
  border-radius: 0;
}
button:focus:not(:focus-visible) {
  outline: 0;
}
input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
button,
select {
  text-transform: none;
}
[role=button] {
  cursor: pointer;
}
select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}
[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}
::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
textarea {
  resize: vertical;
}
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}
::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}
::-webkit-inner-spin-button {
  height: auto;
}
[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-color-swatch-wrapper {
  padding: 0;
}
::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}
output {
  display: inline-block;
}
iframe {
  border: 0;
}
summary {
  display: list-item;
  cursor: pointer;
}
progress {
  vertical-align: baseline;
}
[hidden] {
  display: none !important;
}
.lead {
  font-size: 1.25rem;
  font-weight: 300;
}
.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
.list-inline {
  padding-left: 0;
  list-style: none;
}
.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}
.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}
.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}
.figure {
  display: inline-block;
}
.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}
.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}
.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}
.col {
  flex: 1 0 0%;
}
.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}
.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}
.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}
.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}
.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}
.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.col-auto {
  flex: 0 0 auto;
  width: auto;
}
.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}
.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.col-3 {
  flex: 0 0 auto;
  width: 25%;
}
.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}
.col-6 {
  flex: 0 0 auto;
  width: 50%;
}
.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}
.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}
.col-9 {
  flex: 0 0 auto;
  width: 75%;
}
.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}
.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}
.col-12 {
  flex: 0 0 auto;
  width: 100%;
}
.offset-1 {
  margin-left: 8.33333333%;
}
.offset-2 {
  margin-left: 16.66666667%;
}
.offset-3 {
  margin-left: 25%;
}
.offset-4 {
  margin-left: 33.33333333%;
}
.offset-5 {
  margin-left: 41.66666667%;
}
.offset-6 {
  margin-left: 50%;
}
.offset-7 {
  margin-left: 58.33333333%;
}
.offset-8 {
  margin-left: 66.66666667%;
}
.offset-9 {
  margin-left: 75%;
}
.offset-10 {
  margin-left: 83.33333333%;
}
.offset-11 {
  margin-left: 91.66666667%;
}
.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}
.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}
.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}
.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}
.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}
.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}
.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}
.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}
.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}
.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}
.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}
.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}
@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0%;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0%;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0%;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0%;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0%;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}
.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}
.caption-top {
  caption-side: top;
}
.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}
.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}
.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}
.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}
.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}
.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}
.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}
.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #a6b5cc;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #b5b6b7;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #a7b9b1;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #a6c3ca;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #ccc2a4;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #c6acae;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #c6c7c8;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #4d5154;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}
.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}
.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}
.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  -webkit-appearance: none;
          appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}
.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}
.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}
.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}
textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}
.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}
.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  -webkit-appearance: none;
          appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}
.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}
.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}
.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  -webkit-appearance: none;
          appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}
.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}
.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}
.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .gform_wrapper .btn-check[disabled] + input[type=submit], .gform_wrapper .btn-check[disabled] + .button, .btn-check:disabled + .btn, .gform_wrapper .btn-check:disabled + input[type=submit], .gform_wrapper .btn-check:disabled + .button {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}
[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  -webkit-appearance: none;
          appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  -webkit-appearance: none;
          appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}
.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}
.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn, .input-group .gform_wrapper input[type=submit], .gform_wrapper .input-group input[type=submit], .input-group .gform_wrapper .button, .gform_wrapper .input-group .button {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus, .input-group .gform_wrapper input[type=submit]:focus, .gform_wrapper .input-group input[type=submit]:focus, .input-group .gform_wrapper .button:focus, .gform_wrapper .input-group .button:focus {
  z-index: 5;
}
.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}
.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn,
.gform_wrapper .input-group-lg > input[type=submit],
.gform_wrapper .input-group-lg > .button {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn,
.gform_wrapper .input-group-sm > input[type=submit],
.gform_wrapper .input-group-sm > .button {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}
.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}
.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}
.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}
.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}
.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}
.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}
.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}
.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}
.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}
.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}
.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}
.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}
.btn, .gform_wrapper input[type=submit], .gform_wrapper .button {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn, .gform_wrapper input[type=submit], .gform_wrapper .button {
    transition: none;
  }
}
.btn:hover, .gform_wrapper input[type=submit]:hover, .gform_wrapper .button:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover, .gform_wrapper .btn-check + input[type=submit]:hover, .gform_wrapper .btn-check + .button:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible, .gform_wrapper input[type=submit]:focus-visible, .gform_wrapper .button:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn, .gform_wrapper .btn-check:focus-visible + input[type=submit], .gform_wrapper .btn-check:focus-visible + .button {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, .gform_wrapper .btn-check:checked + input[type=submit], .gform_wrapper .btn-check:checked + .button, :not(.btn-check) + .btn:active, .gform_wrapper :not(.btn-check) + input[type=submit]:active, .gform_wrapper :not(.btn-check) + .button:active, .btn:first-child:active, .gform_wrapper input[type=submit]:first-child:active, .gform_wrapper .button:first-child:active, .btn.active, .gform_wrapper input.active[type=submit], .gform_wrapper .active.button, .btn.show, .gform_wrapper input.show[type=submit], .gform_wrapper .show.button {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, .gform_wrapper .btn-check:checked + input[type=submit]:focus-visible, .gform_wrapper .btn-check:checked + .button:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .gform_wrapper :not(.btn-check) + input[type=submit]:active:focus-visible, .gform_wrapper :not(.btn-check) + .button:active:focus-visible, .btn:first-child:active:focus-visible, .gform_wrapper input[type=submit]:first-child:active:focus-visible, .gform_wrapper .button:first-child:active:focus-visible, .btn.active:focus-visible, .gform_wrapper input.active[type=submit]:focus-visible, .gform_wrapper .active.button:focus-visible, .btn.show:focus-visible, .gform_wrapper input.show[type=submit]:focus-visible, .gform_wrapper .show.button:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .gform_wrapper input[type=submit]:disabled, .gform_wrapper .button:disabled, .btn.disabled, .gform_wrapper input.disabled[type=submit], .gform_wrapper .disabled.button, fieldset:disabled .btn, fieldset:disabled .gform_wrapper input[type=submit], .gform_wrapper fieldset:disabled input[type=submit], fieldset:disabled .gform_wrapper .button, .gform_wrapper fieldset:disabled .button {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}
.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b5ed7;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}
.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c636a;
  --bs-btn-hover-border-color: #565e64;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565e64;
  --bs-btn-active-border-color: #51585e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}
.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}
.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #31d2f2;
  --bs-btn-hover-border-color: #25cff2;
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3dd5f3;
  --bs-btn-active-border-color: #25cff2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}
.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}
.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}
.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}
.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}
.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}
.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}
.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}
.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}
.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}
.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}
.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}
.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}
.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}
.btn-lg, .btn-group-lg > .btn, .gform_wrapper .btn-group-lg > input[type=submit], .gform_wrapper .btn-group-lg > .button {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}
.btn-sm, .btn-group-sm > .btn, .gform_wrapper .btn-group-sm > input[type=submit], .gform_wrapper .btn-group-sm > .button {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}
.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}
.collapse:not(.show) {
  display: none;
}
.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}
.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}
.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}
.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}
.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}
@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}
.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}
.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}
.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  -webkit-text-decoration: none;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}
.dropdown-menu.show {
  display: block;
}
.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}
.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}
.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn, .gform_wrapper .btn-group > input[type=submit], .gform_wrapper .btn-group > .button,
.btn-group-vertical > .btn,
.gform_wrapper .btn-group-vertical > input[type=submit],
.gform_wrapper .btn-group-vertical > .button {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn, .gform_wrapper .btn-group > .btn-check:checked + input[type=submit], .gform_wrapper .btn-group > .btn-check:checked + .button,
.btn-group > .btn-check:focus + .btn,
.gform_wrapper .btn-group > .btn-check:focus + input[type=submit],
.gform_wrapper .btn-group > .btn-check:focus + .button,
.btn-group > .btn:hover,
.gform_wrapper .btn-group > input[type=submit]:hover,
.gform_wrapper .btn-group > .button:hover,
.btn-group > .btn:focus,
.gform_wrapper .btn-group > input[type=submit]:focus,
.gform_wrapper .btn-group > .button:focus,
.btn-group > .btn:active,
.gform_wrapper .btn-group > input[type=submit]:active,
.gform_wrapper .btn-group > .button:active,
.btn-group > .btn.active,
.gform_wrapper .btn-group > input.active[type=submit],
.gform_wrapper .btn-group > .active.button,
.btn-group-vertical > .btn-check:checked + .btn,
.gform_wrapper .btn-group-vertical > .btn-check:checked + input[type=submit],
.gform_wrapper .btn-group-vertical > .btn-check:checked + .button,
.btn-group-vertical > .btn-check:focus + .btn,
.gform_wrapper .btn-group-vertical > .btn-check:focus + input[type=submit],
.gform_wrapper .btn-group-vertical > .btn-check:focus + .button,
.btn-group-vertical > .btn:hover,
.gform_wrapper .btn-group-vertical > input[type=submit]:hover,
.gform_wrapper .btn-group-vertical > .button:hover,
.btn-group-vertical > .btn:focus,
.gform_wrapper .btn-group-vertical > input[type=submit]:focus,
.gform_wrapper .btn-group-vertical > .button:focus,
.btn-group-vertical > .btn:active,
.gform_wrapper .btn-group-vertical > input[type=submit]:active,
.gform_wrapper .btn-group-vertical > .button:active,
.btn-group-vertical > .btn.active,
.gform_wrapper .btn-group-vertical > input.active[type=submit],
.gform_wrapper .btn-group-vertical > .active.button {
  z-index: 1;
}
.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}
.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn, .gform_wrapper .btn-group > :not(.btn-check:first-child) + input[type=submit], .gform_wrapper .btn-group > :not(.btn-check:first-child) + .button,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle), .gform_wrapper .btn-group > input[type=submit]:not(:last-child):not(.dropdown-toggle), .gform_wrapper .btn-group > .button:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.gform_wrapper .btn-group > input.dropdown-toggle-split[type=submit]:first-child,
.gform_wrapper .btn-group > .dropdown-toggle-split.button:first-child,
.btn-group > .btn-group:not(:last-child) > .btn,
.gform_wrapper .btn-group > .btn-group:not(:last-child) > input[type=submit],
.gform_wrapper .btn-group > .btn-group:not(:last-child) > .button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3), .gform_wrapper .btn-group > input[type=submit]:nth-child(n+3), .gform_wrapper .btn-group > .button:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.gform_wrapper .btn-group > :not(.btn-check) + input[type=submit],
.gform_wrapper .btn-group > :not(.btn-check) + .button,
.btn-group > .btn-group:not(:first-child) > .btn,
.gform_wrapper .btn-group > .btn-group:not(:first-child) > input[type=submit],
.gform_wrapper .btn-group > .btn-group:not(:first-child) > .button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}
.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split, .gform_wrapper .btn-group-sm > input[type=submit] + .dropdown-toggle-split, .gform_wrapper .btn-group-sm > .button + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}
.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split, .gform_wrapper .btn-group-lg > input[type=submit] + .dropdown-toggle-split, .gform_wrapper .btn-group-lg > .button + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn, .gform_wrapper .btn-group-vertical > input[type=submit], .gform_wrapper .btn-group-vertical > .button,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child), .gform_wrapper .btn-group-vertical > input[type=submit]:not(:first-child), .gform_wrapper .btn-group-vertical > .button:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle), .gform_wrapper .btn-group-vertical > input[type=submit]:not(:last-child):not(.dropdown-toggle), .gform_wrapper .btn-group-vertical > .button:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn,
.gform_wrapper .btn-group-vertical > .btn-group:not(:last-child) > input[type=submit],
.gform_wrapper .btn-group-vertical > .btn-group:not(:last-child) > .button {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn, .gform_wrapper .btn-group-vertical > input[type=submit] ~ .btn, .gform_wrapper .btn-group-vertical > .btn ~ input[type=submit], .gform_wrapper .btn-group-vertical > input[type=submit] ~ input[type=submit], .gform_wrapper .btn-group-vertical > .button ~ .btn, .gform_wrapper .btn-group-vertical > .button ~ input[type=submit], .gform_wrapper .btn-group-vertical > .btn ~ .button, .gform_wrapper .btn-group-vertical > input[type=submit] ~ .button, .gform_wrapper .btn-group-vertical > .button ~ .button,
.btn-group-vertical > .btn-group:not(:first-child) > .btn,
.gform_wrapper .btn-group-vertical > .btn-group:not(:first-child) > input[type=submit],
.gform_wrapper .btn-group-vertical > .btn-group:not(:first-child) > .button {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  -webkit-text-decoration: none;
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}
.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}
.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}
.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}
.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}
.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}
.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}
.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  -webkit-text-decoration: none;
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}
.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}
.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}
.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}
.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  -webkit-text-decoration: none;
  text-decoration: none;
}
.navbar-toggler:focus {
  -webkit-text-decoration: none;
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}
.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}
.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}
.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}
.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}
.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}
.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}
.card-text:last-child {
  margin-bottom: 0;
}
.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}
.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}
.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}
.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}
.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}
.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}
.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}
.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}
.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --bs-accordion-btn-focus-border-color: #86b7fe;
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}
.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}
.accordion-header {
  margin-bottom: 0;
}
.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}
.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}
[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}
.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}
.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}
.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}
.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}
.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}
.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}
.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}
.btn .badge, .gform_wrapper input[type=submit] .badge, .gform_wrapper .button .badge {
  position: relative;
  top: -1px;
}
.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}
.alert-heading {
  color: inherit;
}
.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}
.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}
.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}
.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}
.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}
.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}
.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}
.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}
.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}
.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}
@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}
.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}
.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}
.progress-stacked > .progress {
  overflow: visible;
}
.progress-stacked > .progress > .progress-bar {
  width: 100%;
}
.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}
.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}
.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}
.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}
.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}
.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}
@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}
.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}
.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}
.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}
.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}
.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}
.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}
.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}
.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}
.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  -webkit-text-decoration: none;
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}
.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}
[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}
.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}
.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}
.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}
.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}
.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}
.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}
.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}
.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}
.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}
.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}
.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}
.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}
@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}
@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}
.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}
/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}
/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}
/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}
/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}
.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}
.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}
/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}
/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}
/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}
/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}
.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}
.carousel {
  position: relative;
}
.carousel.pointer-event {
  touch-action: pan-y;
}
.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}
.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}
.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}
.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}
.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}
.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}
.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  -webkit-text-decoration: none;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}
.carousel-control-prev {
  left: 0;
}
.carousel-control-next {
  right: 0;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}
/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}
.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}
.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}
[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}
.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}
.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}
@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}
.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}
@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}
@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}
.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}
.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}
.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}
.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}
.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before, .gform_wrapper input.placeholder[type=submit]::before, .gform_wrapper .placeholder.button::before {
  display: inline-block;
  content: "";
}
.placeholder-xs {
  min-height: 0.6em;
}
.placeholder-sm {
  min-height: 0.8em;
}
.placeholder-lg {
  min-height: 1.2em;
}
.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}
@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
          mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}
@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}
.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}
.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}
.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}
.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}
.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}
.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}
.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}
.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}
.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}
.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}
.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}
.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}
.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}
.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}
.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}
.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}
.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}
.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}
.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}
.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}
@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}
.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}
.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}
.align-baseline {
  vertical-align: baseline !important;
}
.align-top {
  vertical-align: top !important;
}
.align-middle {
  vertical-align: middle !important;
}
.align-bottom {
  vertical-align: bottom !important;
}
.align-text-bottom {
  vertical-align: text-bottom !important;
}
.align-text-top {
  vertical-align: text-top !important;
}
.float-start {
  float: left !important;
}
.float-end {
  float: right !important;
}
.float-none {
  float: none !important;
}
.object-fit-contain {
  object-fit: contain !important;
}
.object-fit-cover {
  object-fit: cover !important;
}
.object-fit-fill {
  object-fit: fill !important;
}
.object-fit-scale {
  object-fit: scale-down !important;
}
.object-fit-none {
  object-fit: none !important;
}
.opacity-0 {
  opacity: 0 !important;
}
.opacity-25 {
  opacity: 0.25 !important;
}
.opacity-50 {
  opacity: 0.5 !important;
}
.opacity-75 {
  opacity: 0.75 !important;
}
.opacity-100 {
  opacity: 1 !important;
}
.overflow-auto {
  overflow: auto !important;
}
.overflow-hidden {
  overflow: hidden !important;
}
.overflow-visible {
  overflow: visible !important;
}
.overflow-scroll {
  overflow: scroll !important;
}
.overflow-x-auto {
  overflow-x: auto !important;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.overflow-x-visible {
  overflow-x: visible !important;
}
.overflow-x-scroll {
  overflow-x: scroll !important;
}
.overflow-y-auto {
  overflow-y: auto !important;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-y-visible {
  overflow-y: visible !important;
}
.overflow-y-scroll {
  overflow-y: scroll !important;
}
.d-inline {
  display: inline !important;
}
.d-inline-block {
  display: inline-block !important;
}
.d-block {
  display: block !important;
}
.d-grid {
  display: grid !important;
}
.d-inline-grid {
  display: inline-grid !important;
}
.d-table {
  display: table !important;
}
.d-table-row {
  display: table-row !important;
}
.d-table-cell {
  display: table-cell !important;
}
.d-flex {
  display: flex !important;
}
.d-inline-flex {
  display: inline-flex !important;
}
.d-none {
  display: none !important;
}
.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}
.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}
.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}
.shadow-none {
  box-shadow: none !important;
}
.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}
.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}
.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}
.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}
.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}
.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}
.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}
.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}
.position-static {
  position: static !important;
}
.position-relative {
  position: relative !important;
}
.position-absolute {
  position: absolute !important;
}
.position-fixed {
  position: fixed !important;
}
.position-sticky {
  position: sticky !important;
}
.top-0 {
  top: 0 !important;
}
.top-50 {
  top: 50% !important;
}
.top-100 {
  top: 100% !important;
}
.bottom-0 {
  bottom: 0 !important;
}
.bottom-50 {
  bottom: 50% !important;
}
.bottom-100 {
  bottom: 100% !important;
}
.start-0 {
  left: 0 !important;
}
.start-50 {
  left: 50% !important;
}
.start-100 {
  left: 100% !important;
}
.end-0 {
  right: 0 !important;
}
.end-50 {
  right: 50% !important;
}
.end-100 {
  right: 100% !important;
}
.translate-middle {
  transform: translate(-50%, -50%) !important;
}
.translate-middle-x {
  transform: translateX(-50%) !important;
}
.translate-middle-y {
  transform: translateY(-50%) !important;
}
.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.border-0 {
  border: 0 !important;
}
.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.border-top-0 {
  border-top: 0 !important;
}
.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.border-end-0 {
  border-right: 0 !important;
}
.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.border-bottom-0 {
  border-bottom: 0 !important;
}
.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.border-start-0 {
  border-left: 0 !important;
}
.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}
.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}
.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}
.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}
.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}
.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}
.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}
.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}
.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}
.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}
.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}
.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}
.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}
.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}
.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}
.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}
.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}
.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}
.border-1 {
  border-width: 1px !important;
}
.border-2 {
  border-width: 2px !important;
}
.border-3 {
  border-width: 3px !important;
}
.border-4 {
  border-width: 4px !important;
}
.border-5 {
  border-width: 5px !important;
}
.border-opacity-10 {
  --bs-border-opacity: 0.1;
}
.border-opacity-25 {
  --bs-border-opacity: 0.25;
}
.border-opacity-50 {
  --bs-border-opacity: 0.5;
}
.border-opacity-75 {
  --bs-border-opacity: 0.75;
}
.border-opacity-100 {
  --bs-border-opacity: 1;
}
.w-25 {
  width: 25% !important;
}
.w-50 {
  width: 50% !important;
}
.w-75 {
  width: 75% !important;
}
.w-100 {
  width: 100% !important;
}
.w-auto {
  width: auto !important;
}
.mw-100 {
  max-width: 100% !important;
}
.vw-100 {
  width: 100vw !important;
}
.min-vw-100 {
  min-width: 100vw !important;
}
.h-25 {
  height: 25% !important;
}
.h-50 {
  height: 50% !important;
}
.h-75 {
  height: 75% !important;
}
.h-100 {
  height: 100% !important;
}
.h-auto {
  height: auto !important;
}
.mh-100 {
  max-height: 100% !important;
}
.vh-100 {
  height: 100vh !important;
}
.min-vh-100 {
  min-height: 100vh !important;
}
.flex-fill {
  flex: 1 1 auto !important;
}
.flex-row {
  flex-direction: row !important;
}
.flex-column {
  flex-direction: column !important;
}
.flex-row-reverse {
  flex-direction: row-reverse !important;
}
.flex-column-reverse {
  flex-direction: column-reverse !important;
}
.flex-grow-0 {
  flex-grow: 0 !important;
}
.flex-grow-1 {
  flex-grow: 1 !important;
}
.flex-shrink-0 {
  flex-shrink: 0 !important;
}
.flex-shrink-1 {
  flex-shrink: 1 !important;
}
.flex-wrap {
  flex-wrap: wrap !important;
}
.flex-nowrap {
  flex-wrap: nowrap !important;
}
.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}
.justify-content-start {
  justify-content: flex-start !important;
}
.justify-content-end {
  justify-content: flex-end !important;
}
.justify-content-center {
  justify-content: center !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.justify-content-around {
  justify-content: space-around !important;
}
.justify-content-evenly {
  justify-content: space-evenly !important;
}
.align-items-start {
  align-items: flex-start !important;
}
.align-items-end {
  align-items: flex-end !important;
}
.align-items-center {
  align-items: center !important;
}
.align-items-baseline {
  align-items: baseline !important;
}
.align-items-stretch {
  align-items: stretch !important;
}
.align-content-start {
  align-content: flex-start !important;
}
.align-content-end {
  align-content: flex-end !important;
}
.align-content-center {
  align-content: center !important;
}
.align-content-between {
  align-content: space-between !important;
}
.align-content-around {
  align-content: space-around !important;
}
.align-content-stretch {
  align-content: stretch !important;
}
.align-self-auto {
  align-self: auto !important;
}
.align-self-start {
  align-self: flex-start !important;
}
.align-self-end {
  align-self: flex-end !important;
}
.align-self-center {
  align-self: center !important;
}
.align-self-baseline {
  align-self: baseline !important;
}
.align-self-stretch {
  align-self: stretch !important;
}
.order-first {
  order: -1 !important;
}
.order-0 {
  order: 0 !important;
}
.order-1 {
  order: 1 !important;
}
.order-2 {
  order: 2 !important;
}
.order-3 {
  order: 3 !important;
}
.order-4 {
  order: 4 !important;
}
.order-5 {
  order: 5 !important;
}
.order-last {
  order: 6 !important;
}
.m-0 {
  margin: 0 !important;
}
.m-1 {
  margin: 0.25rem !important;
}
.m-2 {
  margin: 0.5rem !important;
}
.m-3 {
  margin: 1rem !important;
}
.m-4 {
  margin: 1.5rem !important;
}
.m-5 {
  margin: 3rem !important;
}
.m-auto {
  margin: auto !important;
}
.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}
.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}
.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}
.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}
.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}
.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}
.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}
.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.mt-1 {
  margin-top: 0.25rem !important;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.mt-3 {
  margin-top: 1rem !important;
}
.mt-4 {
  margin-top: 1.5rem !important;
}
.mt-5 {
  margin-top: 3rem !important;
}
.mt-auto {
  margin-top: auto !important;
}
.me-0 {
  margin-right: 0 !important;
}
.me-1 {
  margin-right: 0.25rem !important;
}
.me-2 {
  margin-right: 0.5rem !important;
}
.me-3 {
  margin-right: 1rem !important;
}
.me-4 {
  margin-right: 1.5rem !important;
}
.me-5 {
  margin-right: 3rem !important;
}
.me-auto {
  margin-right: auto !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.mb-1 {
  margin-bottom: 0.25rem !important;
}
.mb-2 {
  margin-bottom: 0.5rem !important;
}
.mb-3 {
  margin-bottom: 1rem !important;
}
.mb-4 {
  margin-bottom: 1.5rem !important;
}
.mb-5 {
  margin-bottom: 3rem !important;
}
.mb-auto {
  margin-bottom: auto !important;
}
.ms-0 {
  margin-left: 0 !important;
}
.ms-1 {
  margin-left: 0.25rem !important;
}
.ms-2 {
  margin-left: 0.5rem !important;
}
.ms-3 {
  margin-left: 1rem !important;
}
.ms-4 {
  margin-left: 1.5rem !important;
}
.ms-5 {
  margin-left: 3rem !important;
}
.ms-auto {
  margin-left: auto !important;
}
.p-0 {
  padding: 0 !important;
}
.p-1 {
  padding: 0.25rem !important;
}
.p-2 {
  padding: 0.5rem !important;
}
.p-3 {
  padding: 1rem !important;
}
.p-4 {
  padding: 1.5rem !important;
}
.p-5 {
  padding: 3rem !important;
}
.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}
.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}
.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}
.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}
.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
.pt-0 {
  padding-top: 0 !important;
}
.pt-1 {
  padding-top: 0.25rem !important;
}
.pt-2 {
  padding-top: 0.5rem !important;
}
.pt-3 {
  padding-top: 1rem !important;
}
.pt-4 {
  padding-top: 1.5rem !important;
}
.pt-5 {
  padding-top: 3rem !important;
}
.pe-0 {
  padding-right: 0 !important;
}
.pe-1 {
  padding-right: 0.25rem !important;
}
.pe-2 {
  padding-right: 0.5rem !important;
}
.pe-3 {
  padding-right: 1rem !important;
}
.pe-4 {
  padding-right: 1.5rem !important;
}
.pe-5 {
  padding-right: 3rem !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pb-1 {
  padding-bottom: 0.25rem !important;
}
.pb-2 {
  padding-bottom: 0.5rem !important;
}
.pb-3 {
  padding-bottom: 1rem !important;
}
.pb-4 {
  padding-bottom: 1.5rem !important;
}
.pb-5 {
  padding-bottom: 3rem !important;
}
.ps-0 {
  padding-left: 0 !important;
}
.ps-1 {
  padding-left: 0.25rem !important;
}
.ps-2 {
  padding-left: 0.5rem !important;
}
.ps-3 {
  padding-left: 1rem !important;
}
.ps-4 {
  padding-left: 1.5rem !important;
}
.ps-5 {
  padding-left: 3rem !important;
}
.gap-0 {
  gap: 0 !important;
}
.gap-1 {
  gap: 0.25rem !important;
}
.gap-2 {
  gap: 0.5rem !important;
}
.gap-3 {
  gap: 1rem !important;
}
.gap-4 {
  gap: 1.5rem !important;
}
.gap-5 {
  gap: 3rem !important;
}
.row-gap-0 {
  row-gap: 0 !important;
}
.row-gap-1 {
  row-gap: 0.25rem !important;
}
.row-gap-2 {
  row-gap: 0.5rem !important;
}
.row-gap-3 {
  row-gap: 1rem !important;
}
.row-gap-4 {
  row-gap: 1.5rem !important;
}
.row-gap-5 {
  row-gap: 3rem !important;
}
.column-gap-0 {
  -moz-column-gap: 0 !important;
       column-gap: 0 !important;
}
.column-gap-1 {
  -moz-column-gap: 0.25rem !important;
       column-gap: 0.25rem !important;
}
.column-gap-2 {
  -moz-column-gap: 0.5rem !important;
       column-gap: 0.5rem !important;
}
.column-gap-3 {
  -moz-column-gap: 1rem !important;
       column-gap: 1rem !important;
}
.column-gap-4 {
  -moz-column-gap: 1.5rem !important;
       column-gap: 1.5rem !important;
}
.column-gap-5 {
  -moz-column-gap: 3rem !important;
       column-gap: 3rem !important;
}
.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}
.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}
.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}
.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}
.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}
.fs-5 {
  font-size: 1.25rem !important;
}
.fs-6 {
  font-size: 1rem !important;
}
.fst-italic {
  font-style: italic !important;
}
.fst-normal {
  font-style: normal !important;
}
.fw-lighter {
  font-weight: lighter !important;
}
.fw-light {
  font-weight: 300 !important;
}
.fw-normal {
  font-weight: 400 !important;
}
.fw-medium {
  font-weight: 500 !important;
}
.fw-semibold {
  font-weight: 600 !important;
}
.fw-bold {
  font-weight: 700 !important;
}
.fw-bolder {
  font-weight: bolder !important;
}
.lh-1 {
  line-height: 1 !important;
}
.lh-sm {
  line-height: 1.25 !important;
}
.lh-base {
  line-height: 1.5 !important;
}
.lh-lg {
  line-height: 2 !important;
}
.text-start {
  text-align: left !important;
}
.text-end {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
.text-decoration-none {
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
}
.text-decoration-underline {
  -webkit-text-decoration: underline !important;
  text-decoration: underline !important;
}
.text-decoration-line-through {
  -webkit-text-decoration: line-through !important;
  text-decoration: line-through !important;
}
.text-lowercase {
  text-transform: lowercase !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.text-wrap {
  white-space: normal !important;
}
.text-nowrap {
  white-space: nowrap !important;
}
/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}
/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}
.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}
.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}
.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}
.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}
.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}
.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}
.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}
.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}
.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}
.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}
.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}
.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}
.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}
.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}
.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}
.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}
.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}
.text-opacity-25 {
  --bs-text-opacity: 0.25;
}
.text-opacity-50 {
  --bs-text-opacity: 0.5;
}
.text-opacity-75 {
  --bs-text-opacity: 0.75;
}
.text-opacity-100 {
  --bs-text-opacity: 1;
}
.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}
.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}
.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}
.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}
.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}
.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}
.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}
.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}
.link-opacity-10 {
  --bs-link-opacity: 0.1;
}
.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}
.link-opacity-25 {
  --bs-link-opacity: 0.25;
}
.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}
.link-opacity-50 {
  --bs-link-opacity: 0.5;
}
.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}
.link-opacity-75 {
  --bs-link-opacity: 0.75;
}
.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}
.link-opacity-100 {
  --bs-link-opacity: 1;
}
.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}
.link-offset-1 {
  text-underline-offset: 0.125em !important;
}
.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}
.link-offset-2 {
  text-underline-offset: 0.25em !important;
}
.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}
.link-offset-3 {
  text-underline-offset: 0.375em !important;
}
.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}
.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}
.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}
.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}
.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}
.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}
.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}
.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}
.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}
.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}
.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}
.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}
.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}
.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}
.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}
.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}
.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}
.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}
.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}
.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}
.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}
.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}
.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}
.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}
.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}
.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}
.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}
.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}
.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}
.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}
.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}
.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}
.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}
.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}
.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}
.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}
.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}
.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}
.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}
.bg-opacity-100 {
  --bs-bg-opacity: 1;
}
.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}
.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}
.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}
.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}
.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}
.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}
.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}
.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}
.bg-gradient {
  background-image: var(--bs-gradient) !important;
}
.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}
.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}
.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}
.pe-none {
  pointer-events: none !important;
}
.pe-auto {
  pointer-events: auto !important;
}
.rounded {
  border-radius: var(--bs-border-radius) !important;
}
.rounded-0 {
  border-radius: 0 !important;
}
.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}
.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}
.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}
.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}
.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}
.rounded-circle {
  border-radius: 50% !important;
}
.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}
.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}
.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}
.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}
.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}
.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}
.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}
.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}
.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}
.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}
.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}
.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}
.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}
.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}
.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}
.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}
.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}
.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}
.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}
.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}
.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}
.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}
.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}
.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}
.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}
.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}
.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}
.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}
.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}
.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}
.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}
.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}
.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
.z-n1 {
  z-index: -1 !important;
}
.z-0 {
  z-index: 0 !important;
}
.z-1 {
  z-index: 1 !important;
}
.z-2 {
  z-index: 2 !important;
}
.z-3 {
  z-index: 3 !important;
}
@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }
  .column-gap-md-1 {
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
.splide__container {
  box-sizing: border-box;
  position: relative;
}
.splide__list {
  backface-visibility: hidden;
  display: flex;
  height: 100%;
  margin: 0 !important;
  padding: 0 !important;
}
.splide.is-initialized:not(.is-active) .splide__list {
  display: block;
}
.splide__pagination {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
  pointer-events: none;
}
.splide__pagination li {
  display: inline-block;
  line-height: 1;
  list-style-type: none;
  margin: 0;
  pointer-events: auto;
}
.splide:not(.is-overflow) .splide__pagination {
  display: none;
}
.splide__progress__bar {
  width: 0;
}
.splide {
  position: relative;
  visibility: hidden;
}
.splide.is-initialized, .splide.is-rendered {
  visibility: visible;
}
.splide__slide {
  backface-visibility: hidden;
  box-sizing: border-box;
  flex-shrink: 0;
  list-style-type: none !important;
  margin: 0;
  position: relative;
}
.splide__slide img {
  vertical-align: bottom;
}
.splide__spinner {
  animation: splide-loading 1s linear infinite;
  border: 2px solid #999;
  border-left-color: transparent;
  border-radius: 50%;
  bottom: 0;
  contain: strict;
  display: inline-block;
  height: 20px;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
}
.splide__sr {
  clip: rect(0 0 0 0);
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.splide__toggle.is-active .splide__toggle__play, .splide__toggle__pause {
  display: none;
}
.splide__toggle.is-active .splide__toggle__pause {
  display: inline;
}
.splide__track {
  overflow: hidden;
  position: relative;
  z-index: 0;
}
@keyframes splide-loading {
  0% {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
.splide__track--draggable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
.splide__track--fade > .splide__list > .splide__slide {
  margin: 0 !important;
  opacity: 0;
  z-index: 0;
}
.splide__track--fade > .splide__list > .splide__slide.is-active {
  opacity: 1;
  z-index: 1;
}
.splide--rtl {
  direction: rtl;
}
.splide__track--ttb > .splide__list {
  display: block;
}
.splide__arrow {
  align-items: center;
  background: #ccc;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 2em;
  justify-content: center;
  opacity: 0.7;
  padding: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 2em;
  z-index: 1;
}
.splide__arrow svg {
  fill: #000;
  height: 1.2em;
  width: 1.2em;
}
.splide__arrow:hover:not(:disabled) {
  opacity: 0.9;
}
.splide__arrow:disabled {
  opacity: 0.3;
}
.splide__arrow:focus-visible {
  outline: 3px solid #0bf;
  outline-offset: 3px;
}
.splide__arrow--prev {
  left: 1em;
}
.splide__arrow--prev svg {
  transform: scaleX(-1);
}
.splide__arrow--next {
  right: 1em;
}
.splide.is-focus-in .splide__arrow:focus {
  outline: 3px solid #0bf;
  outline-offset: 3px;
}
.splide__pagination {
  bottom: 0.5em;
  left: 0;
  padding: 0 1em;
  position: absolute;
  right: 0;
  z-index: 1;
}
.splide__pagination__page {
  background: #ccc;
  border: 0;
  border-radius: 50%;
  display: inline-block;
  height: 8px;
  margin: 3px;
  opacity: 0.7;
  padding: 0;
  position: relative;
  transition: transform 0.2s linear;
  width: 8px;
}
.splide__pagination__page.is-active {
  background: #fff;
  transform: scale(1.4);
  z-index: 1;
}
.splide__pagination__page:hover {
  cursor: pointer;
  opacity: 0.9;
}
.splide__pagination__page:focus-visible {
  outline: 3px solid #0bf;
  outline-offset: 3px;
}
.splide.is-focus-in .splide__pagination__page:focus {
  outline: 3px solid #0bf;
  outline-offset: 3px;
}
.splide__progress__bar {
  background: #ccc;
  height: 3px;
}
.splide__slide {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.splide__slide:focus {
  outline: 0;
}
@supports (outline-offset: -3px) {
  .splide__slide:focus-visible {
    outline: 3px solid #0bf;
    outline-offset: -3px;
  }
}
@media screen and (-ms-high-contrast: none) {
  .splide__slide:focus-visible {
    border: 3px solid #0bf;
  }
}
@supports (outline-offset: -3px) {
  .splide.is-focus-in .splide__slide:focus {
    outline: 3px solid #0bf;
    outline-offset: -3px;
  }
}
@media screen and (-ms-high-contrast: none) {
  .splide.is-focus-in .splide__slide:focus {
    border: 3px solid #0bf;
  }
  .splide.is-focus-in .splide__track > .splide__list > .splide__slide:focus {
    border-color: #0bf;
  }
}
.splide__toggle {
  cursor: pointer;
}
.splide__toggle:focus-visible {
  outline: 3px solid #0bf;
  outline-offset: 3px;
}
.splide.is-focus-in .splide__toggle:focus {
  outline: 3px solid #0bf;
  outline-offset: 3px;
}
.splide__track--nav > .splide__list > .splide__slide {
  border: 3px solid transparent;
  cursor: pointer;
}
.splide__track--nav > .splide__list > .splide__slide.is-active {
  border: 3px solid #000;
}
.splide__arrows--rtl .splide__arrow--prev {
  left: auto;
  right: 1em;
}
.splide__arrows--rtl .splide__arrow--prev svg {
  transform: scaleX(1);
}
.splide__arrows--rtl .splide__arrow--next {
  left: 1em;
  right: auto;
}
.splide__arrows--rtl .splide__arrow--next svg {
  transform: scaleX(-1);
}
.splide__arrows--ttb .splide__arrow {
  left: 50%;
  transform: translate(-50%);
}
.splide__arrows--ttb .splide__arrow--prev {
  top: 1em;
}
.splide__arrows--ttb .splide__arrow--prev svg {
  transform: rotate(-90deg);
}
.splide__arrows--ttb .splide__arrow--next {
  bottom: 1em;
  top: auto;
}
.splide__arrows--ttb .splide__arrow--next svg {
  transform: rotate(90deg);
}
.splide__pagination--ttb {
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: auto;
  padding: 1em 0;
  right: 0.5em;
  top: 0;
}
.text-red {
  color: #f65d5d;
}
.text-violet {
  color: #4b4b95;
}
.text-orange {
  color: #f29a5f;
}
.text-salmon {
  color: #d27366;
}
.text-sky {
  color: #5f9fe7;
}
.text-pink {
  color: #d16bb7;
}
.text-green {
  color: #51ad9d;
}
.text-peach {
  color: #ffc1af;
}
.fw-400 {
  font-weight: 400 !important;
}
.fw-500 {
  font-weight: 500 !important;
}
.fw-700 {
  font-weight: 700 !important;
}
.fw-900 {
  font-weight: 900 !important;
}
body {
  font-family: "museo-sans", serif;
  background-color: #131113;
}
body img {
  pointer-events: none;
}
body a {
  color: #261722;
  text-underline-offset: 0.1em;
  word-wrap: break-word;
  transition: color 0.35s;
}
body a:hover {
  color: #f65d5d;
}
body main {
  background-color: #ffffff;
}
body main > div:not(.page-header-wrapper):not(.vue-component) {
  min-height: calc(100vh - 610px);
}
.text-sm {
  font-size: 0.68rem;
  font-weight: 600;
}
.btn, .gform_wrapper input[type=submit], .gform_wrapper .button {
  --btnFgColor: red;
  --btnBgColor: white;
  padding: 0.75rem 2.15rem;
  border-radius: 2rem;
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  position: relative;
  background-color: var(--btnFgColor);
  border: 2px solid var(--btnFgColor);
  color: var(--btnBgColor);
  --bs-btn-disabled-bg: var(--btnFgColor);
  --bs-btn-disabled-border-color: var(--btnFgColor);
  --bs-btn-disabled-color: var(--btnBgColor);
}
@media (max-width: 1023.98px) {
  .btn, .gform_wrapper input[type=submit], .gform_wrapper .button {
    padding: 0.75rem 1.25rem;
  }
}
@media (max-width: 575.98px) {
  .btn, .gform_wrapper input[type=submit], .gform_wrapper .button {
    padding: 0.75rem 1.15rem;
  }
}
.btn:hover, .gform_wrapper input[type=submit]:hover, .gform_wrapper .button:hover, .btn:active, .gform_wrapper input[type=submit]:active, .gform_wrapper .button:active {
  color: var(--btnFgColor);
  background-color: var(--btnBgColor);
  border-color: var(--btnFgColor);
}
.btn.btn-red, .gform_wrapper input[type=submit], .gform_wrapper .btn-red.button {
  --btnFgColor: #f65d5d;
  --btnBgColor: #ffffff;
}
.btn.btn-pink, .gform_wrapper input.btn-pink[type=submit], .gform_wrapper .btn-pink.button {
  --btnFgColor: #d16bb7;
  --btnBgColor: #ffffff;
}
.btn.btn-salmon, .gform_wrapper input.btn-salmon[type=submit], .gform_wrapper .btn-salmon.button {
  --btnFgColor: #d27366;
  --btnBgColor: #fbc8bb;
}
.btn.btn-salmon:not(:hover), .gform_wrapper input.btn-salmon[type=submit]:not(:hover), .gform_wrapper .btn-salmon.button:not(:hover), .btn.btn-salmon:disabled, .gform_wrapper input.btn-salmon[type=submit]:disabled, .gform_wrapper .btn-salmon.button:disabled {
  color: #ffffff;
}
.btn.btn-white, .gform_wrapper input.btn-white[type=submit], .gform_wrapper .btn-white.button {
  --btnFgColor: #ffffff;
  --btnBgColor: #9ea3b8;
}
.btn.btn-salmon-inv, .gform_wrapper input.btn-salmon-inv[type=submit], .gform_wrapper .btn-salmon-inv.button {
  --btnFgColor: #fbc8bb;
  --btnBgColor: #d27366;
  --bs-btn-disabled-border-color: var(--btnBgColor);
  border: 2px solid var(--btnBgColor);
}
.btn.btn-red-inv, .gform_wrapper input.btn-red-inv[type=submit], .gform_wrapper .btn-red-inv.button {
  --btnBgColor: #f65d5d;
  --btnFgColor: #ffffff;
  --bs-btn-disabled-border-color: var(--btnBgColor);
  border: 2px solid var(--btnBgColor);
}
.btn.btn-orange, .gform_wrapper input.btn-orange[type=submit], .gform_wrapper .btn-orange.button {
  --btnFgColor: #f29a5f;
  --btnBgColor: #fedfc1;
}
.btn.btn-orange-inv, .gform_wrapper input.btn-orange-inv[type=submit], .gform_wrapper .btn-orange-inv.button {
  --btnFgColor: #fedfc1;
  --btnBgColor: #f29a5f;
  --bs-btn-disabled-border-color: var(--btnBgColor);
}
.btn.btn-orange-inv:hover, .gform_wrapper input.btn-orange-inv[type=submit]:hover, .gform_wrapper .btn-orange-inv.button:hover {
  border: 2px solid var(--btnBgColor);
}
.btn.btn-blue, .gform_wrapper input.btn-blue[type=submit], .gform_wrapper .btn-blue.button {
  --btnFgColor: #4b4b95;
  --btnBgColor: #ffffff;
}
.btn.btn-blue-inv, .gform_wrapper input.btn-blue-inv[type=submit], .gform_wrapper .btn-blue-inv.button {
  --btnFgColor: #ffffff;
  --btnBgColor: #4b4b95;
  --bs-btn-disabled-border-color: var(--btnBgColor);
  border: 2px solid var(--btnBgColor);
}
.btn.btn-gray, .gform_wrapper input.btn-gray[type=submit], .gform_wrapper .btn-gray.button {
  --btnFgColor: #9ea3b8;
  --btnBgColor: #ffffff;
}
.btn.btn-gray-inv, .gform_wrapper input.btn-gray-inv[type=submit], .gform_wrapper .btn-gray-inv.button {
  --btnFgColor: #ffffff;
  --btnBgColor: #9ea3b8;
  --bs-btn-disabled-border-color: var(--btnBgColor);
  border: 2px solid var(--btnBgColor);
}
.btn.btn-white, .gform_wrapper input.btn-white[type=submit], .gform_wrapper .btn-white.button {
  --btnFgColor: #ffffff;
  --btnBgColor: #f65d5d;
}
.btn.btn-white-inv, .gform_wrapper input.btn-white-inv[type=submit], .gform_wrapper .btn-white-inv.button {
  --btnFgColor: #f65d5d;
  --btnBgColor: #ffffff;
  --bs-btn-disabled-border-color: var(--btnBgColor);
  border: 2px solid var(--btnBgColor);
}
.btn.btn-black, .gform_wrapper input.btn-black[type=submit], .gform_wrapper .btn-black.button {
  --btnFgColor: #261722;
  --btnBgColor: #ffffff;
}
.btn.btn-pagecolor, .gform_wrapper input.btn-pagecolor[type=submit], .gform_wrapper .btn-pagecolor.button {
  --btnFgColor: var(--pageFgColor);
  --btnBgColor: var(--pageBgColor);
}
.btn.btn-pagecolor-white, .gform_wrapper input.btn-pagecolor-white[type=submit], .gform_wrapper .btn-pagecolor-white.button {
  --btnFgColor: var(--pageFgColor);
  --btnBgColor: #ffffff;
}
.btn.btn-pagecolor-inv, .gform_wrapper input.btn-pagecolor-inv[type=submit], .gform_wrapper .btn-pagecolor-inv.button {
  --btnFgColor: var(--pageBgColor);
  --btnBgColor: var(--pageFgColor);
  border: 2px solid var(--btnBgColor);
}
.btn.btn-pagecolor-inv-white, .gform_wrapper input.btn-pagecolor-inv-white[type=submit], .gform_wrapper .btn-pagecolor-inv-white.button {
  --btnFgColor: var(--pageBgColor);
  --btnBgColor: #ffffff;
}
.btn.btn-xs, .gform_wrapper input.btn-xs[type=submit], .gform_wrapper .btn-xs.button {
  padding: 0.25rem 1.15rem;
  border-radius: 1.8rem;
}
.btn.btn-sm, .gform_wrapper input.btn-sm[type=submit], .gform_wrapper .btn-sm.button, .btn-group-sm > .btn, .gform_wrapper .btn-group-sm > input[type=submit], .gform_wrapper .btn-group-sm > .button {
  padding: 0.45rem 1.35rem;
  border-radius: 2.8rem;
}
.btn.btn-lg, .gform_wrapper input.btn-lg[type=submit], .gform_wrapper .btn-lg.button, .btn-group-lg > .btn, .gform_wrapper .btn-group-lg > input[type=submit], .gform_wrapper .btn-group-lg > .button {
  padding: 1.35rem 2.35rem;
  border-radius: 2.8rem;
  line-height: 1em;
  font-size: calc(20vw/5);
}
@media (min-width: 576px) {
  .btn.btn-lg, .gform_wrapper input.btn-lg[type=submit], .gform_wrapper .btn-lg.button, .btn-group-lg > .btn, .gform_wrapper .btn-group-lg > input[type=submit], .gform_wrapper .btn-group-lg > .button {
    font-size: calc(20vw/8);
  }
}
@media (min-width: 768px) {
  .btn.btn-lg, .gform_wrapper input.btn-lg[type=submit], .gform_wrapper .btn-lg.button, .btn-group-lg > .btn, .gform_wrapper .btn-group-lg > input[type=submit], .gform_wrapper .btn-group-lg > .button {
    font-size: calc(20vw/10);
  }
}
@media (min-width: 1024px) {
  .btn.btn-lg, .gform_wrapper input.btn-lg[type=submit], .gform_wrapper .btn-lg.button, .btn-group-lg > .btn, .gform_wrapper .btn-group-lg > input[type=submit], .gform_wrapper .btn-group-lg > .button {
    font-size: calc(20vw/14);
  }
}
@media (min-width: 1200px) {
  .btn.btn-lg, .gform_wrapper input.btn-lg[type=submit], .gform_wrapper .btn-lg.button, .btn-group-lg > .btn, .gform_wrapper .btn-group-lg > input[type=submit], .gform_wrapper .btn-group-lg > .button {
    font-size: 20px;
  }
}
.btn.btn-dropdown, .gform_wrapper input.btn-dropdown[type=submit], .gform_wrapper .btn-dropdown.button {
  background-color: #ffffff;
  border: none;
  color: #9ea3b8;
  text-transform: none;
  border-radius: 10px;
  padding: 0.8rem 1.2rem;
  font-weight: 400;
  text-align: left;
  font-size: 1.25rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-size: 0.8rem;
  background-repeat: no-repeat;
  background-position: right 1.2rem center;
  padding-right: 2.85rem;
}
.btn.btn-dropdown.show, .gform_wrapper input.btn-dropdown.show[type=submit], .gform_wrapper .btn-dropdown.show.button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.btn.btn-dropdown::after, .gform_wrapper input.btn-dropdown[type=submit]::after, .gform_wrapper .btn-dropdown.button::after {
  content: "";
  display: none;
}
.btn.btn-dropdown:hover, .gform_wrapper input.btn-dropdown[type=submit]:hover, .gform_wrapper .btn-dropdown.button:hover {
  background-color: #e7e8f0;
}
.btn:disabled, .gform_wrapper input[type=submit]:disabled, .gform_wrapper .button:disabled {
  opacity: 0.4;
}
.btn.has-icon, .gform_wrapper input.has-icon[type=submit], .gform_wrapper .has-icon.button {
  padding-left: 6rem;
}
.btn.has-icon .icon, .gform_wrapper input.has-icon[type=submit] .icon, .gform_wrapper .has-icon.button .icon {
  display: inline-block;
  position: absolute;
  top: 20%;
  left: 32px;
  height: 56%;
  aspect-ratio: 1;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--btnBgColor);
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  transition: background-color 0.2s;
}
.btn.has-icon .icon.icon-community, .gform_wrapper input.has-icon[type=submit] .icon.icon-community, .gform_wrapper .has-icon.button .icon.icon-community {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
          mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.btn.has-icon:hover .icon, .gform_wrapper input.has-icon[type=submit]:hover .icon, .gform_wrapper .has-icon.button:hover .icon {
  background-color: var(--btnFgColor);
}
.btn.btn-more, .gform_wrapper input.btn-more[type=submit], .gform_wrapper .btn-more.button {
  border-width: 1px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn.btn-more.btn-sm, .gform_wrapper input.btn-more.btn-sm[type=submit], .gform_wrapper .btn-more.btn-sm.button, .btn-group-sm > .btn.btn-more, .gform_wrapper .btn-group-sm > input.btn-more[type=submit], .gform_wrapper .btn-group-sm > .btn-more.button {
  width: 1.65rem;
  height: 1.65rem;
  font-size: 0.65rem;
}
.btn-round {
  height: 40px;
  width: 40px;
  border-radius: 20px;
  border: 0;
  padding: inherit;
  font-size: 1rem;
}
.btn-round-lg {
  height: 3.25rem;
  width: 3.25rem;
  border-radius: 3.25rem;
}
.btn-round-lg {
  height: 3.25rem;
  width: 3.25rem;
  border-radius: 3.25rem;
  font-size: 1.2rem;
  padding: 12px 0;
}
.field-wrapper input.is-invalid,
.field-wrapper select.is-invalid {
  border: 2px solid #dc3545 !important;
}
.field-wrapper input[type=checkbox].is-invalid {
  outline: 2px solid #dc3545 !important;
}
.border-error {
  border: 2px solid #f65d5d;
}
.sticky-col {
  position: sticky;
  top: 5.75rem;
}
.dropdown-menu {
  margin-top: 0.5rem !important;
  border: 0;
  box-shadow: 0px 0px 3px 1px rgba(68, 68, 68, 0.15);
  max-height: 30rem;
  overflow-y: scroll;
}
.dropdown-menu::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 0.5rem;
  background-color: #ffffff;
}
.dropdown-menu::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: lightgray;
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.75);
}
.dropdown-menu > li a {
  padding: 0.65rem 1.2rem;
}
.dropdown-menu > li a:hover {
  background-color: #e7e8f0;
}
.text-pagecolor {
  color: var(--pageFgColor);
}
.link-pagecolor {
  color: var(--pageFgColor);
}
.link-pagecolor:hover {
  color: var(--pageFgColor);
}
.border-pagecolor {
  color: var(--pageFgColor);
}
.custom-form .form-group, .vue-kit-order-widget .form-group {
  margin-top: 0.8rem;
}
.custom-form .form-group .form-control, .vue-kit-order-widget .form-group .form-control,
.custom-form .form-group select.form-select,
.vue-kit-order-widget .form-group select.form-select {
  background-color: #e7e8f0;
  border-color: #e7e8f0 default;
  border-radius: 10px;
  padding: 0.8rem 1.2rem;
  font-size: 1.25rem;
}
.custom-form .form-group input.form-check-input, .vue-kit-order-widget .form-group input.form-check-input {
  background-color: #e7e8f0;
  border: 0;
  width: 1.2em;
  height: 1.2em;
  margin-top: 0.1em;
}
.custom-form .form-group input.form-check-input:checked, .vue-kit-order-widget .form-group input.form-check-input:checked {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.custom-form .form-group label.form-label, .vue-kit-order-widget .form-group label.form-label {
  font-size: 0.8rem;
  text-transform: uppercase;
  color: #4b4b95;
  font-weight: 600;
  margin-bottom: 0;
}
.custom-form .form-group .ci.ci-eye-slash, .vue-kit-order-widget .form-group .ci.ci-eye-slash {
  font-size: 1.35rem;
  position: relative;
  top: 5px;
  margin-right: 0.35rem;
}
.custom-form .form-group .input-group .btn, .custom-form .form-group .input-group .gform_wrapper input[type=submit], .gform_wrapper .custom-form .form-group .input-group input[type=submit], .custom-form .form-group .input-group .gform_wrapper .button, .gform_wrapper .custom-form .form-group .input-group .button, .vue-kit-order-widget .form-group .input-group .btn, .vue-kit-order-widget .form-group .input-group .gform_wrapper input[type=submit], .gform_wrapper .vue-kit-order-widget .form-group .input-group input[type=submit], .vue-kit-order-widget .form-group .input-group .gform_wrapper .button, .gform_wrapper .vue-kit-order-widget .form-group .input-group .button {
  background-color: #e7e8f0;
  border-radius: 10px;
  border: 0;
  color: #9ea3b8;
}
.custom-form .form-group .search-control, .vue-kit-order-widget .form-group .search-control {
  background-color: #ffffff;
  border: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  background-size: 1.45rem;
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 2.85rem;
}
.custom-form .form-group .search-control::placeholder, .vue-kit-order-widget .form-group .search-control::placeholder {
  color: #9ea3b8;
  opacity: 1;
}
.custom-form .form-group.btn-combined, .vue-kit-order-widget .form-group.btn-combined {
  position: relative;
}
.custom-form .form-group.btn-combined .btn, .custom-form .form-group.btn-combined .gform_wrapper input[type=submit], .gform_wrapper .custom-form .form-group.btn-combined input[type=submit], .custom-form .form-group.btn-combined .gform_wrapper .button, .gform_wrapper .custom-form .form-group.btn-combined .button, .vue-kit-order-widget .form-group.btn-combined .btn, .vue-kit-order-widget .form-group.btn-combined .gform_wrapper input[type=submit], .gform_wrapper .vue-kit-order-widget .form-group.btn-combined input[type=submit], .vue-kit-order-widget .form-group.btn-combined .gform_wrapper .button, .gform_wrapper .vue-kit-order-widget .form-group.btn-combined .button {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
}
.custom-form .color-chooser .color, .vue-kit-order-widget .color-chooser .color {
  --thisColor: #f65d5d;
  width: 2.8rem;
  height: 2.8rem;
  border: 0.65rem solid #e7e8f0;
  background-color: var(--thisColor);
  border-radius: 4rem;
  transition: border-color 0.3s;
  cursor: pointer;
}
.custom-form .color-chooser .color.selected, .vue-kit-order-widget .color-chooser .color.selected {
  outline: 1px solid #4b4b95;
}
.custom-form .color-chooser .color.blue, .vue-kit-order-widget .color-chooser .color.blue {
  --thisColor: #bad4fe;
}
.custom-form .color-chooser .color.pink, .vue-kit-order-widget .color-chooser .color.pink {
  --thisColor: #ffd7f3;
}
.custom-form .color-chooser .color.yellow, .vue-kit-order-widget .color-chooser .color.yellow {
  --thisColor: #fedfc1;
}
.custom-form .color-chooser .color.salmon, .vue-kit-order-widget .color-chooser .color.salmon {
  --thisColor: #fbc8bb;
}
.custom-form .color-chooser .color.green, .vue-kit-order-widget .color-chooser .color.green {
  --thisColor: #c2efc8;
}
.custom-form .color-chooser .color:not(.selected):hover, .vue-kit-order-widget .color-chooser .color:not(.selected):hover {
  border-color: var(--thisColor);
}
label.violet-label {
  font-size: 0.8rem;
  text-transform: uppercase;
  color: #4b4b95;
  font-weight: 600;
  margin-bottom: 0;
}
.user-profile-box .avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  margin-right: 0.5rem;
  background-size: cover;
  background-position: center center;
}
@media (max-width: 575.98px) {
  .user-profile-box .avatar {
    width: 50px;
    height: 50px;
  }
}
.user-profile-box .user-info {
  overflow: hidden;
  width: calc(100% - 110px);
}
.user-profile-box .user-info p.username {
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
}
@media (max-width: 575.98px) {
  .user-profile-box .user-info p.username {
    font-size: 1.25rem;
  }
}
.user-profile-box .user-info p.social-info {
  font-size: 0.65rem;
  font-weight: 700;
  margin: 0;
  -webkit-user-select: none;
          user-select: none;
}
@media (max-width: 575.98px) {
  .user-profile-box .user-info p.social-info {
    font-size: 0.75rem;
  }
}
.user-profile-box .user-info p.social-info .icon-followers {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  margin-bottom: -5px;
}
.splide.no-navigation .splide__arrow {
  display: none;
}
.splide.no-pagination .splide__pagination {
  display: none;
}
.custom-navigation .splide-controls {
  display: flex;
  justify-content: center;
  --controlsColor: #d27366;
}
.custom-navigation .splide-controls .splide__arrow {
  display: block;
  width: 60px;
  height: 60px;
  margin: 0 0.5rem;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid var(--controlsColor);
  position: static;
  background: none;
  transform: none;
  color: var(--controlsColor);
  font-size: 3.5rem;
  transition: background-color 0.5s, opacity 0.5s;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.custom-navigation .splide-controls .splide__arrow i.ci {
  position: relative;
  bottom: 0.5rem;
}
.custom-navigation .splide-controls .splide__arrow:not(:disabled):hover {
  background-color: var(--controlsColor);
  color: #ffffff;
}
.custom-navigation .splide-controls .splide__arrow:not(:disabled):active {
  opacity: 0.5;
}
.custom-navigation .splide-controls .splide__pagination {
  position: static;
}
.custom-navigation .splide-controls .splide__pagination li > * {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--controlsColor);
  opacity: 0.35;
  transition: opacity 500ms;
  margin: 0 0.5rem;
  cursor: pointer;
}
.custom-navigation .splide-controls .splide__pagination li > *.is-active {
  opacity: 1;
  transform: none;
}
.custom-navigation .splide-controls .splide__pagination li > *:hover {
  opacity: 1;
}
@media (max-width: 575.98px) {
  .custom-navigation .splide-controls .splide__pagination {
    display: none;
  }
}
.custom-navigation.archive-pagination .splide-controls .splide__arrow {
  width: 3rem;
  height: 3rem;
  margin: 0 1rem;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-navigation.archive-pagination .splide-controls .splide__arrow .ci {
  position: static;
}
.custom-navigation.archive-pagination li {
  line-height: 15px;
}
.custom-navigation.archive-pagination li > * {
  font-weight: 600;
  font-size: 1.15rem;
  background: none !important;
  width: auto !important;
  -webkit-text-decoration: none;
  text-decoration: none;
  position: relative;
}
@media (min-width: 1200px) {
  .custom-navigation.archive-pagination li > * {
    margin: 0 0.85rem !important;
  }
}
.custom-navigation.archive-pagination li > *.is-active::after, .custom-navigation.archive-pagination li > *:hover::after {
  content: " ";
  position: absolute;
  bottom: -1rem;
  background-color: #f65d5d;
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  left: calc(50% - 0.15rem);
}
.bg-cover {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.bg-contain {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.ci.ci-nudge::before {
  position: relative;
  left: 1px;
  top: 1px;
}
.ci.ci-flip-x::before {
  display: inline-block;
  transform: rotateY(180deg);
}
.ci.ci-flip-y::before {
  display: inline-block;
  transform: rotateX(180deg);
}
.custom-splide-pagination button {
  display: block;
  width: 60px;
  height: 60px;
  margin: 0 0.5rem;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 500ms;
  background-color: rgba(95, 159, 231, 0.85);
  border: 2px solid rgba(95, 159, 231, 0.85);
  color: #ffffff;
  font-size: 2rem;
  text-align: center;
  padding-left: 0;
  padding-right: 0;
}
.custom-splide-pagination button:hover {
  background-color: #ffffff;
  color: rgba(95, 159, 231, 0.85);
}
.toggleContainer {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: -moz-fit-content;
  width: fit-content;
  border: 2px solid var(--pageFgColor);
  border-radius: 20px;
  background: var(--pageBgColor);
  font-weight: bold;
  color: var(--pageFgColor);
  cursor: pointer;
  padding: 0.3rem 1.35rem;
  overflow: hidden;
}
.toggleContainer::before {
  content: "";
  position: absolute;
  width: 50%;
  height: 100%;
  left: 0%;
  border-radius: 1rem;
  background: var(--pageFgColor);
  transition: all 0.3s;
  z-index: 1;
}
.toggleContainer.gray-toggle {
  --pageFgColor: #9ea3b8;
  --pageBgColor: #ffffff;
}
.toggleCheckbox {
  display: none;
}
.toggleCheckbox:checked + .toggleContainer::before {
  left: 50%;
}
.toggleCheckbox:checked + .toggleContainer div:first-child {
  color: var(--pageFgColor);
}
.toggleCheckbox:checked + .toggleContainer div:last-child {
  color: #ffffff;
}
.toggleCheckbox + .toggleContainer div {
  z-index: 2;
  transition: color 0.3s;
  min-width: 50%;
  text-align: center;
}
.toggleCheckbox + .toggleContainer div:first-child {
  color: #ffffff;
  padding-right: 1.35rem;
}
.toggleCheckbox + .toggleContainer div:last-child {
  color: var(--pageFgColor);
  padding-left: 1.35rem;
}
.users-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 22rem;
  overflow-y: auto;
}
.users-list ul li {
  display: flex;
  -moz-column-gap: 0.85rem;
       column-gap: 0.85rem;
  border-bottom: 1px solid #e7e8f0;
  padding: 0.5rem 0;
  align-items: center;
  padding-right: 0.5rem;
}
.users-list ul li img {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 50%;
}
.users-list ul li .btn, .users-list ul li .gform_wrapper input[type=submit], .gform_wrapper .users-list ul li input[type=submit], .users-list ul li .gform_wrapper .button, .gform_wrapper .users-list ul li .button {
  border-radius: 0.5rem;
  font-weight: 400;
  font-size: 0.9rem;
  padding: 0.25rem 0.75rem;
}
.users-list ul li .btn.active, .users-list ul li .gform_wrapper input.active[type=submit], .gform_wrapper .users-list ul li input.active[type=submit], .users-list ul li .gform_wrapper .active.button, .gform_wrapper .users-list ul li .active.button {
  color: #4b4b95;
  border-color: #4b4b95;
}
.users-list ul li .btn.active:hover, .users-list ul li .gform_wrapper input.active[type=submit]:hover, .gform_wrapper .users-list ul li input.active[type=submit]:hover, .users-list ul li .gform_wrapper .active.button:hover, .gform_wrapper .users-list ul li .active.button:hover {
  background-color: #e7e8f0;
}
.users-list ul li .btn .ci, .users-list ul li .gform_wrapper input[type=submit] .ci, .gform_wrapper .users-list ul li input[type=submit] .ci, .users-list ul li .gform_wrapper .button .ci, .gform_wrapper .users-list ul li .button .ci {
  display: none;
}
.users-list ul li .name {
  flex-grow: 1;
  font-weight: 600;
  font-size: 1.2rem;
}
.custom-scroll::-webkit-scrollbar {
  width: 8px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: none;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #e7e8f0;
  border-radius: 4px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #9ea3b8;
}
@media (max-width: 575.98px) {
  .related-posts {
    margin-left: calc(-1 * var(--bs-gutter-x));
    margin-right: calc(-1 * var(--bs-gutter-x));
  }
  .custom-splide-pagination button {
    font-size: 1.5rem;
  }
  .custom-splide-pagination button:hover {
    background-color: #ffffff;
    color: rgba(95, 159, 231, 0.85);
  }
}
@media (max-width: 767.98px) {
  .custom-navigation:not(.mobi-navigation) .splide-controls .splide__arrow {
    display: none;
  }
  .custom-navigation.mobi-navigation .splide-controls .splide__pagination {
    flex: 1 1 0%;
  }
  .row {
    margin-right: 0;
    margin-left: 0;
  }
}
@font-face {
  font-family: "communiti-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=ci-], [class*=" ci-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "communiti-icons" !important;
  pointer-events: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ci-clock:before {
  content: "\\e953";
}
.ci-question-circle:before {
  content: "\\e952";
}
.ci-chevron-up:before {
  content: "\\e94e";
}
.ci-chevron-right:before {
  content: "\\e94f";
}
.ci-chevron-down:before {
  content: "\\e950";
}
.ci-chevron-left:before {
  content: "\\e951";
}
.ci-speaker:before {
  content: "\\e94a";
}
.ci-pin:before {
  content: "\\e94b";
}
.ci-help:before {
  content: "\\e94c";
}
.ci-logout:before {
  content: "\\e94d";
}
.ci-eye-slash:before {
  content: "\\e949";
}
.ci-user-alt:before {
  content: "\\e944";
}
.ci-user-single:before {
  content: "\\e945";
}
.ci-eye:before {
  content: "\\e946";
}
.ci-gear:before {
  content: "\\e947";
}
.ci-minus:before {
  content: "\\e948";
}
.ci-twitter-x:before {
  content: "\\e940";
}
.ci-facebook:before {
  content: "\\e941";
}
.ci-email:before {
  content: "\\e942";
}
.ci-whatsapp:before {
  content: "\\e943";
}
.ci-post-arrow:before {
  content: "\\e934";
}
.ci-close:before {
  content: "\\e935";
}
.ci-download:before {
  content: "\\e936";
}
.ci-upload:before {
  content: "\\e93f";
}
.ci-image:before {
  content: "\\e937";
}
.ci-image-alt:before {
  content: "\\e938";
}
.ci-text:before {
  content: "\\e939";
}
.ci-underline:before {
  content: "\\e93a";
}
.ci-italic:before {
  content: "\\e93b";
}
.ci-bold:before {
  content: "\\e93c";
}
.ci-resize:before {
  content: "\\e93d";
}
.ci-delete:before {
  content: "\\e93e";
}
.ci-circolare:before {
  content: "\\e920";
}
.ci-bookmark-active:before {
  content: "\\e900";
}
.ci-bookmark:before {
  content: "\\e901";
}
.ci-comment-active:before {
  content: "\\e902";
}
.ci-comment:before {
  content: "\\e903";
}
.ci-share-active:before {
  content: "\\e904";
}
.ci-share:before {
  content: "\\e905";
}
.ci-like-active:before {
  content: "\\e906";
}
.ci-like:before {
  content: "\\e907";
}
.ci-star:before {
  content: "\\e908";
}
.ci-play:before {
  content: "\\e909";
}
.ci-user:before {
  content: "\\e90a";
}
.ci-community:before {
  content: "\\e90b";
}
.ci-autori:before {
  content: "\\e90c";
}
.ci-audience:before {
  content: "\\e90d";
}
.ci-bell:before {
  content: "\\e90e";
}
.ci-cesta:before {
  content: "\\e923";
}
.ci-cerca:before {
  content: "\\e924";
}
.ci-awards:before {
  content: "\\e90f";
}
.ci-concorso:before {
  content: "\\e910";
}
.ci-temi:before {
  content: "\\e911";
}
.ci-web:before {
  content: "\\e912";
}
.ci-disponibilita:before {
  content: "\\e913";
}
.ci-interests:before {
  content: "\\e914";
}
.ci-partnership:before {
  content: "\\e915";
}
.ci-school:before {
  content: "\\e916";
}
.ci-van:before {
  content: "\\e917";
}
.ci-hand:before {
  content: "\\e918";
}
.ci-event:before {
  content: "\\e919";
}
.ci-kit:before {
  content: "\\e91a";
}
.ci-pcto:before {
  content: "\\e925";
}
.ci-webinar:before {
  content: "\\e926";
}
.ci-contest:before {
  content: "\\e910";
}
.ci-stanze:before {
  content: "\\e927";
}
.ci-pencil:before {
  content: "\\e91b";
}
.ci-poll:before {
  content: "\\e91c";
}
.ci-post:before {
  content: "\\e91d";
}
.ci-story:before {
  content: "\\e91e";
}
.ci-guida:before {
  content: "\\e91f";
}
.ci-locandina:before {
  content: "\\e920";
}
.ci-libro-alunni:before {
  content: "\\e921";
}
.ci-opuscoli:before {
  content: "\\e922";
}
.ci-cartolina:before {
  content: "\\e928";
}
.ci-busta:before {
  content: "\\e929";
}
.ci-scatola:before {
  content: "\\e92a";
}
.ci-verified:before {
  content: "\\e92b";
}
.ci-caret:before {
  content: "\\e92c";
}
.ci-calendar:before {
  content: "\\e930";
}
.ci-arrow-left:before {
  content: "\\e92d";
}
.ci-arrow-right:before {
  content: "\\e92e";
}
.ci-nav-bookmark:before {
  content: "\\e92f";
}
.ci-nav-calendar:before {
  content: "\\e930";
}
.ci-nav-plus:before {
  content: "\\e931";
}
.ci-nav-van:before {
  content: "\\e932";
}
.ci-nav-desk:before {
  content: "\\e933";
}
ul.tags-list {
  list-style-type: none;
  padding: 0;
}
ul.tags-list li {
  display: inline-block;
}
ul.tags-list li a {
  text-align: left;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.25rem;
}
ul.tags-list li a.smaller {
  font-size: 0.85rem;
  line-height: 0.85rem;
}
@media (min-width: 768px) {
  .multi-column-2 {
    -moz-column-count: 2;
         column-count: 2;
  }
}
@media (min-width: 768px) {
  .multi-column-3 {
    -moz-column-count: 2;
         column-count: 2;
  }
}
.img-avatar {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  object-fit: cover;
  overflow: hidden;
}
.img-avatar.small {
  width: 36px;
  height: 36px;
  border-radius: 18px;
}
.main-404 {
  min-height: 50vh;
  padding: 10rem 0;
  background-color: #bad4fe;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
  text-align: center;
}
.main-404 h1, .main-404 .h1 {
  font-size: 8rem;
  color: #5f9fe7;
}
.new-story-widget {
  position: absolute;
  left: 2rem;
  top: 3rem;
  padding: 5px;
  flex-direction: column;
  background-color: var(--pageFgColor);
  border: none;
}
.new-story-widget:hover {
  color: var(--pageFgColor);
}
.new-story-widget .avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
}
.new-story-widget .action {
  padding-top: 1rem;
  padding-bottom: 0.2rem;
  font-size: 1.25rem;
}
@media (max-width: 1199.98px) {
  .new-story-widget {
    left: 1rem;
  }
}
@media (max-width: 575.98px) {
  .new-story-widget {
    display: none !important;
  }
}
.modal-backdrop {
  z-index: 17;
}
.side-article {
  align-items: center;
  -moz-column-gap: 0.85rem;
       column-gap: 0.85rem;
}
.side-article:not(:last-child) {
  border-bottom: 1px solid var(--pageFgColor, #d27366);
}
.side-article .btn-round {
  border-width: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.side-article .avatar-img {
  object-fit: cover;
  width: 3.5rem;
  height: 3.5rem;
}
.side-article a {
  -webkit-text-decoration: none;
  text-decoration: none;
}
.modal-review .rating-badge {
  box-shadow: none;
}
.modal-review .rating-badge .rating-star {
  height: 2.35rem;
  width: 2.35rem;
  cursor: pointer;
}
.btn.btn-white.btn-edit-cover, .gform_wrapper input.btn-white.btn-edit-cover[type=submit], .gform_wrapper .btn-white.btn-edit-cover.button {
  --btnBgColor: #261722;
  --btnFgColor: rgba(255, 255, 255, 0.6);
  padding: 0.35rem 0.85rem;
  position: absolute;
  right: 1rem;
  margin-bottom: 1rem;
  border: none;
}
.site-nav {
  --navBgColor: #bad4fe;
  --navFgColor: #5f9fe7;
  background-color: var(--navBgColor);
  background-size: cover;
  z-index: 20;
  /* .user-menu {
    a.user-login {
      border: 2px solid var(--navFgColor);
      background-color: transparent;
      border-radius: 50px;
      text-decoration: none;
      color: var(--navFgColor);
      text-transform: uppercase;
      padding: 5px 15px;
      padding-right: 2px;
      cursor: pointer;
      font-size: 1.2em;
      font-weight: 600;
      transition: border-color 0.2s, color 0.2s;

      .user-login-icon {
        position: relative;
        bottom: -7px;
        display: inline-block;
        width: 27px;
        height: 27px;
        margin-left: calc(1rem * 0.45);
        background-color: var(--navFgColor);
        -webkit-mask-image: url('../images/icons/communiti_nav_user_icon_user_white.svg');
        mask-image: url('../images/icons/communiti_nav_user_icon_user_white.svg');
        transition: background-color 0.2s;
      }

      &:hover {
        background: var(--navFgColor);
        color: var(--navBgColor);

        .user-login-icon {
          background-color: var(--navBgColor);
        }
      }
    }
  }*/
}
.site-nav:not(.header-alt-light) {
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.15);
}
.site-nav.header-alt-light {
  --navBgColor: #ffffff;
  --navFgColor: rgba(255, 255, 255, 0.65);
}
.site-nav.header-alt-light .main-menu ul.menu li.menu-item.current-menu-item a, .site-nav.header-alt-light .main-menu ul.menu li.menu-item:hover a {
  color: #ffffff;
}
.site-nav.header-alt-light .main-menu ul.menu li.menu-item a::after {
  background-color: #ffffff;
}
.site-nav.has-logo-light .logo-dark {
  display: none;
}
.site-nav.has-logo-dark .logo-light {
  display: none;
}
.site-nav .header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.site-nav .branding {
  padding: 1.25rem 0;
}
.site-nav .branding img {
  height: 28px;
}
.site-nav .main-menu {
  overflow-x: auto;
  text-align: center;
  white-space: nowrap;
}
.site-nav .main-menu ul.menu {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}
@media (min-width: 576px) {
  .site-nav .main-menu ul.menu {
    justify-content: center;
  }
}
.site-nav .main-menu ul.menu li.menu-item a {
  font-size: 1.25em;
  font-weight: 700;
  color: var(--navFgColor);
  -webkit-text-decoration: none;
  text-decoration: none;
  display: inline-block;
  position: relative;
  padding: 0.58rem 0.5rem;
  border-radius: 10px;
  margin-right: 0.25rem;
  white-space: nowrap;
  transition: color 0.2s ease;
}
.site-nav .main-menu ul.menu li.menu-item a::after {
  content: "";
  opacity: 0;
  position: absolute;
  display: block;
  width: 5px;
  height: 5px;
  background-color: #f65d5d;
  border-radius: 50%;
  left: calc(50% - 3px);
  bottom: 0.2rem;
  transition: opacity 0.2s ease;
}
.site-nav .main-menu ul.menu li.menu-item.current-menu-item a, .site-nav .main-menu ul.menu li.menu-item:hover a {
  color: #261722;
}
.site-nav .main-menu ul.menu li.menu-item.current-menu-item a::after, .site-nav .main-menu ul.menu li.menu-item:hover a::after {
  opacity: 1;
}
.site-nav .user-menu {
  -moz-column-gap: 1.85rem;
       column-gap: 1.85rem;
  padding-right: 2rem;
}
@media (max-width: 1023.98px) {
  .site-nav .user-menu {
    -moz-column-gap: 1.55rem;
         column-gap: 1.55rem;
    padding-right: 1rem;
  }
}
.site-nav .user-menu .user-button {
  padding: 0.2rem;
  border: 1px solid var(--navFgColor);
  transition: border-color 0.2s;
}
.site-nav .user-menu .user-button:hover {
  border-color: #261722;
}
.site-nav .user-menu .user-button .user-image {
  width: 1.65rem;
  height: 1.65rem;
  object-fit: cover;
}
.site-nav .user-menu .user-action {
  -webkit-text-decoration: none;
  text-decoration: none;
  font-size: 1.15rem;
  color: var(--navFgColor);
  line-height: 1.15rem;
  transition: color 0.2s;
}
.site-nav .user-menu .user-action:hover {
  color: #261722;
}
.site-nav.header-alt-light .user-menu .user-button:hover,
.site-nav.header-alt-light .user-menu .user-action:hover {
  border-color: #ffffff;
  color: #ffffff;
}
@media (max-width: 1023.98px) {
  .site-nav {
    flex-wrap: wrap;
    box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.15);
    padding-bottom: 1rem;
  }
  .site-nav .branding {
    width: 50%;
  }
  .site-nav .branding img {
    height: 25px;
  }
  .site-nav .user-menu {
    width: 50%;
  }
  .site-nav .main-menu {
    width: 100%;
    position: static !important;
    transform: translate(0, 0) !important;
  }
  .site-nav .main-menu ul.menu {
    gap: 0.55rem;
    padding: 0 1rem;
  }
  .site-nav .main-menu ul.menu li.menu-item a {
    margin-right: 0;
    font-size: 1rem;
    background-color: var(--navFgColor);
    padding: 0.5rem 1rem;
    color: #ffffff;
  }
  .site-nav .main-menu ul.menu li.menu-item a::after {
    bottom: 0.45rem;
  }
  .site-nav .main-menu ul.menu li.menu-item.current-menu-item a, .site-nav .main-menu ul.menu li.menu-item:hover a {
    color: #ffffff;
    background-color: #261722;
    padding-top: 0.35rem;
    padding-bottom: 0.75rem;
  }
  .site-nav .main-menu ul.menu li.menu-item.current-menu-item a::after, .site-nav .main-menu ul.menu li.menu-item:hover a::after {
    opacity: 1;
  }
}
footer {
  background-color: #261722;
}
footer img {
  max-width: 100%;
}
footer a {
  -webkit-text-decoration: none;
  text-decoration: none;
  transition: color 500ms;
  color: #ffffff;
}
footer a.f-active {
  color: #f65d5d;
}
footer a.f-inactive {
  pointer-events: none;
  opacity: 0.5;
}
footer a:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
  color: #f65d5d;
}
footer img {
  height: 50px;
  width: auto;
}
footer .f-map {
  padding: 3%;
  padding-top: 3em;
  padding-bottom: 3em;
}
footer .f-copy {
  padding: 3%;
  padding-top: 1.4em;
  padding-bottom: 1.4em;
  background-color: #261722;
  color: #ffffff;
}
footer .f-copy strong {
  font-weight: 400;
  color: #f65d5d;
}
footer .f-copy p {
  margin-bottom: 0;
}
@media (max-width: 575.98px) {
  footer .row p img {
    max-height: 2.5rem;
    width: auto;
  }
}
.tiwi-block.post-buttons .post-buttons-button {
  display: inline-block;
  background-color: #f29a5f;
  border-radius: 10px;
  margin: 0 5px 5px 0;
  color: white !important;
  border: 2px solid #f29a5f;
  transition: all 200ms;
}
.tiwi-block.post-buttons .post-buttons-button:hover, .tiwi-block.post-buttons .post-buttons-button:active {
  background-color: transparent;
  color: #f29a5f !important;
}
@media (min-width: 1024px) {
  .box-list .box {
    padding: 2rem 1rem;
  }
}
.box-list .box .box-image {
  aspect-ratio: 2/1;
  object-fit: cover;
  margin: 1rem 0;
}
.box-list .box .box-number {
  padding-right: 1rem;
  color: #f65d5d;
  font-weight: 900;
  text-align: center;
}
.box-list .box .box-title {
  font-weight: 700;
}
.page-header-wrapper {
  background-size: cover;
  background-position: center;
}
.page-header-wrapper .page-header {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 35%, rgba(0, 0, 0, 0.9) 100%);
  height: max(250px, 30vh);
  transition: max-height 0.5s;
}
.page-header-wrapper .page-header .page-header-content {
  position: relative;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
}
.page-header-wrapper .page-header .page-header-content h1, .page-header-wrapper .page-header .page-header-content .h1 {
  line-height: 1em;
  font-size: calc(50vw/5);
  font-weight: 900;
  text-transform: uppercase;
  color: #ffffff;
  overflow: hidden;
}
@media (min-width: 576px) {
  .page-header-wrapper .page-header .page-header-content h1, .page-header-wrapper .page-header .page-header-content .h1 {
    font-size: calc(50vw/8);
  }
}
@media (min-width: 768px) {
  .page-header-wrapper .page-header .page-header-content h1, .page-header-wrapper .page-header .page-header-content .h1 {
    font-size: calc(50vw/10);
  }
}
@media (min-width: 1024px) {
  .page-header-wrapper .page-header .page-header-content h1, .page-header-wrapper .page-header .page-header-content .h1 {
    font-size: calc(50vw/14);
  }
}
@media (min-width: 1200px) {
  .page-header-wrapper .page-header .page-header-content h1, .page-header-wrapper .page-header .page-header-content .h1 {
    font-size: 50px;
  }
}
.page-header-wrapper .page-header .page-header-content h1 .ci, .page-header-wrapper .page-header .page-header-content .h1 .ci {
  font-size: 1.35em;
  bottom: -0.2em;
  position: relative;
}
.page-header-wrapper .page-header .page-header-content h1 .ci.ci-pcto, .page-header-wrapper .page-header .page-header-content .h1 .ci.ci-pcto, .page-header-wrapper .page-header .page-header-content h1 .ci.ci-webinar, .page-header-wrapper .page-header .page-header-content .h1 .ci.ci-webinar {
  font-size: 1em;
  bottom: -0.1em;
}
.side-box {
  --accentColor: var(--pageFgColor, #d27366);
}
.side-box .side-box-head {
  -webkit-user-select: none;
          user-select: none;
  border-bottom: 1px solid var(--accentColor);
  width: 100%;
  display: flex;
  gap: 0.35rem;
}
.side-box .side-box-head::before {
  content: "";
  display: block;
  width: 1.55rem;
  height: 1.55rem;
  margin-top: -2px;
  background-color: var(--accentColor);
  -webkit-mask-size: contain;
          mask-size: contain;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center center;
          mask-position: center center;
}
.side-box .side-box-head.icon-event::before {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}
.side-box .side-box-head.icon-van::before {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.side-box .side-box-head.icon-story::before {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.side-box .side-box-head.icon-bell::before {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.side-box .side-box-head.icon-pencil::before {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}
.side-box .side-box-head.icon-tag::before {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.side-box .side-box-head.no-icon::before {
  display: none;
}
.side-box .side-box-head h4.side-box-title, .side-box .side-box-head .side-box-title.h4 {
  color: var(--accentColor);
  text-transform: uppercase;
  vertical-align: middle;
  font-size: 1.25rem;
  font-weight: 700;
}
.side-box .side-box-head[data-bs-toggle=collapse] {
  cursor: pointer;
}
.side-box .side-box-head:hover .collapse-ico .ci {
  color: #ffffff;
  background-color: #d27366;
}
.side-box .side-box-head.collapsed .collapse-ico .ci {
  rotate: 0deg;
}
.side-box .side-box-head .collapse-ico {
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
}
.side-box .side-box-head .collapse-ico .ci {
  color: #d27366;
  border: 1px solid #d27366;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: inline-block;
  font-size: 0.35rem;
  position: relative;
  top: -2px;
  transition: background-color 0.25s, color 0.1s, transform 0.1s;
  text-align: center;
  rotate: 180deg;
}
.side-box .side-box-head .collapse-ico .ci::before {
  position: relative;
  top: 9px;
}
@media (min-width: 1024px) {
  .side-box .collapse {
    display: block !important;
    height: auto !important;
    visibility: visible;
  }
  .side-box .collapse-ico {
    display: none !important;
  }
}
.side-box .kit-banner .card {
  padding: 1.5rem !important;
  height: 23rem;
  background-position: bottom right;
  background-size: 70%;
}
.side-box .kit-banner .card h3, .side-box .kit-banner .card .h3 {
  flex-grow: 1;
}
@media (min-width: 768px) and (max-width: 1199.98px) {
  .side-box .card .btn, .side-box .card .gform_wrapper input[type=submit], .gform_wrapper .side-box .card input[type=submit], .side-box .card .gform_wrapper .button, .gform_wrapper .side-box .card .button {
    padding: 0.35rem 1.15rem;
  }
}
.side-box .side-box-elements .element {
  display: flex;
}
.side-box .side-box-elements .element .element-thumb {
  width: 3.15rem;
  height: 3.15rem;
  background-size: cover;
  background-position: center center;
  background-color: #ffffff;
  border-radius: 6px;
  opacity: 1;
  transition: opacity 0.2s;
}
.side-box .side-box-elements .element p.disclaimer {
  line-height: 1.4em;
  font-size: calc(12vw/5);
  font-weight: 700;
  color: var(--accentColor);
  line-height: 1.2;
}
@media (min-width: 576px) {
  .side-box .side-box-elements .element p.disclaimer {
    font-size: calc(12vw/8);
  }
}
@media (min-width: 768px) {
  .side-box .side-box-elements .element p.disclaimer {
    font-size: calc(12vw/10);
  }
}
@media (min-width: 1024px) {
  .side-box .side-box-elements .element p.disclaimer {
    font-size: calc(12vw/14);
  }
}
@media (min-width: 1200px) {
  .side-box .side-box-elements .element p.disclaimer {
    font-size: 12px;
  }
}
.side-box .side-box-elements .element .element-info {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.side-box .side-box-elements .element .element-info p {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--accentColor);
  line-height: 1.2;
}
.side-box .side-box-elements .element .element-info p.title {
  font-size: 1rem;
  font-weight: 700;
}
.side-box .side-box-elements .element .element-info p.title a {
  color: #261722;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.side-box .side-box-elements .element .element-info p.type {
  font-weight: 600;
  text-transform: uppercase;
}
.side-box .side-box-elements .element .element-info p.type.small {
  font-size: 0.6rem;
}
.side-box .side-box-elements .element .element-info p.date {
  font-size: 0.75rem;
}
.side-box .side-box-elements .element .element-info p.date.small {
  font-size: 0.5rem;
}
.side-box .side-box-elements .element.plus-icon .element-thumb {
  background-color: rgba(255, 255, 255, 0);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.side-box .side-box-elements .element.plus-icon p.title a {
  color: var(--accentColor);
}
.side-box .side-box-elements .element:hover .element-thumb {
  opacity: 0.65;
}
.single-cover {
  position: relative;
}
.single-cover figure {
  margin: 0;
  border-radius: 20px;
  overflow: hidden;
}
.single-cover figure .img-kit-cover {
  width: 100%;
  object-fit: cover;
}
.single-cover figure .img-kit-cover.img-kit-cover-desktop {
  aspect-ratio: 128/84;
}
.single-cover figure .img-kit-cover.img-kit-cover-mobile {
  aspect-ratio: 3/4;
}
.single-cover .cover-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 80%, rgba(0, 0, 0, 0.5) 100%);
  z-index: 10;
  padding: 20px;
  border-radius: 20px;
}
.single-cover .cover-overlay .info-bubble {
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 1rem;
  color: #ffffff;
  font-weight: bold;
  padding: 0.35rem 0.65rem;
  text-align: right;
}
.single-cover .cover-overlay .collection-badge {
  border-radius: 10rem;
  position: absolute;
  min-width: 1.8rem;
  min-height: 1.8rem;
  top: 2rem;
  left: 2rem;
  z-index: 2;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  font-weight: 700;
}
.single-cover .cover-overlay .collection-badge .card-badge-image {
  width: 10rem;
  height: 10rem;
  margin: 0.25rem;
  border-radius: 0.7rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  font-size: 1.15rem;
}
@media (max-width: 575.98px) {
  .single-cover .cover-overlay .collection-badge {
    top: 1rem;
    left: 1rem;
  }
  .single-cover .cover-overlay .collection-badge .card-badge-image {
    width: 6rem;
    height: 6rem;
  }
}
.kit-banner .card {
  padding: 2rem;
  background-color: #fd5c5c;
  color: white;
  border: 0;
  justify-content: space-between;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: contain;
}
@media (max-width: 575.98px) {
  .kit-banner .card {
    min-height: 28rem;
  }
}
.mobile-actions-menu {
  z-index: 6;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-position: center center;
  background-repeat: no-repeat;
  width: 25rem;
  min-height: 7.8rem;
  margin-bottom: 0.25rem;
  display: flex;
}
.mobile-actions-menu .actions-menu {
  padding-top: 1.4rem;
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.mobile-actions-menu .actions-menu .nav-btn {
  background: none;
  border: none;
  width: 5rem;
  color: #d27366;
  transition: opacity 0.35s;
  padding: 0;
}
.mobile-actions-menu .actions-menu .nav-btn:active {
  opacity: 0.55;
}
.mobile-actions-menu .actions-menu .nav-btn.plus {
  background-color: #4b4b95;
  border-radius: 2.5rem;
  margin: 0 0.5rem;
  margin-top: 2px;
  margin-left: calc(0.5rem - 1.8px);
  height: 4.25rem;
  width: 4.25rem;
  color: #ffffff;
}
.mobile-actions-menu .actions-menu .nav-btn.plus .ci {
  position: relative;
  top: 3px;
  font-size: 1.55rem;
}
.mobile-actions-menu .actions-menu .nav-btn .ci {
  font-size: 1.25rem;
}
.mobile-actions-menu .actions-menu .nav-btn .button-desc {
  display: block;
  font-size: 0.65rem;
}
.vue-content-card .card-loader {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  overflow: hidden;
}
.vue-content-card .card-loader .card-loader-overlay {
  background-color: rgba(255, 255, 255, 0.5);
}
.vue-content-card .card-loader .card-loader-overlay .spinner-border {
  color: #f65d5d;
}
.vue-content-card .card-image-container {
  position: relative;
}
.vue-content-card .card-image-container .card-image {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  overflow: hidden;
  -webkit-text-decoration: none;
  text-decoration: none;
  min-height: calc(250px + 2rem);
  height: 100%;
  transition: transform 0.5s;
  /* Animation */
}
.vue-content-card .card-image-container .card-image:hover {
  transform: scale(1.1);
}
.vue-content-card .card-image-container .card-image .badge {
  background-color: #261722;
  color: #ffffff;
  max-width: 45%;
  white-space: wrap;
}
.vue-content-card .vue-content-icon {
  -webkit-user-select: none;
          user-select: none;
  text-transform: uppercase;
  color: #f65d5d;
  font-size: 0.8em;
}
.vue-content-card .vue-content-icon .ci {
  font-size: 1.45em;
  bottom: -0.15em;
  position: relative;
}
.vue-content-card .card-badge {
  position: absolute;
  min-width: 1.8rem;
  min-height: 1.8rem;
  top: 1rem;
  z-index: 2;
  border-radius: 0.9rem;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  font-weight: 700;
}
.vue-content-card .card-badge .card-badge-label {
  padding-left: 0.75rem;
}
.vue-content-card .card-badge .card-badge-name {
  padding-left: 0.8rem;
}
.vue-content-card .card-badge .card-badge-image {
  width: 1.4rem;
  height: 1.4rem;
  margin: 0.25rem;
  border-radius: 0.7rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  font-size: 1.15rem;
}
.vue-content-card .card-badge.left {
  left: 1rem;
}
.vue-content-card .card-badge.right {
  right: 1rem;
}
.vue-content-card .card-icon {
  position: absolute;
  min-width: 1.8rem;
  height: 1.8rem;
  top: 1rem;
  left: 1rem;
  border-radius: 0.9rem;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.75rem;
  font-weight: 700;
}
.vue-content-card .card-icon .author-name {
  padding-left: 0.8rem;
}
.vue-content-card .card-icon .author-image {
  width: 1.4rem;
  height: 1.4rem;
  margin: 0.25rem;
  border-radius: 0.7rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.vue-content-card .card-rating {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
}
.vue-content-card .card-edit-link {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
}
.vue-content-card .card-edit-link .ci::before {
  top: 6px;
}
.vue-content-card .card-body .card-date {
  color: #9ea3b8;
  font-size: 0.8rem;
  font-weight: 700;
  margin: 0;
}
.vue-content-card .card-body .card-date a {
  color: #9ea3b8;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.vue-content-card .card-body .card-date a:hover {
  color: #f65d5d;
}
.vue-content-card .card-body .card-title {
  font-size: 1.25rem;
}
.vue-content-card .card-body .card-title a {
  color: #261722;
  font-weight: 700;
  -webkit-text-decoration: none;
  text-decoration: none;
  transition: color 0.5s;
}
.vue-content-card .card-body .card-title a:hover {
  color: #f65d5d;
}
.vue-content-card .card-body .card-summary {
  color: #9ea3b8;
  font-size: 0.8rem;
  font-weight: 700;
  margin: 0;
}
.vue-content-card .card-body .card-content {
  margin-top: 1rem;
}
.vue-content-card .card-body .left-icon {
  -webkit-user-select: none;
          user-select: none;
}
.vue-content-card .card-body .left-icon .icon {
  height: 1rem;
  padding-left: 1.7rem;
  text-align: left;
  line-height: 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  background: none;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
  color: #261722;
  border: none;
}
.vue-content-card .card-body .left-icon .icon.icon-van {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.vue-content-card .card-body .left-icon .icon.icon-hand {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  padding-left: 1.2rem;
}
@media (min-width: 1024px) {
  .vue-content-card.horizontal > .card {
    flex-direction: row;
    /* .card-badge.left {
      display: none;
    } */
  }
  .vue-content-card.horizontal > .card .card-image-container, .vue-content-card.horizontal > .card > .card-body {
    width: 50%;
  }
  .vue-content-card.horizontal > .card .card-badge:not(.collection-badge) {
    left: calc(50% + 1rem);
    flex-direction: row-reverse;
  }
  .vue-content-card.horizontal > .card .card-badge:not(.collection-badge) .card-badge-label {
    padding-left: 0;
    padding-right: 0.75rem;
  }
  .vue-content-card.horizontal > .card .card-badge:not(.collection-badge).right {
    right: unset;
  }
  .vue-content-card.horizontal > .card .card-body {
    padding-top: 3.5rem !important;
  }
}
.vue-content-card .collection-badge {
  border-radius: 6rem;
}
.vue-content-card .collection-badge .card-badge-image {
  width: 4.5rem;
  height: 4.5rem;
}
@media (max-width: 1023.98px) {
  .vue-content-card .card-image-container {
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: var(--bs-border-radius-xl) !important;
  }
}
.vue-content-actions {
  -webkit-user-select: none;
          user-select: none;
}
.vue-content-actions .icon {
  padding: 0;
  margin-top: -0.25rem;
  text-align: right;
  font-size: 0.75rem;
  background: none;
  color: #9ea3b8;
  border: none;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.vue-content-actions .icon .ci {
  font-size: 1.5rem;
  position: relative;
  bottom: -6px;
}
.vue-content-actions .icon.disabled {
  opacity: 0.33;
  cursor: not-allowed;
}
.vue-content-actions .icon:not(.disabled):hover .ci-share:before, .vue-content-actions .icon.active .ci-share:before {
  content: "\\e904";
}
.vue-content-actions .icon:not(.disabled):hover .ci-bookmark:before, .vue-content-actions .icon.active .ci-bookmark:before {
  content: "\\e900";
}
.vue-content-actions .icon:not(.disabled):hover .ci-comment:before, .vue-content-actions .icon.active .ci-comment:before {
  content: "\\e902";
}
.vue-content-actions .icon:not(.disabled):hover .ci-like:before, .vue-content-actions .icon.active .ci-like:before {
  content: "\\e906";
}
.vue-content-actions .icon:hover {
  opacity: 0.5;
}
.vue-content-actions .share-popup {
  background-color: #ffffff;
  border-radius: 0.75em;
  right: -3rem;
  top: 2.8rem;
  z-index: 8;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.25);
}
.vue-content-actions .share-popup ul {
  background-color: #ffffff;
  border-radius: 0.75em;
  padding: 0.25em;
  list-style-type: none;
  margin: 0;
}
.vue-content-actions .share-popup .btn, .vue-content-actions .share-popup .gform_wrapper input[type=submit], .gform_wrapper .vue-content-actions .share-popup input[type=submit], .vue-content-actions .share-popup .gform_wrapper .button, .gform_wrapper .vue-content-actions .share-popup .button {
  font-weight: normal;
  text-wrap: nowrap;
  color: #261722;
  padding: 0;
  border-radius: 0;
  background: none;
  border: none;
  text-transform: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-align: left;
  padding: 0.15em 0.45em;
  border-radius: 0.55em;
}
.vue-content-actions .share-popup .btn.btn-link, .vue-content-actions .share-popup .gform_wrapper input.btn-link[type=submit], .gform_wrapper .vue-content-actions .share-popup input.btn-link[type=submit], .vue-content-actions .share-popup .gform_wrapper .btn-link.button, .gform_wrapper .vue-content-actions .share-popup .btn-link.button {
  width: 100%;
}
.vue-content-actions .share-popup .btn:hover, .vue-content-actions .share-popup .gform_wrapper input[type=submit]:hover, .gform_wrapper .vue-content-actions .share-popup input[type=submit]:hover, .vue-content-actions .share-popup .gform_wrapper .button:hover, .gform_wrapper .vue-content-actions .share-popup .button:hover {
  background-color: #e7e8f1;
}
.vue-content-actions .share-popup .btn:active, .vue-content-actions .share-popup .gform_wrapper input[type=submit]:active, .gform_wrapper .vue-content-actions .share-popup input[type=submit]:active, .vue-content-actions .share-popup .gform_wrapper .button:active, .gform_wrapper .vue-content-actions .share-popup .button:active {
  background-color: #c8c9d1;
}
.vue-content-actions .share-popup .btn.social-network .ci, .vue-content-actions .share-popup .gform_wrapper input.social-network[type=submit] .ci, .gform_wrapper .vue-content-actions .share-popup input.social-network[type=submit] .ci, .vue-content-actions .share-popup .gform_wrapper .social-network.button .ci, .gform_wrapper .vue-content-actions .share-popup .social-network.button .ci {
  position: relative;
  top: 2px;
}
.vue-content-actions .share-popup .btn.social-network .ci.ci-email, .vue-content-actions .share-popup .gform_wrapper input.social-network[type=submit] .ci.ci-email, .gform_wrapper .vue-content-actions .share-popup input.social-network[type=submit] .ci.ci-email, .vue-content-actions .share-popup .gform_wrapper .social-network.button .ci.ci-email, .gform_wrapper .vue-content-actions .share-popup .social-network.button .ci.ci-email {
  font-size: 0.75em;
  top: 0;
}
.vue-content-actions .share-popup .btn.social-network .ci.ci-twitter-x, .vue-content-actions .share-popup .gform_wrapper input.social-network[type=submit] .ci.ci-twitter-x, .gform_wrapper .vue-content-actions .share-popup input.social-network[type=submit] .ci.ci-twitter-x, .vue-content-actions .share-popup .gform_wrapper .social-network.button .ci.ci-twitter-x, .gform_wrapper .vue-content-actions .share-popup .social-network.button .ci.ci-twitter-x {
  font-size: 0.8em;
  top: 0;
}
.vue-content-actions .share-popup .vue-social-networks {
  padding-left: 0.25rem;
  gap: 0.25em;
}
.vue-content-actions .share-popup::before {
  background-color: #ffffff;
  box-shadow: 0px -2px 6px 0px rgba(0, 0, 0, 0.25);
  content: " ";
  display: block;
  height: 16px;
  position: absolute;
  top: -2px;
  right: 52px;
  transform: rotate(-90deg) skew(45deg);
  width: 30px;
  z-index: -1;
}
.vue-content-actions.white .icon {
  color: #ffffff;
}
.vue-content-icon .post-type-label {
  font-weight: 600;
}
.vue-activity-list hr {
  border-top: 1px solid #f29a5f;
  opacity: 1;
}
.vue-activity-list .activity-image {
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 8px;
}
.vue-activity-list .activity-date {
  color: #f29a5f;
}
.vue-activity-list .activity-content {
  font-size: 1.25rem;
}
.vue-video-player {
  align-items: center;
}
.vue-video-player .video-container {
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  background-size: cover;
  background-position: center;
  /*
  width: 96%;
  display: block;
  margin: 0 auto;
  position: relative;



  @include media-breakpoint-up(xl){ width: 80%;}
  */
}
.vue-video-player .video-container .hover-message {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column wrap;
  z-index: 9;
  transition: transform 0.3s ease;
}
.vue-video-player .video-container .hover-message .play-button {
  display: block;
  cursor: pointer;
  background: #f65d5d;
  color: #ffffff;
  border-radius: 50%;
  padding: 1rem;
  transition: all 500ms;
}
@media screen and (min-width: 768px) {
  .vue-video-player .video-container .hover-message .play-button {
    padding: 1.5rem;
  }
}
@media screen and (min-width: 992px) {
  .vue-video-player .video-container .hover-message .play-button {
    padding: 2rem;
  }
}
.vue-video-player .video-container .hover-message .play-button img {
  display: block;
  width: 22px;
  height: auto;
  transform: translate(0.1rem, 0);
}
@media screen and (min-width: 768px) {
  .vue-video-player .video-container .hover-message .play-button img {
    width: 28px;
  }
}
@media screen and (min-width: 992px) {
  .vue-video-player .video-container .hover-message .play-button img {
    width: 32px;
  }
}
.vue-video-player .video-container .hover-message .play-button:hover {
  transform: scale(1.2);
}
.vue-video-player .video-container video {
  display: block;
  width: 100%;
}
.rating-badge {
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1490196078);
}
.rating-badge .rating-star {
  height: 1.25rem;
  width: 1.25rem;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}
.rating-badge .rating-star.on {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}
.rating-badge .total-ratings {
  font-size: 0.75rem;
  font-weight: 600;
  color: #fbd281;
}
.rating-badge:not(.voted) .rating-star:hover, .rating-badge:not(.disabled) .rating-star:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}
.vue-comment-section .modal-comment-form {
  display: flex;
}
.vue-comment-section .modal-comment-form form {
  position: relative;
  flex-grow: 1;
  padding-left: 5px;
}
.vue-comment-section .modal-comment-form form .form-control {
  height: 50px;
  border-radius: 15px;
  background-color: #f0f0f0;
  border: none;
  font-size: 1.25em;
  padding: 0.5em 1em;
  min-height: 50px;
  max-height: 500px;
}
.vue-comment-section .modal-comment-form form .form-control::-webkit-resizer {
  display: none;
}
.vue-comment-section .modal-comment-form form .btn-submit {
  position: absolute;
  top: 5px;
  right: 5px;
  border: 2px solid var(--btnFgColor);
  padding-top: 0.25em;
  padding-left: 0.15em;
  font-size: 1.2em;
}
.vue-comment-section .modal-comment-form form .btn-submit:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}
.vue-comment-section .related-comment-field .modal-comment-form .form-control {
  font-size: 1em;
  height: 40px;
  padding: 0.5em 1em;
  min-height: 40px;
}
.vue-comment-section .related-comment-field .modal-comment-form .img-avatar {
  width: 40px;
  height: 40px;
}
.vue-comment-section .related-comment-field .modal-comment-form .btn-submit {
  padding-top: 0.25em;
  padding-left: 0.15em;
  font-size: 0.85em;
  width: 30px;
  height: 30px;
}
.vue-comment-card .card-comment {
  border: 0;
  border-radius: 15px;
}
.vue-comment-card .card-comment .card-comment-author {
  display: flex;
  align-items: center;
  margin-bottom: 0.85em;
}
.vue-comment-card .card-comment .card-comment-author .card-comment-author-display-name {
  font-size: 1.1rem;
  padding-left: 0.65em;
  font-weight: bold;
}
.vue-comment-card .card-comment .card-comment-content {
  font-size: 0.9rem;
  margin-bottom: 0.85em;
}
.vue-comment-card .card-comment .card-comment-date {
  font-size: 0.75rem;
  color: #9ea3b8;
}
.vue-comment-card .comment-replies .img-avatar.small {
  width: 26px;
  height: 26px;
}
.vue-comment-card .comment-replies .card-comment-author {
  margin-bottom: 0.5em;
}
.vue-comment-card .comment-replies .card-comment-author .card-comment-author-display-name {
  font-size: 1rem;
}
.vue-comment-card .comment-replies .card-comment-content {
  margin-bottom: 0.5em;
}
.slide-fade-enter-active {
  transition: all 0.1s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.1s ease-out;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.vue-modal .img-avatar {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  object-fit: cover;
  overflow: hidden;
}
.vue-modal .img-avatar.small {
  width: 36px;
  height: 36px;
  border-radius: 18px;
}
.vue-modal .modal-hover .modal-content {
  background-color: rgba(75, 75, 149, 0.9);
  display: flex;
  align-items: center;
  max-height: 100%;
}
.vue-modal .modal-hover .modal-header {
  border-bottom: none !important;
}
.vue-modal .modal-hover .btn-close {
  background-color: white;
  position: absolute;
  top: 1rem;
  right: 1rem;
  color: black;
  opacity: 1;
  padding: 0;
  transition: transform 0.5s, opacity 0.5s;
}
.vue-modal .modal-hover .btn-close:hover {
  transform: rotate(-8deg);
  opacity: 0.9;
}
.vue-modal .modal-hover .btn-close:active {
  transform: rotate(0deg);
  opacity: 0.75;
}
.vue-modal .modal-hover .video-container {
  justify-content: center;
}
.vue-modal .modal-hover .video-container .btn-close {
  top: -1.2rem;
  right: -1.2rem;
  z-index: 2;
}
.vue-modal .modal-hover .modal-container {
  width: 500px;
  font-size: 1rem;
}
.vue-modal .modal-hover .modal-container.wider {
  width: 650px;
}
.vue-modal .modal-hover .modal-container.widest {
  width: 900px;
}
.vue-modal .modal-hover .modal-container.video-modal {
  min-width: 500px;
  width: 75vw;
}
.vue-modal .modal-hover .modal-container.video-modal .video-container {
  border-radius: 0;
}
@media (max-width: 767.98px) {
  .vue-modal .modal-hover .modal-container.video-modal {
    min-width: auto;
    width: 90vw;
  }
  .vue-modal .modal-hover .modal-container, .vue-modal .modal-hover .modal-container.wider, .vue-modal .modal-hover .modal-container.widest {
    min-width: 100%;
    width: 100%;
  }
}
.vue-modal .modal-hover .modal-comment-feedback {
  color: white;
}
.vue-modal .modal-hover .modal-comment-list {
  overflow-x: hidden;
  overflow-y: auto;
}
.vue-modal .modal-hover .card .card-header {
  background-color: #ffffff;
  border-color: #e7e8f0;
  text-align: left !important;
}
.vue-modal .modal-hover .card .card-header h3, .vue-modal .modal-hover .card .card-header .h3 {
  color: #9ea3b8;
  font-weight: 700;
  margin: 0.25em 0;
}
.vue-modal .modal-hover .card .card-header h3 .ci, .vue-modal .modal-hover .card .card-header .h3 .ci {
  top: 0.1rem;
  position: relative;
  font-weight: 600;
  margin-right: 0.35rem;
}
.vue-modal .modal-hover .card .card-header .btn-close {
  top: 0.75rem;
  background-color: #e7e8f0;
  background-size: 30%;
  transition: background-color 0.35s;
}
.vue-modal .modal-hover .card .card-header .btn-close:hover {
  background-color: #9ea3b8;
  transform: none;
}
.vue-modal .modal-hover .card .upload-image {
  width: 15rem;
}
.vue-modal .modal-hover .card .profile-image-container {
  width: 15rem;
  height: 15rem;
  border: 1px solid #4b4b95;
  padding: 0.5rem;
  overflow: hidden;
  position: relative;
}
.vue-modal .modal-hover .card .profile-image-container .profile-image {
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
}
.vue-modal .modal-hover .card .profile-image-container .img-loader {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_46___}) repeat-x;
  background-position: 0% 110%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  animation-name: fill-wave, wave-0;
  animation-duration: 5s, 7s;
  animation-delay: 0s, 5s;
  animation-fill-mode: forwards, none;
  animation-iteration-count: 1, infinite;
  animation-timing-function: var(--ease-in), var(--ease-out);
}
.vue-modal .modal-hover .card .profile-image-container .img-loader._0 {
  background-position: 0% 110%;
}
.vue-modal .modal-hover .card .profile-image-container .img-loader._50 {
  background-position: 0% 57%;
  animation-name: fill-wave, wave-50;
}
.vue-modal .modal-hover .card .profile-image-container .img-loader._100 {
  background-position: 0% 5%;
  animation-name: fill-wave, wave-100;
}
.vue-modal .modal-hover .card .upload-cover-image {
  text-align: center;
}
.vue-modal .modal-hover .card .upload-cover-image .cover-image {
  width: 100%;
  height: 300px;
  background-position: center center;
  background-size: cover;
}
.vue-modal .modal-hover .card #fileUpload,
.vue-modal .modal-hover .card #coverUpload {
  width: 0;
  height: 0;
}
.vue-modal .modal-hover .card .card-actions .btn, .vue-modal .modal-hover .card .card-actions .gform_wrapper input[type=submit], .gform_wrapper .vue-modal .modal-hover .card .card-actions input[type=submit], .vue-modal .modal-hover .card .card-actions .gform_wrapper .button, .gform_wrapper .vue-modal .modal-hover .card .card-actions .button {
  min-width: 14rem;
}
:root {
  --ease-in: cubic-bezier(0.58, 0.42, 1, 1);
  --ease-out: cubic-bezier(0, 0, 0.42, 0.58);
}
@keyframes fill-wave {
  from {
    background-position: -1200px -110%;
  }
}
@keyframes wave-0 {
  to {
    background-position: 1200px 110%;
  }
}
@keyframes wave-50 {
  to {
    background-position: 1200px 57%;
  }
}
@keyframes wave-100 {
  to {
    background-position: 1200px 90%;
  }
}
.vue-story-editor .title-edit textarea {
  font-size: 2em;
  font-weight: bold;
}
.vue-story-editor .title-edit textarea:focus {
  outline: none;
  background-color: rgba(231, 232, 240, 0.25);
}
.vue-story-editor .input-label {
  font-size: 0.95rem;
  font-weight: bold;
}
.vue-story-editor .vue-story-editor-block {
  position: relative;
}
.vue-story-editor .vue-story-editor-block .block-edit {
  min-width: 0;
  min-height: 182px;
  transition: min-height 0.35s;
}
.vue-story-editor .vue-story-editor-block .block-edit > .block-type-ico {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  font-size: 0.85rem;
  color: #9ea3b8;
}
.vue-story-editor .vue-story-editor-block .block-drag {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.45rem;
  color: #9ea3b8;
  cursor: move;
}
.vue-story-editor .vue-story-editor-block .block-drag:hover {
  background-color: rgba(231, 232, 240, 0.25);
}
.vue-story-editor .vue-story-editor-block .btn.block-delete, .vue-story-editor .vue-story-editor-block .gform_wrapper input.block-delete[type=submit], .gform_wrapper .vue-story-editor .vue-story-editor-block input.block-delete[type=submit], .vue-story-editor .vue-story-editor-block .gform_wrapper .block-delete.button, .gform_wrapper .vue-story-editor .vue-story-editor-block .block-delete.button {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 10;
  padding: 0.1rem;
  width: 1.8rem;
  height: 1.8rem;
  font-size: 0.9rem;
  border-width: 1px;
  color: #9ea3b8;
}
.vue-story-editor .vue-story-editor-block .btn.block-delete:hover, .vue-story-editor .vue-story-editor-block .gform_wrapper input.block-delete[type=submit]:hover, .gform_wrapper .vue-story-editor .vue-story-editor-block input.block-delete[type=submit]:hover, .vue-story-editor .vue-story-editor-block .gform_wrapper .block-delete.button:hover, .gform_wrapper .vue-story-editor .vue-story-editor-block .block-delete.button:hover {
  color: #ffffff;
}
.vue-story-editor .vue-story-editor-block .btn.block-delete .ci, .vue-story-editor .vue-story-editor-block .gform_wrapper input.block-delete[type=submit] .ci, .gform_wrapper .vue-story-editor .vue-story-editor-block input.block-delete[type=submit] .ci, .vue-story-editor .vue-story-editor-block .gform_wrapper .block-delete.button .ci, .gform_wrapper .vue-story-editor .vue-story-editor-block .block-delete.button .ci {
  position: relative;
  top: 2px;
}
.vue-story-editor .vue-story-editor-block .block-image-buttons {
  display: flex;
  justify-content: flex-end;
}
.vue-story-editor .vue-story-editor-block .block-image-buttons .btn, .vue-story-editor .vue-story-editor-block .block-image-buttons .gform_wrapper input[type=submit], .gform_wrapper .vue-story-editor .vue-story-editor-block .block-image-buttons input[type=submit], .vue-story-editor .vue-story-editor-block .block-image-buttons .gform_wrapper .button, .gform_wrapper .vue-story-editor .vue-story-editor-block .block-image-buttons .button {
  padding: 0.15rem 1.15rem;
  font-size: 0.9rem;
}
.vue-story-editor .vue-story-editor-block .block-edit-image input[type=file] {
  width: 0;
  height: 0;
}
.vue-story-editor .vue-story-editor-block .empty-image {
  margin-bottom: 3.75rem !important;
}
.vue-story-editor .attachments-edit .btn-upload {
  position: absolute;
  right: 0.6rem;
  top: 0.6rem;
}
.vue-story-editor .attachments-edit .btn-upload .ci {
  font-weight: 600;
  position: relative;
  top: 1px;
  right: 4px;
}
.vue-story-editor .empty-image {
  height: 10rem;
  border: 2px dashed #9ea3b8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #9ea3b8;
  font-size: 1.25rem;
  cursor: pointer;
}
.vue-story-editor .empty-image .ci {
  font-size: 3.5rem;
}
.vue-story-editor .empty-image .spinner-border {
  width: 3rem;
  height: 3rem;
}
.vue-story-editor .empty-image:hover {
  background-color: rgba(231, 232, 240, 0.25);
}
.multiselect .multiselect__tags {
  display: flex;
  flex-wrap: wrap;
  padding: 0.55rem;
  background-color: #e7e8f0;
  min-height: 62px;
}
.multiselect .multiselect__tags .multiselect__tags-wrap {
  display: flex;
  flex-wrap: wrap;
  -moz-column-gap: 0.5em;
       column-gap: 0.5em;
  row-gap: 0.5em;
}
.multiselect .multiselect__tags .multiselect__tags-wrap .multiselect__tag {
  display: flex;
  background-color: white;
  padding: 0.65rem 1rem;
  border-radius: 2rem;
  font-weight: bold;
}
.multiselect .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "communiti-icons" !important;
  font-style: normal;
  line-height: 1;
  display: block;
  margin-left: 0.85rem;
  font-size: 0.85rem;
  position: relative;
  top: 5px;
  cursor: pointer;
  color: #9ea3b8;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.multiselect .multiselect__tags .multiselect__tags-wrap .multiselect__tag .multiselect__tag-icon:before {
  content: "\\e935";
}
.multiselect .multiselect__tags .multiselect__tags-wrap .multiselect__tag a {
  -webkit-text-decoration: none;
  text-decoration: none;
}
.multiselect .multiselect__tags .multiselect__input {
  position: relative !important;
  width: auto !important;
  padding-left: 1rem !important;
  flex: 1;
  background: none;
  border: none;
  min-height: 45px;
}
.multiselect .multiselect__tags .multiselect__input:focus {
  outline: none;
}
.multiselect .multiselect__tags .multiselect__input::placeholder {
  font-weight: bold;
  color: #9ea3b8;
}
.multiselect .multiselect__tags .multiselect__placeholder {
  display: none;
}
.multiselect .multiselect__content {
  display: inline !important;
  padding: 0;
  margin: 0;
  list-style-type: none;
  width: 100%;
}
.multiselect .multiselect__content .multiselect__element {
  width: 100%;
}
.multiselect .multiselect__content .multiselect__element .multiselect__option {
  display: block;
  width: 100%;
  padding: 0.55rem 1.5rem;
  font-weight: bold;
  cursor: pointer;
}
.multiselect .multiselect__content .multiselect__element .multiselect__option.multiselect__option--selected {
  display: none;
}
.multiselect .multiselect__content .multiselect__element .multiselect__option:hover {
  background-color: rgba(231, 232, 240, 0.8);
}
.multiselect .multiselect__content li:not(.multiselect__element) .multiselect__option {
  display: block;
  padding: 0.55rem 1.5rem;
}
.multiselect.readonly .multiselect__input, .multiselect.readonly .multiselect__content-wrapper {
  display: none;
}
.tox.tox-tinymce {
  border: none;
  border-radius: 0;
}
.tox.tox-tinymce .tox-editor-container {
  flex-direction: column-reverse;
}
.tox.tox-tinymce .tox-editor-header {
  box-shadow: none;
  padding: 0 !important;
}
.tox.tox-tinymce .tox-editor-header .tox-toolbar__primary {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.tox.tox-tinymce .tox-editor-header .tox-toolbar__primary .tox-toolbar__group {
  background-color: #e7e8f0;
  border-radius: 0.25rem;
  padding: 0;
  overflow: hidden;
}
.tox.tox-tinymce .tox-editor-header .tox-toolbar__primary .tox-toolbar__group .tox-tbtn {
  margin: 0;
  padding: 1rem;
  border-radius: 0;
  color: #261722;
}
.tox.tox-tinymce .tox-editor-header .tox-toolbar__primary .tox-toolbar__group .tox-tbtn:hover {
  background-color: rgba(186, 212, 254, 0.5);
}
.tox.tox-tinymce .tox-editor-header .tox-toolbar__primary .tox-toolbar__group .tox-tbtn.tox-tbtn--enabled {
  background-color: #c5cedd;
}
.vue-inline-editor .editor {
  background-color: white;
  padding: 2rem;
  border-radius: 20px;
}
.vue-inline-editor .editor .form-control {
  border: 0;
  outline: 0;
  padding: 0;
  font-size: 1.4rem;
}
.vue-inline-editor .editor .form-control:focus, .vue-inline-editor .editor .form-control:active {
  outline: 0;
  box-shadow: none;
}
.vue-inline-editor .editor .form-control:disabled {
  background-color: transparent;
  opacity: 0.75;
}
.vue-inline-editor .editor .textarea-limit {
  color: #9ea3b8;
  font-size: 0.75rem;
}
.vue-edit-school-button {
  display: inline;
}
.vue-edit-school-button .school-breadcrumbs {
  padding: 0;
  border-radius: 2.8rem;
}
@media (min-width: 768px) {
  .vue-edit-school-button .school-breadcrumbs {
    border: 2px solid #9ea3b8;
  }
}
.vue-edit-school-button .school-breadcrumbs .school-breadcrumbs-item {
  display: inline-block;
  padding: 0 20px;
  padding: 0.45rem 1.35rem;
  border-radius: 2.8rem;
}
.vue-edit-school-button .school-breadcrumbs .school-breadcrumbs-item .btn-bundle-select {
  color: #9ea3b8;
  -webkit-text-decoration: none;
  text-decoration: none;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 6px;
}
.vue-edit-school-button .school-breadcrumbs .school-breadcrumbs-item .btn-bundle-delete {
  color: white;
  -webkit-text-decoration: none;
  text-decoration: none;
  font-size: 0.9rem;
  padding-left: 6px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.vue-edit-school-button .school-breadcrumbs .school-breadcrumbs-item.active, .vue-edit-school-button .school-breadcrumbs .school-breadcrumbs-item:active {
  color: white;
  background-color: #9ea3b8;
}
.vue-edit-school-button .school-breadcrumbs .school-breadcrumbs-item.active .btn-bundle-select, .vue-edit-school-button .school-breadcrumbs .school-breadcrumbs-item:active .btn-bundle-select {
  color: white;
}
.vue-edit-school-button .school-select-form .school-selection-dropdown {
  z-index: 100;
  margin-top: -10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border: 2px solid #e7e8f0;
  max-height: 250px;
  width: 94%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
}
.vue-edit-school-button .school-select-form .school-selection-dropdown li {
  max-width: 100%;
}
.vue-edit-school-button .school-select-form .school-selection-dropdown li .dropdown-item {
  font-size: 0.8rem;
}
.vue-edit-school-button .school-select-form .school-selection-dropdown li .dropdown-item small, .vue-edit-school-button .school-select-form .school-selection-dropdown li .dropdown-item .small {
  font-size: 0.65rem;
}
.vue-edit-school-button .school-select-form .teaching-areas-wrapper-toggler .ci::before {
  font-size: 0.5rem;
}
.vue-edit-school-button .school-select-form .visibility-disclaimer {
  text-transform: none;
}
.vue-edit-school-button .school-select-form .visibility-disclaimer .ci {
  font-size: 1.5rem;
}
.vue-edit-school-button .text-mini {
  font-size: 0.875rem;
  line-height: 0.875rem;
  text-transform: none;
  color: #9ea3b8;
}
.vue-edit-school-button .teaching-areas-wrapper .teaching-areas-wrapper-toggler, .vue-edit-school-button .school-types-wrapper .teaching-areas-wrapper-toggler {
  border: 0;
  background-color: transparent;
  display: inline;
  color: #4b4b95;
  cursor: pointer;
}
.vue-edit-school-button .teaching-areas-wrapper .form-check-label, .vue-edit-school-button .school-types-wrapper .form-check-label {
  font-size: 0.875rem;
  line-height: 0.875rem;
}
.vue-edit-school-button .card-gray {
  background-color: #9ea3b8;
  color: white;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}
.vue-edit-school-button .card-gray .card-gray-header {
  border-bottom: 1px solid white;
}
.vue-edit-school-button .card-gray .card-gray-header .card-gray-header-icon {
  font-size: 2rem;
  margin-right: 8px;
}
.vue-edit-school-button .card-gray .card-gray-header .card-gray-header-title {
  font-size: 1rem;
  display: inline;
}
.vue-edit-school-button .card-gray .form-label {
  color: white !important;
}
.vue-story-teaser .card.post-card {
  border: none;
}
.vue-story-teaser .card.post-card .avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 1rem;
  background-size: cover;
  background-position: center center;
}
.vue-story-teaser .card.post-card .avatar img {
  height: 100%;
  width: auto;
}
.vue-story-teaser .card.post-card .post-field {
  width: calc(100% - 60px - 1rem);
  background: #e7e8f0 !important;
  border: 0;
  border-radius: 10px;
  padding: 1rem;
  font-size: 1.25rem;
  color: #9ea3b8;
}
.vue-story-teaser .card.post-card .post-submit {
  width: 300px;
  margin: 0 0 0 auto;
}
.vue-component.vue-avatar-editor {
  /*
  .btn-random-avatar{
      color: white;
      padding: 4px 8px;

      font-size: 0.75rem;
      text-decoration: none;
      height: 20px;
      border-radius: 10px;
      background-color: \$gray;

      &:hover{
          color: \$gray;
          border: 2px solid \$gray;
          background-color: white;
      }
  }
      */
}
@media (min-width: 768px) {
  .vue-component.vue-avatar-editor .col-avatar {
    max-height: 65vh;
    overflow-y: auto;
  }
}
.vue-component.vue-avatar-editor .avatar-canvas {
  width: 100%;
  max-width: 100%;
  height: auto;
  aspect-ratio: 1/1;
  border-radius: 50%;
  overflow: hidden;
  background-color: #e7e8f0;
}
.vue-component.vue-avatar-editor .avatar-canvas #svg_canvas {
  height: 100%;
  width: 100%;
}
.vue-component.vue-avatar-editor .avatar-canvas #svg_canvas svg {
  height: 100%;
  width: 100%;
}
.vue-component.vue-avatar-editor .btn-feature {
  width: 56px;
  height: 56px;
  border: 2px solid transparent;
  background-color: #e7e8f0;
  border-radius: 8px;
  aspect-ratio: 1/1;
  position: relative;
  /*
  &.face img{
     transform: scale(2.5);
  }

  &.beard img{
      transform: scale(2.0);
   }

   &.accessories img{
      transform: scale(2.0);
   }
      */
}
.vue-component.vue-avatar-editor .btn-feature .btn-feature-remove {
  position: absolute;
  z-index: 10;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  background-size: cover;
  background-position: center;
  border: 0;
  background-color: transparent;
}
.vue-component.vue-avatar-editor .btn-feature img {
  width: 100%;
  object-fit: cover;
  object-position: center;
}
.vue-component.vue-avatar-editor .btn-feature.active {
  border: 2px solid #4b4b95;
}
.vue-component.vue-avatar-editor .btn-color {
  width: 56px;
  height: 56px;
  border: 0;
  background-color: #e7e8f0;
  border-radius: 28px;
  aspect-ratio: 1/1;
  text-align: center;
  overflow: hidden;
}
.vue-component.vue-avatar-editor .btn-color .color-swatch {
  width: 32px;
  height: 32px;
  border-radius: 16px;
  margin: 0 auto;
  border: 0.5px solid #D3D3D3;
}
.vue-component.vue-avatar-editor .btn-color.active {
  border: 2px solid #4b4b95;
}
.vue-component.vue-avatar-editor .btn-picker {
  display: inline-block;
  height: 56px;
  border: 0;
  background-color: #e7e8f0;
  border-radius: 8px;
  padding: 12px;
  margin-top: 20px;
}
.vue-component.vue-avatar-editor .btn-picker .vc-color-wrap {
  display: inline-block;
  width: 32px !important;
  height: 32px !important;
  border-radius: 16px !important;
  margin: 0 auto;
  border: 0.5px solid #D3D3D3;
  box-shadow: none;
}
.vue-component.vue-avatar-editor .btn-picker img {
  width: 24px;
  height: 24px;
  margin-left: 8px;
}
.vue-component.vue-avatar-editor .section-title {
  color: #f65d5d;
  text-transform: uppercase;
  text-align: left;
}
.vue-component.vue-avatar-editor .section-label {
  color: #4b4b95;
  text-transform: uppercase;
  text-align: left;
  margin-bottom: 0;
}
.vue-component.vue-avatar-editor .section-label a {
  font-size: 0.9rem;
  margin-left: 8px;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: #4b4b95;
}
.vue-component.vue-avatar-editor .splide .splide__arrow {
  background-color: transparent;
  border: 1px solid #4b4b95;
  height: 46px;
  width: 46px;
}
.vue-component.vue-avatar-editor .splide .splide__arrow svg {
  fill: #4b4b95;
}
.vue-component.vue-avatar-editor .splide .splide__track {
  padding: 10px;
}
.vue-component.vue-avatar-editor .splide.splide-3 .splide__track {
  margin: 10px 20%;
}
.vue-component.vue-avatar-editor .splide.splide-4 .splide__track {
  margin: 10px 16.6666666667%;
}
.vue-form-support .card {
  background-color: white;
}
.vue-form-support .card .card-header {
  background-color: transparent;
}
.vue-form-support .card .card-header h3, .vue-form-support .card .card-header .h3 {
  color: #9ea3b8;
  font-weight: 700;
  margin: 0.25em 0;
}
.vue-form-support .card .card-header h3 .ci, .vue-form-support .card .card-header .h3 .ci {
  top: 0.1rem;
  position: relative;
  font-weight: 600;
  margin-right: 0.35rem;
}
.vue-form-support .card .card-body .btn-file {
  font-size: 0.75rem;
  border-radius: 0.5rem;
}
.vue-form-support .card .card-footer {
  background-color: transparent;
  border-top: none;
}
.vue-kit-order-widget .btn-circle {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #9ea3b8;
  -webkit-text-decoration: none;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  padding: 3px 0px;
}
.vue-kit-order-widget .btn-circle i {
  font-size: 16px;
  color: #9ea3b8;
}
.vue-kit-order-widget .btn-circle:hover, .vue-kit-order-widget .btn-circle:focus, .vue-kit-order-widget .btn-circle.active {
  background-color: #9ea3b8;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.vue-kit-order-widget .btn-circle:hover i, .vue-kit-order-widget .btn-circle:focus i, .vue-kit-order-widget .btn-circle.active i {
  color: white;
}
.vue-kit-order-widget .step-title {
  margin-bottom: 1rem;
  text-transform: uppercase;
  color: #f29a5f;
  font-size: 1.75rem;
  font-weight: 700;
}
.vue-kit-order-widget .step-title .step-number {
  color: black;
  padding-right: 1rem;
}
.vue-kit-order-widget .alert-info {
  border: 0;
  background-color: #bad4fe;
  color: #4b4b95;
}
.vue-kit-order-widget .card {
  border: 0;
  border-radius: 1rem;
}
.vue-kit-order-widget .card-trasparent {
  background-color: transparent !important;
}
.vue-kit-order-widget .nav-tabs .nav-item .nav-link {
  border: 0;
  outline: 0;
  text-transform: uppercase;
  color: #f65d5d;
  font-size: 1.25rem;
  font-weight: 700;
  padding: 0.5rem 1rem;
}
.vue-kit-order-widget .nav-tabs .nav-item .nav-link.active {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.vue-kit-order-widget .nav-panel {
  background-color: white;
  padding: 1rem;
  border-top-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.vue-kit-order-widget .policy-container {
  font-size: 0.75rem;
  background-color: #e7e8f0;
  border-radius: 10px;
  padding: 1rem;
  height: 100px;
  overflow-y: scroll;
}
.vue-kit-order-widget .policy-container::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 0.5rem;
  background-color: #ffffff;
}
.vue-kit-order-widget .policy-container::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: lightgray;
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.75);
}
.vue-tag-cloud {
  list-style: none;
  padding-left: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  -moz-column-gap: 3rem;
       column-gap: 3rem;
  max-width: 450px;
  text-transform: uppercase;
}
.vue-tag-cloud li {
  color: var(--color);
  font-size: calc(var(--size) * 0.25rem + 0.5rem);
  font-weight: 600;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.vue-tag-cloud li:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.vue-tag-cloud li.size-0 {
  --size: 1.5;
  --color: #d27366;
  text-transform: none;
}
.vue-tag-cloud li.size-1 {
  --size: 2.4;
  --color: #9a6666;
}
.vue-tag-cloud li.size-2 {
  --size: 4;
  --color: #f65d5d;
}
.vue-tag-cloud li.size-3 {
  --size: 6;
  --color: #f65d5d;
}
.vue-tag-list {
  list-style: none;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  row-gap: 0.65rem;
  font-size: 0.85em;
  -moz-column-gap: 0.65rem;
       column-gap: 0.65rem;
}
@media (max-width: 1023.98px) {
  .vue-tag-list {
    flex-direction: row;
    overflow-x: scroll;
    padding-bottom: 0.75rem;
  }
  .vue-tag-list::-webkit-scrollbar {
    height: 9px;
    border: 1px solid #d27366;
    border-radius: 6px;
  }
  .vue-tag-list::-webkit-scrollbar-track {
    background: none;
  }
  .vue-tag-list::-webkit-scrollbar-thumb {
    background: #e7e8f0;
    border-radius: 6px;
    background-color: #f65d5d;
  }
  .vue-tag-list::-webkit-scrollbar-thumb:hover {
    background: #f32d2d;
  }
  .vue-tag-list .tag {
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
    flex-wrap: nowrap;
  }
  .vue-tag-list .tag-name, .vue-tag-list .tag-count {
    text-wrap: nowrap;
  }
}
.vue-tag-list li {
  --bgColor: none;
  --fgColor: #d27366;
  padding: 0.5rem 2.35rem;
  cursor: pointer;
  border-radius: 5rem;
  display: flex;
  justify-content: space-between;
  color: var(--fgColor);
  border: 1px solid var(--fgColor);
  background-color: var(--bgColor);
  flex-wrap: wrap;
  row-gap: 0.25rem;
  transition: background-color 0.15s, color 0.15s;
}
.vue-tag-list li .tag-name {
  text-transform: uppercase;
}
.vue-tag-list li a.tag {
  display: flex;
  justify-content: space-between;
  row-gap: 0.25rem;
  width: 100%;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: inherit;
  display: flex;
  transition: color 0.15s;
}
.vue-tag-list li:hover {
  border-color: #d27366;
  --bgColor: #d27366;
  --fgColor: #ffffff;
}
.vue-tag-list li:first-child {
  border-color: #f65d5d;
  --bgColor: #f65d5d;
  --fgColor: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  background-size: 0.9rem;
  background-repeat: no-repeat;
  background-position: top 10px left 16px;
}
.vue-tag-list li:first-child:hover {
  background-image: none;
  --bgColor: none;
  --fgColor: #f65d5d;
}
.vue-tag-list li:nth-child(2), .vue-tag-list li:nth-child(3) {
  border-color: #d27366;
  --bgColor: #d27366;
  --fgColor: #ffffff;
}
.vue-tag-list li:nth-child(2):hover, .vue-tag-list li:nth-child(3):hover {
  --bgColor: none;
  --fgColor: #d27366;
}
.vue-tag-list-show-more {
  background: none;
  border: none;
  color: #d27366;
  font-weight: 600;
  transition: background-color 0.25s, color 0.25s;
}
.vue-tag-list-show-more .ci {
  border: 1px solid #d27366;
  border-radius: 50%;
  margin-left: 0.35rem;
  width: 25px;
  height: 25px;
  display: inline-block;
  font-size: 0.35rem;
  position: relative;
  top: -12px;
  transition: background-color 0.25s, color 0.1s;
}
.vue-tag-list-show-more .ci::before {
  position: relative;
  top: 9px;
}
.vue-tag-list-show-more:hover {
  color: #f65d5d;
}
.vue-tag-list-show-more:hover .ci {
  border: 1px solid #f65d5d;
  background-color: #f65d5d;
  color: #ffffff;
}
.vue-user-wall-slider .slide-card {
  position: relative;
  height: 100%;
  border: 0;
  overflow: hidden;
}
.vue-user-wall-slider .slide-card .slide-content {
  height: 100%;
}
.vue-user-wall-slider .slide-card .slide-content .slide-eyelet {
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: bold;
}
.vue-user-wall-slider .slide-card .slide-content .slide-image {
  width: 100%;
  max-width: 100%;
}
.vue-user-wall-slider .slide-card .slide-cta {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.vue-user-wall-slider .slide-card .slide-cta .btn, .vue-user-wall-slider .slide-card .slide-cta .gform_wrapper input[type=submit], .gform_wrapper .vue-user-wall-slider .slide-card .slide-cta input[type=submit], .vue-user-wall-slider .slide-card .slide-cta .gform_wrapper .button, .gform_wrapper .vue-user-wall-slider .slide-card .slide-cta .button {
  cursor: pointer;
  transition: all 100ms;
}
.vue-user-wall-slider .slide-card .slide-cta .btn:hover, .vue-user-wall-slider .slide-card .slide-cta .gform_wrapper input[type=submit]:hover, .gform_wrapper .vue-user-wall-slider .slide-card .slide-cta input[type=submit]:hover, .vue-user-wall-slider .slide-card .slide-cta .gform_wrapper .button:hover, .gform_wrapper .vue-user-wall-slider .slide-card .slide-cta .button:hover {
  transform: scale(1.05);
}
.vue-user-wall-slider .splide__pagination {
  bottom: -1rem;
}
.vue-user-wall-slider .splide__pagination li > * {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #d27366;
  opacity: 0.35;
  transition: opacity 500ms;
  margin: 0 0.5rem;
  cursor: pointer;
}
.vue-user-wall-slider .splide__pagination li > *.is-active {
  opacity: 1;
  transform: none;
}
.vue-user-wall-slider .splide__pagination li > *:hover {
  opacity: 1;
}
@media (max-width: 575.98px) {
  .vue-user-wall-slider .splide__pagination {
    display: none;
  }
}
.vue-overlay-container {
  z-index: 18;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(38, 23, 34, 0.85);
  padding-top: 90px;
  overflow: auto;
}
.vue-overlay-container .btn-buttons-container {
  position: fixed;
  z-index: 19;
  top: 90px;
  right: 30px;
  padding-right: 10px;
}
@media (max-width: 575.98px) {
  .vue-overlay-container .btn-buttons-container {
    top: 130px;
    right: 0;
    padding-right: 4px;
  }
}
.vue-overlay-container .btn-circle {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: #e7e8f0;
  -webkit-text-decoration: none;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  padding-top: 10px;
}
.vue-overlay-container .btn-circle:hover {
  background-color: #9ea3b8;
}
.vue-overlay-container .btn-circle i {
  font-size: 20px;
  line-height: 20px;
  color: #261722;
}
@media (max-width: 575.98px) {
  .vue-overlay-container .btn-circle {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    padding-top: 4px;
  }
  .vue-overlay-container .btn-circle i {
    font-size: 15px;
    line-height: 15px;
  }
}
.vue-overlay-container .btn-circle:hover, .vue-overlay-container .btn-circle:focus, .vue-overlay-container .btn-circle.active {
  background-color: #9ea3b8;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.vue-overlay-container .btn-circle:hover i, .vue-overlay-container .btn-circle:focus i, .vue-overlay-container .btn-circle.active i {
  color: white;
}
.vue-overlay-container .content {
  overflow: auto;
}
.hero-brand img {
  margin-top: 20px;
  width: 350px;
}
.hero-slider {
  padding: 0;
  height: 100vh;
}
.hero-slider .splide__track {
  height: 100%;
}
.hero-slider .splide__track .splide__slide {
  background-size: cover;
  background-position: center center;
}
.hero-slider .splide__track .splide__slide .slide-title {
  line-height: 1em;
  font-size: calc(80vw/5);
  font-weight: 700;
}
@media (min-width: 576px) {
  .hero-slider .splide__track .splide__slide .slide-title {
    font-size: calc(80vw/8);
  }
}
@media (min-width: 768px) {
  .hero-slider .splide__track .splide__slide .slide-title {
    font-size: calc(80vw/10);
  }
}
@media (min-width: 1024px) {
  .hero-slider .splide__track .splide__slide .slide-title {
    font-size: calc(80vw/14);
  }
}
@media (min-width: 1200px) {
  .hero-slider .splide__track .splide__slide .slide-title {
    font-size: 80px;
  }
}
@media (min-width: 768px) {
  .hero-slider .splide__track .splide__slide .slide-title {
    width: 85%;
  }
}
@media (min-width: 1200px) {
  .hero-slider .splide__track .splide__slide .slide-title {
    width: 65%;
  }
}
.hero-slider.custom-navigation .splide-controls {
  --controlsColor: #ffffff;
}
.preview-slider {
  padding: 0;
}
.preview-slider .splide__track {
  height: 100%;
}
.preview-slider .splide__track .splide__slide {
  background-size: cover;
  background-position: center;
}
.section-intro {
  background-color: #bad4fe;
}
.section-intro .cards .card {
  background-color: transparent;
  border: 2px solid #5f9fe7;
  padding: 1.5rem;
  border-radius: 20px;
}
.section-intro .cards .card img.cover {
  display: block;
  margin-bottom: 1rem;
}
.section-intro .cards .card h3.title, .section-intro .cards .card .title.h3 {
  color: #5f9fe7;
  text-transform: uppercase;
  font-weight: 900;
  line-height: 1em;
  font-size: calc(40vw/5);
}
@media (min-width: 576px) {
  .section-intro .cards .card h3.title, .section-intro .cards .card .title.h3 {
    font-size: calc(40vw/8);
  }
}
@media (min-width: 768px) {
  .section-intro .cards .card h3.title, .section-intro .cards .card .title.h3 {
    font-size: calc(40vw/10);
  }
}
@media (min-width: 1024px) {
  .section-intro .cards .card h3.title, .section-intro .cards .card .title.h3 {
    font-size: calc(40vw/14);
  }
}
@media (min-width: 1200px) {
  .section-intro .cards .card h3.title, .section-intro .cards .card .title.h3 {
    font-size: 40px;
  }
}
.section-intro .cards .card p {
  line-height: 1em;
  font-size: calc(30vw/5);
  color: #261722;
  font-weight: 600;
  line-height: 1.2em;
}
@media (min-width: 576px) {
  .section-intro .cards .card p {
    font-size: calc(30vw/8);
  }
}
@media (min-width: 768px) {
  .section-intro .cards .card p {
    font-size: calc(30vw/10);
  }
}
@media (min-width: 1024px) {
  .section-intro .cards .card p {
    font-size: calc(30vw/14);
  }
}
@media (min-width: 1200px) {
  .section-intro .cards .card p {
    font-size: 30px;
  }
}
.section-intro .cards .card p.cta-box {
  flex-grow: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.section-intro .section-title {
  padding-top: 5rem;
  padding-bottom: 3.5rem;
}
.section-intro .section-title h2, .section-intro .section-title .h2 {
  margin-top: 2rem;
  color: #5f9fe7;
  line-height: 1em;
  font-size: calc(70vw/5);
  font-weight: 600;
}
@media (min-width: 576px) {
  .section-intro .section-title h2, .section-intro .section-title .h2 {
    font-size: calc(70vw/8);
  }
}
@media (min-width: 768px) {
  .section-intro .section-title h2, .section-intro .section-title .h2 {
    font-size: calc(70vw/10);
  }
}
@media (min-width: 1024px) {
  .section-intro .section-title h2, .section-intro .section-title .h2 {
    font-size: calc(70vw/14);
  }
}
@media (min-width: 1200px) {
  .section-intro .section-title h2, .section-intro .section-title .h2 {
    font-size: 70px;
  }
}
.section-intro .section-title p {
  font-size: 1.65rem;
  font-weight: 600;
  margin-top: 2rem;
}
.section-intro .section-title p strong {
  color: #5f9fe7;
  font-weight: 600;
  margin-top: 1rem;
  font-size: 1.35em;
  display: inline-block;
}
.section-intro .section-title img {
  height: auto;
  display: block;
  margin: 0 auto 0.5rem auto;
  width: 80%;
}
@media (min-width: 576px) {
  .section-intro .section-title img {
    width: 40%;
  }
}
@media (min-width: 768px) {
  .section-intro .section-title img {
    width: 50%;
  }
}
@media (min-width: 1024px) {
  .section-intro .section-title img {
    width: 50%;
  }
}
@media (min-width: 1200px) {
  .section-intro .section-title img {
    width: 50%;
    max-width: 625px;
  }
}
@media (min-width: 768px) {
  .section-intro .preview-slider::before, .section-intro .preview-slider::after {
    content: " ";
    height: 100%;
    position: absolute;
    top: 0;
    width: 5vw;
    z-index: 1;
    background: linear-gradient(90deg, #bad4fe 0%, rgba(0, 0, 0, 0) 100%);
  }
  .section-intro .preview-slider::after {
    background: linear-gradient(-90deg, #bad4fe 0%, rgba(0, 0, 0, 0) 100%);
    right: 0;
  }
}
.section-intro .preview-slider .splide__slide {
  transition: transform 0.2s;
}
.section-intro .preview-slider .splide__slide a.slider-link {
  -webkit-text-decoration: none;
  text-decoration: none;
}
.section-intro .preview-slider .splide__slide:hover {
  transform: scale(1.02);
}
.section-intro .preview-slider .splide-controls {
  --controlsColor: #5f9fe7;
}
.section-intro .preview-slider .see-more {
  position: absolute;
  bottom: 1rem;
  z-index: 4;
  color: #ffffff;
  border: 1px solid #ffffff;
  padding: 10px;
  border-radius: 50%;
  max-height: 38px;
  aspect-ratio: 1;
}
.section-intro .preview-slider .see-more:hover {
  background-color: rgba(255, 255, 255, 0.55);
}
.section-intro .preview-slider .see-more .ci {
  display: block;
  transition: background-color 0.5s;
}
.section-intro .preview-slider .see-more .ci.ci-play {
  left: 1px;
  position: relative;
}
.section-intro .preview-slider .splide__track .splide__slide {
  background-size: cover;
}
.section-intro .preview-slider .splide__track .splide__slide .slide-content {
  position: relative;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.85) 0, rgba(0, 0, 0, 0) 90%);
}
.section-intro .preview-slider .splide__track .splide__slide .slide-content .slide-title {
  font-size: 2rem;
  font-weight: 800;
  text-transform: uppercase;
}
.section-intro .preview-slider .splide__track .splide__slide .slide-content .slide-text {
  font-size: 1.45rem;
  line-height: 1.2em;
  font-weight: 500;
  max-width: 80%;
  min-height: 180px;
}
.section-intro .preview-slider .splide__track .splide__slide .slide-illustration {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: auto 75%;
  z-index: 2;
}
.section-preview {
  background-color: #fbc8bb;
}
.section-preview .section-title {
  line-height: 1em;
  font-size: calc(70vw/5);
  color: #d27366;
  text-align: center;
  font-weight: 700;
}
@media (min-width: 576px) {
  .section-preview .section-title {
    font-size: calc(70vw/8);
  }
}
@media (min-width: 768px) {
  .section-preview .section-title {
    font-size: calc(70vw/10);
  }
}
@media (min-width: 1024px) {
  .section-preview .section-title {
    font-size: calc(70vw/14);
  }
}
@media (min-width: 1200px) {
  .section-preview .section-title {
    font-size: 70px;
  }
}
.section-preview .section-title .red {
  text-transform: uppercase;
  font-weight: 900;
  color: #f65d5d;
}
.section-preview .preview-slider {
  padding-bottom: 5rem;
  height: 800px;
}
.section-preview .preview-slider .splide__track .splide__slide {
  background-size: cover;
}
.section-preview .preview-slider .splide__track .splide__slide .slide-content {
  position: relative;
  background: linear-gradient(0deg, rgb(0, 0, 0) 0, rgba(0, 0, 0, 0) 200px);
}
.section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-title {
  line-height: 1em;
  font-size: calc(70vw/5);
  font-weight: 800;
  text-transform: uppercase;
}
@media (min-width: 576px) {
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-title {
    font-size: calc(70vw/8);
  }
}
@media (min-width: 768px) {
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-title {
    font-size: calc(70vw/10);
  }
}
@media (min-width: 1024px) {
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-title {
    font-size: calc(70vw/14);
  }
}
@media (min-width: 1200px) {
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-title {
    font-size: 70px;
  }
}
.section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-text {
  line-height: 1em;
  font-size: calc(40vw/5);
  font-weight: 500;
  max-width: 80%;
}
@media (min-width: 576px) {
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-text {
    font-size: calc(40vw/8);
  }
}
@media (min-width: 768px) {
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-text {
    font-size: calc(40vw/10);
  }
}
@media (min-width: 1024px) {
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-text {
    font-size: calc(40vw/14);
  }
}
@media (min-width: 1200px) {
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-text {
    font-size: 40px;
  }
}
.section-preview .preview-slider .splide__track .splide__slide .slide-illustration {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: auto 75%;
  z-index: 2;
}
@media (max-width: 1023.98px) {
  .section-preview {
    padding-bottom: 120px;
  }
}
.intro-preview-gradient {
  width: 100%;
  background: linear-gradient(0deg, #fbc8bb 0%, #bad4fe 100%);
}
@media (max-width: 767.98px) {
  .hero-brand img {
    margin-top: 3rem;
    width: 320px;
  }
  .hero-slider .splide__track .splide__slide::after {
    background: #000;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
    content: " ";
    display: block;
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
  }
  .hero-slider .splide__track .splide__slide .slide-content {
    z-index: 2;
  }
  .hero-slider .splide__track .splide__slide .slide-content .slide-title {
    font-size: 2.8rem;
  }
  .hero-slider .splide-controls {
    height: calc(64px + 3rem);
  }
  .intro-preview-gradient {
    min-height: 5rem;
  }
  .section-preview .section-title {
    font-size: 3rem;
  }
  .section-preview .preview-slider .splide__track .splide__slide .slide-content > div {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%);
  }
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-title {
    font-size: 2rem;
  }
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-title > img {
    width: 95% !important;
  }
  .section-preview .preview-slider .splide__track .splide__slide .slide-content .slide-text {
    font-size: 1.25rem;
    max-width: 100%;
  }
  .section-preview .preview-slider .slide-bg-mobi {
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: center;
    display: block !important;
  }
  .section-intro .section-title {
    font-size: 3rem;
    padding-bottom: 2rem;
  }
}
@media (max-width: 1023.98px) {
  .section-intro .section-title {
    padding-bottom: 2.5rem;
  }
  .intro-preview-gradient {
    min-height: 8rem;
  }
  .section-intro .section-title {
    padding-bottom: 3rem;
  }
}
.homepage-wrapper {
  background-color: #fbc8bb;
}
.wall-title h2, .wall-title .h2 {
  font-size: 3rem;
  color: #d27366;
  font-weight: 600;
}
.wall-title h2 img, .wall-title .h2 img {
  height: 2.85rem;
  width: auto;
  position: relative;
  bottom: 10px;
}
@media (max-width: 1399.98px) {
  .btn.btn-unisciti, .gform_wrapper input.btn-unisciti[type=submit], .gform_wrapper .btn-unisciti.button {
    padding-left: 5rem !important;
    padding-right: 0.5rem !important;
  }
  .btn.btn-unisciti .icon, .gform_wrapper input.btn-unisciti[type=submit] .icon, .gform_wrapper .btn-unisciti.button .icon {
    left: 21px;
  }
}
div.btn-unisciti {
  position: sticky;
  bottom: 0;
  right: 0;
  z-index: 20;
  padding: 1rem;
  width: max-content;
  margin-left: auto;
}
@media (max-width: 1023.98px) {
  div.btn-unisciti {
    left: 0;
  }
}
.page-template-template-bacheca,
.page-template-template-segnalibri {
  --pageBgColor: #fbc8bb;
  --pageFgColor: #d27366;
}
.page-template-template-bacheca .site-nav,
.page-template-template-segnalibri .site-nav {
  --navBgColor: #fbc8bb;
  --navFgColor: #d27366;
}
.page-template-template-bacheca .content-title,
.page-template-template-segnalibri .content-title {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 800;
}
@media (min-width: 1200px) {
  .page-template-template-bacheca .content-title,
  .page-template-template-segnalibri .content-title {
    font-size: 4rem;
  }
}
.page-template-template-bacheca .content-title .ci,
.page-template-template-segnalibri .content-title .ci {
  position: relative;
  top: 6px;
  right: 6px;
}
.page-template-template-bacheca .btn-bookmark .ci,
.page-template-template-segnalibri .btn-bookmark .ci {
  margin-left: 1.5rem;
}
.page-template-template-bacheca .btn-bookmark .ci::before,
.page-template-template-segnalibri .btn-bookmark .ci::before {
  font-size: 2em;
  position: absolute;
  top: 8px;
  left: 1.5rem;
}
.bg-bacheca {
  background-color: #fbc8bb;
}
.page-template-template-cpt-archive,
.page-template-template-magazine-archive {
  --pageBgColor: #fbc8bb;
  --pageFgColor: #d27366;
}
.page-template-template-cpt-archive .page-header-wrapper .page-header-picture,
.page-template-template-magazine-archive .page-header-wrapper .page-header-picture {
  width: 66.6666%;
  margin-bottom: 2rem;
}
@media (max-width: 767.98px) {
  .page-template-template-cpt-archive .page-header-wrapper .page-header-picture,
  .page-template-template-magazine-archive .page-header-wrapper .page-header-picture {
    width: 90%;
    padding-left: 5%;
  }
}
.page-template-template-cpt-archive .page-header-wrapper.has-picture h1, .page-template-template-cpt-archive .page-header-wrapper.has-picture .h1,
.page-template-template-magazine-archive .page-header-wrapper.has-picture h1,
.page-template-template-magazine-archive .page-header-wrapper.has-picture .h1 {
  display: none !important;
}
.page-template-template-cpt-archive .site-nav,
.page-template-template-magazine-archive .site-nav {
  position: fixed;
  width: 100%;
  --navBgColor: #fbc8bb;
  --navFgColor: #d27366;
  transition: background-color 0.35s;
}
.page-template-template-cpt-archive .site-nav.header-alt-light,
.page-template-template-magazine-archive .site-nav.header-alt-light {
  background: none;
  --navBgColor: #ffffff;
  --navFgColor: rgba(255, 255, 255, 0.65);
  box-shadow: none;
}
.page-template-template-cpt-archive .archives-template,
.page-template-template-magazine-archive .archives-template {
  background-color: #fbc8bb;
}
.page-template-template-cpt-archive .archives-template .archive-description,
.page-template-template-magazine-archive .archives-template .archive-description {
  line-height: 1em;
  font-size: calc(30vw/5);
  line-height: 1.25em;
}
@media (min-width: 576px) {
  .page-template-template-cpt-archive .archives-template .archive-description,
  .page-template-template-magazine-archive .archives-template .archive-description {
    font-size: calc(30vw/8);
  }
}
@media (min-width: 768px) {
  .page-template-template-cpt-archive .archives-template .archive-description,
  .page-template-template-magazine-archive .archives-template .archive-description {
    font-size: calc(30vw/10);
  }
}
@media (min-width: 1024px) {
  .page-template-template-cpt-archive .archives-template .archive-description,
  .page-template-template-magazine-archive .archives-template .archive-description {
    font-size: calc(30vw/14);
  }
}
@media (min-width: 1200px) {
  .page-template-template-cpt-archive .archives-template .archive-description,
  .page-template-template-magazine-archive .archives-template .archive-description {
    font-size: 30px;
  }
}
.page-template-template-cpt-archive .archives-template .archive-description p strong,
.page-template-template-magazine-archive .archives-template .archive-description p strong {
  color: #f65d5d;
}
.page-template-template-cpt-archive .archives-template .archive-description p .desc-image,
.page-template-template-magazine-archive .archives-template .archive-description p .desc-image {
  width: 100%;
  margin-bottom: 2rem;
}
.page-template-template-cpt-archive .archives-template .archive-description .strong,
.page-template-template-magazine-archive .archives-template .archive-description .strong {
  font-weight: 700;
  line-height: 1em;
  font-size: calc(35vw/5);
}
@media (min-width: 576px) {
  .page-template-template-cpt-archive .archives-template .archive-description .strong,
  .page-template-template-magazine-archive .archives-template .archive-description .strong {
    font-size: calc(35vw/8);
  }
}
@media (min-width: 768px) {
  .page-template-template-cpt-archive .archives-template .archive-description .strong,
  .page-template-template-magazine-archive .archives-template .archive-description .strong {
    font-size: calc(35vw/10);
  }
}
@media (min-width: 1024px) {
  .page-template-template-cpt-archive .archives-template .archive-description .strong,
  .page-template-template-magazine-archive .archives-template .archive-description .strong {
    font-size: calc(35vw/14);
  }
}
@media (min-width: 1200px) {
  .page-template-template-cpt-archive .archives-template .archive-description .strong,
  .page-template-template-magazine-archive .archives-template .archive-description .strong {
    font-size: 35px;
  }
}
.page-template-template-cpt-archive .archives-template .archive-description .red,
.page-template-template-magazine-archive .archives-template .archive-description .red {
  color: #f65d5d;
}
.page-template-template-cpt-archive .archives-template .archives-col .archive-description,
.page-template-template-magazine-archive .archives-template .archives-col .archive-description {
  line-height: 1em;
  font-size: calc(20vw/5);
  line-height: 1.45em;
}
@media (min-width: 576px) {
  .page-template-template-cpt-archive .archives-template .archives-col .archive-description,
  .page-template-template-magazine-archive .archives-template .archives-col .archive-description {
    font-size: calc(20vw/8);
  }
}
@media (min-width: 768px) {
  .page-template-template-cpt-archive .archives-template .archives-col .archive-description,
  .page-template-template-magazine-archive .archives-template .archives-col .archive-description {
    font-size: calc(20vw/10);
  }
}
@media (min-width: 1024px) {
  .page-template-template-cpt-archive .archives-template .archives-col .archive-description,
  .page-template-template-magazine-archive .archives-template .archives-col .archive-description {
    font-size: calc(20vw/14);
  }
}
@media (min-width: 1200px) {
  .page-template-template-cpt-archive .archives-template .archives-col .archive-description,
  .page-template-template-magazine-archive .archives-template .archives-col .archive-description {
    font-size: 20px;
  }
}
@media (max-width: 767.98px) {
  .page-template-template-cpt-archive .archives-template .archives-col .archive-description,
  .page-template-template-magazine-archive .archives-template .archives-col .archive-description {
    line-height: 1em;
    font-size: calc(30vw/5);
    line-height: 1.45em;
  }
}
@media (max-width: 767.98px) and (min-width: 576px) {
  .page-template-template-cpt-archive .archives-template .archives-col .archive-description,
  .page-template-template-magazine-archive .archives-template .archives-col .archive-description {
    font-size: calc(30vw/8);
  }
}
@media (max-width: 767.98px) and (min-width: 768px) {
  .page-template-template-cpt-archive .archives-template .archives-col .archive-description,
  .page-template-template-magazine-archive .archives-template .archives-col .archive-description {
    font-size: calc(30vw/10);
  }
}
@media (max-width: 767.98px) and (min-width: 1024px) {
  .page-template-template-cpt-archive .archives-template .archives-col .archive-description,
  .page-template-template-magazine-archive .archives-template .archives-col .archive-description {
    font-size: calc(30vw/14);
  }
}
@media (max-width: 767.98px) and (min-width: 1200px) {
  .page-template-template-cpt-archive .archives-template .archives-col .archive-description,
  .page-template-template-magazine-archive .archives-template .archives-col .archive-description {
    font-size: 30px;
  }
}
.page-template-template-kit-request .kit-request-form .btn, .page-template-template-kit-request .kit-request-form .gform_wrapper input[type=submit], .gform_wrapper .page-template-template-kit-request .kit-request-form input[type=submit], .page-template-template-kit-request .kit-request-form .gform_wrapper .button, .gform_wrapper .page-template-template-kit-request .kit-request-form .button,
.page-template-template-kit-request-v2 .kit-request-form .btn,
.page-template-template-kit-request-v2 .kit-request-form .gform_wrapper input[type=submit],
.gform_wrapper .page-template-template-kit-request-v2 .kit-request-form input[type=submit],
.page-template-template-kit-request-v2 .kit-request-form .gform_wrapper .button,
.gform_wrapper .page-template-template-kit-request-v2 .kit-request-form .button {
  --btnFgColor: #f65d5d;
  --btnBgColor: #ffffff;
}
body.archive {
  --pageBgColor: #fedfc1;
  --pageFgColor: #f29a5f;
}
body.archive .site-nav {
  position: fixed;
  width: 100%;
  --navBgColor: var(--pageBgColor);
  --navFgColor: var(--pageFgColor);
  transition: background-color 0.35s;
}
body.archive .site-nav.header-alt-light {
  background: none;
  --navBgColor: #ffffff;
  --navFgColor: rgba(255, 255, 255, 0.65);
  box-shadow: none;
}
body.archive main {
  background-color: var(--pageBgColor);
}
body.archive main .page-header-wrapper {
  padding-bottom: 0;
}
body.archive main .page-header-wrapper .page-header {
  height: calc(max(250px, 40vh) + 30px);
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0) 35%);
}
body.archive main .page-header-wrapper .page-header .page-header-picture {
  width: min(30rem, 100%);
  padding-bottom: 1.5rem;
}
body.archive main .page-header-wrapper ~ div .content-title {
  margin-top: 4rem;
}
body.archive main .content-title {
  margin-top: 7rem;
  margin-bottom: 2rem;
  color: var(--pageFgColor);
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 800;
}
@media (min-width: 1200px) {
  body.archive main .content-title {
    font-size: 4rem;
  }
}
body.archive.tax-collection {
  --pageBgColor: #fbc8bb;
  --pageFgColor: #d27366;
}
body.archive.tax-collection .tax-header img {
  max-height: 14rem;
}
body.archive.tax-collection .tax-description {
  font-size: calc(1.305rem + 0.66vw);
}
@media (min-width: 1200px) {
  body.archive.tax-collection .tax-description {
    font-size: 1.8rem;
  }
}
body.archive.tax-collection .tax-description strong {
  color: var(--pageFgColor);
  font-weight: 600;
}
body.archive.tax-collection .archive-text {
  color: var(--pageFgColor);
  font-weight: 800;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  body.archive.tax-collection .archive-text {
    font-size: 2.5rem;
  }
}
body.archive.tax-collection .side-box img {
  max-height: 10rem;
}
body.page-template-template-editor-storia main {
  background-color: #bad4fe !important;
}
body.page-template-template-editor-storia h2, body.page-template-template-editor-storia .h2 {
  color: #4b4b95;
  font-weight: 600;
}
body.page-template-template-editor-storia h2 i, body.page-template-template-editor-storia .h2 i {
  font-size: 1.2em;
  font-weight: 400;
  position: relative;
  top: 0.25rem;
}
body.page-template-template-faq main {
  background-color: #bad4fe !important;
  padding-bottom: 4.5rem;
}
body.page-template-template-faq .page-header {
  padding-top: 4.5rem;
  padding-bottom: 1.5rem;
}
body.page-template-template-faq .page-header h1, body.page-template-template-faq .page-header .h1 {
  color: #5f9fe7;
  font-weight: 700;
}
body.page-template-template-faq .faq .faq-question {
  border-bottom: 1px solid #5f9fe7;
  padding: 0.5rem;
}
body.page-template-template-faq .faq .faq-question .faq-question-text {
  color: #5f9fe7;
  text-transform: uppercase;
  font-size: 1.25rem;
  font-weight: 700;
  -webkit-text-decoration: none;
  text-decoration: none;
}
body.page-template-template-faq .faq .faq-question .faq-question-toggler {
  border: 1px solid #5f9fe7;
  background-color: transparent;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  transition: all 500ms;
}
body.page-template-template-faq .faq .faq-question .faq-question-toggler:hover {
  background-color: white;
}
body.page-template-template-faq .faq .faq-question .faq-question-toggler .ci {
  color: #5f9fe7;
  font-size: 9px;
}
body.page-template-template-faq .faq .faq-question .faq-question-toggler:not(.collapsed) {
  transform: rotate(180deg);
}
body.page-template-template-faq .faq .faq-answer {
  padding: 1rem 0.5rem;
}
body.page-template-template-support main {
  background-color: #bad4fe !important;
  padding-bottom: 4.5rem;
}
body.page-template-template-support .page-header {
  padding-top: 4.5rem;
  padding-bottom: 1.5rem;
}
body.page-template-template-support .page-header h1, body.page-template-template-support .page-header .h1 {
  color: #5f9fe7;
  font-weight: 700;
}
.single-kit,
.single-post,
.single-story,
.single-teacher,
.single-webinar,
.single-contest,
.single-pcto,
.page-template-template-pagina-utente,
.page-template-template-kit-request,
.page-template-template-kit-request-v2,
.single-landing-page {
  --pageBgColor: #fedfc1;
  --pageFgColor: #f29a5f;
}
.single-kit main,
.single-post main,
.single-story main,
.single-teacher main,
.single-webinar main,
.single-contest main,
.single-pcto main,
.page-template-template-pagina-utente main,
.page-template-template-kit-request main,
.page-template-template-kit-request-v2 main,
.single-landing-page main {
  background-color: var(--pageBgColor);
}
.single-kit .site-nav,
.single-post .site-nav,
.single-story .site-nav,
.single-teacher .site-nav,
.single-webinar .site-nav,
.single-contest .site-nav,
.single-pcto .site-nav,
.page-template-template-pagina-utente .site-nav,
.page-template-template-kit-request .site-nav,
.page-template-template-kit-request-v2 .site-nav,
.single-landing-page .site-nav {
  --navBgColor: var(--pageBgColor);
  --navFgColor: var(--pageFgColor);
}
.single-kit .post-date,
.single-post .post-date,
.single-story .post-date,
.single-teacher .post-date,
.single-webinar .post-date,
.single-contest .post-date,
.single-pcto .post-date,
.page-template-template-pagina-utente .post-date,
.page-template-template-kit-request .post-date,
.page-template-template-kit-request-v2 .post-date,
.single-landing-page .post-date {
  color: #f29a5f;
  font-size: 1.25rem;
  text-transform: uppercase;
}
.single-kit .post-date small, .single-kit .post-date .small,
.single-post .post-date small,
.single-post .post-date .small,
.single-story .post-date small,
.single-story .post-date .small,
.single-teacher .post-date small,
.single-teacher .post-date .small,
.single-webinar .post-date small,
.single-webinar .post-date .small,
.single-contest .post-date small,
.single-contest .post-date .small,
.single-pcto .post-date small,
.single-pcto .post-date .small,
.page-template-template-pagina-utente .post-date small,
.page-template-template-pagina-utente .post-date .small,
.page-template-template-kit-request .post-date small,
.page-template-template-kit-request .post-date .small,
.page-template-template-kit-request-v2 .post-date small,
.page-template-template-kit-request-v2 .post-date .small,
.single-landing-page .post-date small,
.single-landing-page .post-date .small {
  font-size: 0.75rem;
}
.single-kit .post-date,
.single-post .post-date,
.single-story .post-date,
.single-teacher .post-date,
.single-webinar .post-date,
.single-contest .post-date,
.single-pcto .post-date,
.page-template-template-pagina-utente .post-date,
.page-template-template-kit-request .post-date,
.page-template-template-kit-request-v2 .post-date,
.single-landing-page .post-date {
  color: #f29a5f;
  font-size: 1.25rem;
}
.single-kit .post-author .post-author-icon,
.single-post .post-author .post-author-icon,
.single-story .post-author .post-author-icon,
.single-teacher .post-author .post-author-icon,
.single-webinar .post-author .post-author-icon,
.single-contest .post-author .post-author-icon,
.single-pcto .post-author .post-author-icon,
.page-template-template-pagina-utente .post-author .post-author-icon,
.page-template-template-kit-request .post-author .post-author-icon,
.page-template-template-kit-request-v2 .post-author .post-author-icon,
.single-landing-page .post-author .post-author-icon {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  overflow: hidden;
  object-fit: cover;
}
.single-kit .post-author .post-author-label,
.single-post .post-author .post-author-label,
.single-story .post-author .post-author-label,
.single-teacher .post-author .post-author-label,
.single-webinar .post-author .post-author-label,
.single-contest .post-author .post-author-label,
.single-pcto .post-author .post-author-label,
.page-template-template-pagina-utente .post-author .post-author-label,
.page-template-template-kit-request .post-author .post-author-label,
.page-template-template-kit-request-v2 .post-author .post-author-label,
.single-landing-page .post-author .post-author-label {
  font-size: calc(1.275rem + 0.3vw);
  font-weight: 700;
}
@media (min-width: 1200px) {
  .single-kit .post-author .post-author-label,
  .single-post .post-author .post-author-label,
  .single-story .post-author .post-author-label,
  .single-teacher .post-author .post-author-label,
  .single-webinar .post-author .post-author-label,
  .single-contest .post-author .post-author-label,
  .single-pcto .post-author .post-author-label,
  .page-template-template-pagina-utente .post-author .post-author-label,
  .page-template-template-kit-request .post-author .post-author-label,
  .page-template-template-kit-request-v2 .post-author .post-author-label,
  .single-landing-page .post-author .post-author-label {
    font-size: 1.5rem;
  }
}
.single-kit .post-summary,
.single-post .post-summary,
.single-story .post-summary,
.single-teacher .post-summary,
.single-webinar .post-summary,
.single-contest .post-summary,
.single-pcto .post-summary,
.page-template-template-pagina-utente .post-summary,
.page-template-template-kit-request .post-summary,
.page-template-template-kit-request-v2 .post-summary,
.single-landing-page .post-summary {
  font-size: calc(1.275rem + 0.3vw);
  font-weight: 900;
}
@media (min-width: 1200px) {
  .single-kit .post-summary,
  .single-post .post-summary,
  .single-story .post-summary,
  .single-teacher .post-summary,
  .single-webinar .post-summary,
  .single-contest .post-summary,
  .single-pcto .post-summary,
  .page-template-template-pagina-utente .post-summary,
  .page-template-template-kit-request .post-summary,
  .page-template-template-kit-request-v2 .post-summary,
  .single-landing-page .post-summary {
    font-size: 1.5rem;
  }
}
.single-kit .post-category,
.single-post .post-category,
.single-story .post-category,
.single-teacher .post-category,
.single-webinar .post-category,
.single-contest .post-category,
.single-pcto .post-category,
.page-template-template-pagina-utente .post-category,
.page-template-template-kit-request .post-category,
.page-template-template-kit-request-v2 .post-category,
.single-landing-page .post-category {
  color: #f29a5f !important;
  font-weight: 900;
  text-transform: uppercase;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.single-kit .post-category:hover,
.single-post .post-category:hover,
.single-story .post-category:hover,
.single-teacher .post-category:hover,
.single-webinar .post-category:hover,
.single-contest .post-category:hover,
.single-pcto .post-category:hover,
.page-template-template-pagina-utente .post-category:hover,
.page-template-template-kit-request .post-category:hover,
.page-template-template-kit-request-v2 .post-category:hover,
.single-landing-page .post-category:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.single-kit .post-content,
.single-post .post-content,
.single-story .post-content,
.single-teacher .post-content,
.single-webinar .post-content,
.single-contest .post-content,
.single-pcto .post-content,
.page-template-template-pagina-utente .post-content,
.page-template-template-kit-request .post-content,
.page-template-template-kit-request-v2 .post-content,
.single-landing-page .post-content {
  font-size: calc(1.265rem + 0.18vw);
}
@media (min-width: 1200px) {
  .single-kit .post-content,
  .single-post .post-content,
  .single-story .post-content,
  .single-teacher .post-content,
  .single-webinar .post-content,
  .single-contest .post-content,
  .single-pcto .post-content,
  .page-template-template-pagina-utente .post-content,
  .page-template-template-kit-request .post-content,
  .page-template-template-kit-request-v2 .post-content,
  .single-landing-page .post-content {
    font-size: 1.4rem;
  }
}
.single-kit .post-content a,
.single-post .post-content a,
.single-story .post-content a,
.single-teacher .post-content a,
.single-webinar .post-content a,
.single-contest .post-content a,
.single-pcto .post-content a,
.page-template-template-pagina-utente .post-content a,
.page-template-template-kit-request .post-content a,
.page-template-template-kit-request-v2 .post-content a,
.single-landing-page .post-content a {
  color: black !important;
  transition: all 0.25s;
}
.single-kit .post-content a:hover,
.single-post .post-content a:hover,
.single-story .post-content a:hover,
.single-teacher .post-content a:hover,
.single-webinar .post-content a:hover,
.single-contest .post-content a:hover,
.single-pcto .post-content a:hover,
.page-template-template-pagina-utente .post-content a:hover,
.page-template-template-kit-request .post-content a:hover,
.page-template-template-kit-request-v2 .post-content a:hover,
.single-landing-page .post-content a:hover {
  color: #9ea3b8 !important;
}
.single-kit .post-content figure.alignnone,
.single-kit .post-content img.alignnone,
.single-kit .post-content iframe,
.single-post .post-content figure.alignnone,
.single-post .post-content img.alignnone,
.single-post .post-content iframe,
.single-story .post-content figure.alignnone,
.single-story .post-content img.alignnone,
.single-story .post-content iframe,
.single-teacher .post-content figure.alignnone,
.single-teacher .post-content img.alignnone,
.single-teacher .post-content iframe,
.single-webinar .post-content figure.alignnone,
.single-webinar .post-content img.alignnone,
.single-webinar .post-content iframe,
.single-contest .post-content figure.alignnone,
.single-contest .post-content img.alignnone,
.single-contest .post-content iframe,
.single-pcto .post-content figure.alignnone,
.single-pcto .post-content img.alignnone,
.single-pcto .post-content iframe,
.page-template-template-pagina-utente .post-content figure.alignnone,
.page-template-template-pagina-utente .post-content img.alignnone,
.page-template-template-pagina-utente .post-content iframe,
.page-template-template-kit-request .post-content figure.alignnone,
.page-template-template-kit-request .post-content img.alignnone,
.page-template-template-kit-request .post-content iframe,
.page-template-template-kit-request-v2 .post-content figure.alignnone,
.page-template-template-kit-request-v2 .post-content img.alignnone,
.page-template-template-kit-request-v2 .post-content iframe,
.single-landing-page .post-content figure.alignnone,
.single-landing-page .post-content img.alignnone,
.single-landing-page .post-content iframe {
  width: 100% !important;
  margin: 1rem 0;
  border-radius: 1.25rem;
}
.single-kit .post-content figure.alignnone img,
.single-kit .post-content img.alignnone img,
.single-kit .post-content iframe img,
.single-post .post-content figure.alignnone img,
.single-post .post-content img.alignnone img,
.single-post .post-content iframe img,
.single-story .post-content figure.alignnone img,
.single-story .post-content img.alignnone img,
.single-story .post-content iframe img,
.single-teacher .post-content figure.alignnone img,
.single-teacher .post-content img.alignnone img,
.single-teacher .post-content iframe img,
.single-webinar .post-content figure.alignnone img,
.single-webinar .post-content img.alignnone img,
.single-webinar .post-content iframe img,
.single-contest .post-content figure.alignnone img,
.single-contest .post-content img.alignnone img,
.single-contest .post-content iframe img,
.single-pcto .post-content figure.alignnone img,
.single-pcto .post-content img.alignnone img,
.single-pcto .post-content iframe img,
.page-template-template-pagina-utente .post-content figure.alignnone img,
.page-template-template-pagina-utente .post-content img.alignnone img,
.page-template-template-pagina-utente .post-content iframe img,
.page-template-template-kit-request .post-content figure.alignnone img,
.page-template-template-kit-request .post-content img.alignnone img,
.page-template-template-kit-request .post-content iframe img,
.page-template-template-kit-request-v2 .post-content figure.alignnone img,
.page-template-template-kit-request-v2 .post-content img.alignnone img,
.page-template-template-kit-request-v2 .post-content iframe img,
.single-landing-page .post-content figure.alignnone img,
.single-landing-page .post-content img.alignnone img,
.single-landing-page .post-content iframe img {
  width: 100% !important;
  border-radius: 1.25rem;
}
.single-kit .post-content .wp-embed-aspect-16-9 iframe,
.single-post .post-content .wp-embed-aspect-16-9 iframe,
.single-story .post-content .wp-embed-aspect-16-9 iframe,
.single-teacher .post-content .wp-embed-aspect-16-9 iframe,
.single-webinar .post-content .wp-embed-aspect-16-9 iframe,
.single-contest .post-content .wp-embed-aspect-16-9 iframe,
.single-pcto .post-content .wp-embed-aspect-16-9 iframe,
.page-template-template-pagina-utente .post-content .wp-embed-aspect-16-9 iframe,
.page-template-template-kit-request .post-content .wp-embed-aspect-16-9 iframe,
.page-template-template-kit-request-v2 .post-content .wp-embed-aspect-16-9 iframe,
.single-landing-page .post-content .wp-embed-aspect-16-9 iframe {
  width: 100% !important;
  height: auto !important;
  aspect-ratio: 16/9;
}
.single-kit .post-content figure.aligncenter,
.single-kit .post-content img.aligncenter,
.single-post .post-content figure.aligncenter,
.single-post .post-content img.aligncenter,
.single-story .post-content figure.aligncenter,
.single-story .post-content img.aligncenter,
.single-teacher .post-content figure.aligncenter,
.single-teacher .post-content img.aligncenter,
.single-webinar .post-content figure.aligncenter,
.single-webinar .post-content img.aligncenter,
.single-contest .post-content figure.aligncenter,
.single-contest .post-content img.aligncenter,
.single-pcto .post-content figure.aligncenter,
.single-pcto .post-content img.aligncenter,
.page-template-template-pagina-utente .post-content figure.aligncenter,
.page-template-template-pagina-utente .post-content img.aligncenter,
.page-template-template-kit-request .post-content figure.aligncenter,
.page-template-template-kit-request .post-content img.aligncenter,
.page-template-template-kit-request-v2 .post-content figure.aligncenter,
.page-template-template-kit-request-v2 .post-content img.aligncenter,
.single-landing-page .post-content figure.aligncenter,
.single-landing-page .post-content img.aligncenter {
  display: block;
  margin: 1rem auto;
  border-radius: 1.25rem;
}
.single-kit .post-content figure.aligncenter img,
.single-kit .post-content img.aligncenter img,
.single-post .post-content figure.aligncenter img,
.single-post .post-content img.aligncenter img,
.single-story .post-content figure.aligncenter img,
.single-story .post-content img.aligncenter img,
.single-teacher .post-content figure.aligncenter img,
.single-teacher .post-content img.aligncenter img,
.single-webinar .post-content figure.aligncenter img,
.single-webinar .post-content img.aligncenter img,
.single-contest .post-content figure.aligncenter img,
.single-contest .post-content img.aligncenter img,
.single-pcto .post-content figure.aligncenter img,
.single-pcto .post-content img.aligncenter img,
.page-template-template-pagina-utente .post-content figure.aligncenter img,
.page-template-template-pagina-utente .post-content img.aligncenter img,
.page-template-template-kit-request .post-content figure.aligncenter img,
.page-template-template-kit-request .post-content img.aligncenter img,
.page-template-template-kit-request-v2 .post-content figure.aligncenter img,
.page-template-template-kit-request-v2 .post-content img.aligncenter img,
.single-landing-page .post-content figure.aligncenter img,
.single-landing-page .post-content img.aligncenter img {
  border-radius: 1.25rem;
}
.single-kit .post-content figure.alignleft,
.single-kit .post-content img.alignleft,
.single-post .post-content figure.alignleft,
.single-post .post-content img.alignleft,
.single-story .post-content figure.alignleft,
.single-story .post-content img.alignleft,
.single-teacher .post-content figure.alignleft,
.single-teacher .post-content img.alignleft,
.single-webinar .post-content figure.alignleft,
.single-webinar .post-content img.alignleft,
.single-contest .post-content figure.alignleft,
.single-contest .post-content img.alignleft,
.single-pcto .post-content figure.alignleft,
.single-pcto .post-content img.alignleft,
.page-template-template-pagina-utente .post-content figure.alignleft,
.page-template-template-pagina-utente .post-content img.alignleft,
.page-template-template-kit-request .post-content figure.alignleft,
.page-template-template-kit-request .post-content img.alignleft,
.page-template-template-kit-request-v2 .post-content figure.alignleft,
.page-template-template-kit-request-v2 .post-content img.alignleft,
.single-landing-page .post-content figure.alignleft,
.single-landing-page .post-content img.alignleft {
  float: left;
  border-radius: 1.25rem;
  margin-right: 1rem;
}
.single-kit .post-content figure.alignleft img,
.single-kit .post-content img.alignleft img,
.single-post .post-content figure.alignleft img,
.single-post .post-content img.alignleft img,
.single-story .post-content figure.alignleft img,
.single-story .post-content img.alignleft img,
.single-teacher .post-content figure.alignleft img,
.single-teacher .post-content img.alignleft img,
.single-webinar .post-content figure.alignleft img,
.single-webinar .post-content img.alignleft img,
.single-contest .post-content figure.alignleft img,
.single-contest .post-content img.alignleft img,
.single-pcto .post-content figure.alignleft img,
.single-pcto .post-content img.alignleft img,
.page-template-template-pagina-utente .post-content figure.alignleft img,
.page-template-template-pagina-utente .post-content img.alignleft img,
.page-template-template-kit-request .post-content figure.alignleft img,
.page-template-template-kit-request .post-content img.alignleft img,
.page-template-template-kit-request-v2 .post-content figure.alignleft img,
.page-template-template-kit-request-v2 .post-content img.alignleft img,
.single-landing-page .post-content figure.alignleft img,
.single-landing-page .post-content img.alignleft img {
  border-radius: 1.25rem;
}
.single-kit .post-content figure.alignright,
.single-kit .post-content img.alignright,
.single-post .post-content figure.alignright,
.single-post .post-content img.alignright,
.single-story .post-content figure.alignright,
.single-story .post-content img.alignright,
.single-teacher .post-content figure.alignright,
.single-teacher .post-content img.alignright,
.single-webinar .post-content figure.alignright,
.single-webinar .post-content img.alignright,
.single-contest .post-content figure.alignright,
.single-contest .post-content img.alignright,
.single-pcto .post-content figure.alignright,
.single-pcto .post-content img.alignright,
.page-template-template-pagina-utente .post-content figure.alignright,
.page-template-template-pagina-utente .post-content img.alignright,
.page-template-template-kit-request .post-content figure.alignright,
.page-template-template-kit-request .post-content img.alignright,
.page-template-template-kit-request-v2 .post-content figure.alignright,
.page-template-template-kit-request-v2 .post-content img.alignright,
.single-landing-page .post-content figure.alignright,
.single-landing-page .post-content img.alignright {
  float: right;
  border-radius: 1.25rem;
  margin-left: 1rem;
}
.single-kit .post-content figure.alignright img,
.single-kit .post-content img.alignright img,
.single-post .post-content figure.alignright img,
.single-post .post-content img.alignright img,
.single-story .post-content figure.alignright img,
.single-story .post-content img.alignright img,
.single-teacher .post-content figure.alignright img,
.single-teacher .post-content img.alignright img,
.single-webinar .post-content figure.alignright img,
.single-webinar .post-content img.alignright img,
.single-contest .post-content figure.alignright img,
.single-contest .post-content img.alignright img,
.single-pcto .post-content figure.alignright img,
.single-pcto .post-content img.alignright img,
.page-template-template-pagina-utente .post-content figure.alignright img,
.page-template-template-pagina-utente .post-content img.alignright img,
.page-template-template-kit-request .post-content figure.alignright img,
.page-template-template-kit-request .post-content img.alignright img,
.page-template-template-kit-request-v2 .post-content figure.alignright img,
.page-template-template-kit-request-v2 .post-content img.alignright img,
.single-landing-page .post-content figure.alignright img,
.single-landing-page .post-content img.alignright img {
  border-radius: 1.25rem;
}
.single-kit .post-content figure figcaption,
.single-post .post-content figure figcaption,
.single-story .post-content figure figcaption,
.single-teacher .post-content figure figcaption,
.single-webinar .post-content figure figcaption,
.single-contest .post-content figure figcaption,
.single-pcto .post-content figure figcaption,
.page-template-template-pagina-utente .post-content figure figcaption,
.page-template-template-kit-request .post-content figure figcaption,
.page-template-template-kit-request-v2 .post-content figure figcaption,
.single-landing-page .post-content figure figcaption {
  margin-top: 0.5em;
  font-size: 0.8em;
}
.single-kit .post-content h2, .single-kit .post-content .h2,
.single-kit .post-content h3,
.single-kit .post-content .h3,
.single-kit .post-content h4,
.single-kit .post-content .h4,
.single-kit .post-content h5,
.single-kit .post-content .h5,
.single-post .post-content h2,
.single-post .post-content .h2,
.single-post .post-content h3,
.single-post .post-content .h3,
.single-post .post-content h4,
.single-post .post-content .h4,
.single-post .post-content h5,
.single-post .post-content .h5,
.single-story .post-content h2,
.single-story .post-content .h2,
.single-story .post-content h3,
.single-story .post-content .h3,
.single-story .post-content h4,
.single-story .post-content .h4,
.single-story .post-content h5,
.single-story .post-content .h5,
.single-teacher .post-content h2,
.single-teacher .post-content .h2,
.single-teacher .post-content h3,
.single-teacher .post-content .h3,
.single-teacher .post-content h4,
.single-teacher .post-content .h4,
.single-teacher .post-content h5,
.single-teacher .post-content .h5,
.single-webinar .post-content h2,
.single-webinar .post-content .h2,
.single-webinar .post-content h3,
.single-webinar .post-content .h3,
.single-webinar .post-content h4,
.single-webinar .post-content .h4,
.single-webinar .post-content h5,
.single-webinar .post-content .h5,
.single-contest .post-content h2,
.single-contest .post-content .h2,
.single-contest .post-content h3,
.single-contest .post-content .h3,
.single-contest .post-content h4,
.single-contest .post-content .h4,
.single-contest .post-content h5,
.single-contest .post-content .h5,
.single-pcto .post-content h2,
.single-pcto .post-content .h2,
.single-pcto .post-content h3,
.single-pcto .post-content .h3,
.single-pcto .post-content h4,
.single-pcto .post-content .h4,
.single-pcto .post-content h5,
.single-pcto .post-content .h5,
.page-template-template-pagina-utente .post-content h2,
.page-template-template-pagina-utente .post-content .h2,
.page-template-template-pagina-utente .post-content h3,
.page-template-template-pagina-utente .post-content .h3,
.page-template-template-pagina-utente .post-content h4,
.page-template-template-pagina-utente .post-content .h4,
.page-template-template-pagina-utente .post-content h5,
.page-template-template-pagina-utente .post-content .h5,
.page-template-template-kit-request .post-content h2,
.page-template-template-kit-request .post-content .h2,
.page-template-template-kit-request .post-content h3,
.page-template-template-kit-request .post-content .h3,
.page-template-template-kit-request .post-content h4,
.page-template-template-kit-request .post-content .h4,
.page-template-template-kit-request .post-content h5,
.page-template-template-kit-request .post-content .h5,
.page-template-template-kit-request-v2 .post-content h2,
.page-template-template-kit-request-v2 .post-content .h2,
.page-template-template-kit-request-v2 .post-content h3,
.page-template-template-kit-request-v2 .post-content .h3,
.page-template-template-kit-request-v2 .post-content h4,
.page-template-template-kit-request-v2 .post-content .h4,
.page-template-template-kit-request-v2 .post-content h5,
.page-template-template-kit-request-v2 .post-content .h5,
.single-landing-page .post-content h2,
.single-landing-page .post-content .h2,
.single-landing-page .post-content h3,
.single-landing-page .post-content .h3,
.single-landing-page .post-content h4,
.single-landing-page .post-content .h4,
.single-landing-page .post-content h5,
.single-landing-page .post-content .h5 {
  color: #f29a5f;
  text-transform: uppercase;
  vertical-align: middle;
  font-size: 1.25rem;
  font-weight: 700;
  margin-top: 0.5em;
}
.single-kit .post-content h2 a, .single-kit .post-content .h2 a,
.single-kit .post-content h3 a,
.single-kit .post-content .h3 a,
.single-kit .post-content h4 a,
.single-kit .post-content .h4 a,
.single-kit .post-content h5 a,
.single-kit .post-content .h5 a,
.single-post .post-content h2 a,
.single-post .post-content .h2 a,
.single-post .post-content h3 a,
.single-post .post-content .h3 a,
.single-post .post-content h4 a,
.single-post .post-content .h4 a,
.single-post .post-content h5 a,
.single-post .post-content .h5 a,
.single-story .post-content h2 a,
.single-story .post-content .h2 a,
.single-story .post-content h3 a,
.single-story .post-content .h3 a,
.single-story .post-content h4 a,
.single-story .post-content .h4 a,
.single-story .post-content h5 a,
.single-story .post-content .h5 a,
.single-teacher .post-content h2 a,
.single-teacher .post-content .h2 a,
.single-teacher .post-content h3 a,
.single-teacher .post-content .h3 a,
.single-teacher .post-content h4 a,
.single-teacher .post-content .h4 a,
.single-teacher .post-content h5 a,
.single-teacher .post-content .h5 a,
.single-webinar .post-content h2 a,
.single-webinar .post-content .h2 a,
.single-webinar .post-content h3 a,
.single-webinar .post-content .h3 a,
.single-webinar .post-content h4 a,
.single-webinar .post-content .h4 a,
.single-webinar .post-content h5 a,
.single-webinar .post-content .h5 a,
.single-contest .post-content h2 a,
.single-contest .post-content .h2 a,
.single-contest .post-content h3 a,
.single-contest .post-content .h3 a,
.single-contest .post-content h4 a,
.single-contest .post-content .h4 a,
.single-contest .post-content h5 a,
.single-contest .post-content .h5 a,
.single-pcto .post-content h2 a,
.single-pcto .post-content .h2 a,
.single-pcto .post-content h3 a,
.single-pcto .post-content .h3 a,
.single-pcto .post-content h4 a,
.single-pcto .post-content .h4 a,
.single-pcto .post-content h5 a,
.single-pcto .post-content .h5 a,
.page-template-template-pagina-utente .post-content h2 a,
.page-template-template-pagina-utente .post-content .h2 a,
.page-template-template-pagina-utente .post-content h3 a,
.page-template-template-pagina-utente .post-content .h3 a,
.page-template-template-pagina-utente .post-content h4 a,
.page-template-template-pagina-utente .post-content .h4 a,
.page-template-template-pagina-utente .post-content h5 a,
.page-template-template-pagina-utente .post-content .h5 a,
.page-template-template-kit-request .post-content h2 a,
.page-template-template-kit-request .post-content .h2 a,
.page-template-template-kit-request .post-content h3 a,
.page-template-template-kit-request .post-content .h3 a,
.page-template-template-kit-request .post-content h4 a,
.page-template-template-kit-request .post-content .h4 a,
.page-template-template-kit-request .post-content h5 a,
.page-template-template-kit-request .post-content .h5 a,
.page-template-template-kit-request-v2 .post-content h2 a,
.page-template-template-kit-request-v2 .post-content .h2 a,
.page-template-template-kit-request-v2 .post-content h3 a,
.page-template-template-kit-request-v2 .post-content .h3 a,
.page-template-template-kit-request-v2 .post-content h4 a,
.page-template-template-kit-request-v2 .post-content .h4 a,
.page-template-template-kit-request-v2 .post-content h5 a,
.page-template-template-kit-request-v2 .post-content .h5 a,
.single-landing-page .post-content h2 a,
.single-landing-page .post-content .h2 a,
.single-landing-page .post-content h3 a,
.single-landing-page .post-content .h3 a,
.single-landing-page .post-content h4 a,
.single-landing-page .post-content .h4 a,
.single-landing-page .post-content h5 a,
.single-landing-page .post-content .h5 a {
  color: #f29a5f !important;
}
.single-kit .post-content h6, .single-kit .post-content .h6,
.single-post .post-content h6,
.single-post .post-content .h6,
.single-story .post-content h6,
.single-story .post-content .h6,
.single-teacher .post-content h6,
.single-teacher .post-content .h6,
.single-webinar .post-content h6,
.single-webinar .post-content .h6,
.single-contest .post-content h6,
.single-contest .post-content .h6,
.single-pcto .post-content h6,
.single-pcto .post-content .h6,
.page-template-template-pagina-utente .post-content h6,
.page-template-template-pagina-utente .post-content .h6,
.page-template-template-kit-request .post-content h6,
.page-template-template-kit-request .post-content .h6,
.page-template-template-kit-request-v2 .post-content h6,
.page-template-template-kit-request-v2 .post-content .h6,
.single-landing-page .post-content h6,
.single-landing-page .post-content .h6 {
  font-size: 1em;
}
.single-kit .post-content pre.wp-block-verse,
.single-post .post-content pre.wp-block-verse,
.single-story .post-content pre.wp-block-verse,
.single-teacher .post-content pre.wp-block-verse,
.single-webinar .post-content pre.wp-block-verse,
.single-contest .post-content pre.wp-block-verse,
.single-pcto .post-content pre.wp-block-verse,
.page-template-template-pagina-utente .post-content pre.wp-block-verse,
.page-template-template-kit-request .post-content pre.wp-block-verse,
.page-template-template-kit-request-v2 .post-content pre.wp-block-verse,
.single-landing-page .post-content pre.wp-block-verse {
  font-family: unset;
  font-size: 1em;
}
.single-kit .wp-block-image,
.single-post .wp-block-image,
.single-story .wp-block-image,
.single-teacher .wp-block-image,
.single-webinar .wp-block-image,
.single-contest .wp-block-image,
.single-pcto .wp-block-image,
.page-template-template-pagina-utente .wp-block-image,
.page-template-template-kit-request .wp-block-image,
.page-template-template-kit-request-v2 .wp-block-image,
.single-landing-page .wp-block-image {
  padding: 0;
  width: 100%;
}
.single-kit .wp-block-image img,
.single-post .wp-block-image img,
.single-story .wp-block-image img,
.single-teacher .wp-block-image img,
.single-webinar .wp-block-image img,
.single-contest .wp-block-image img,
.single-pcto .wp-block-image img,
.page-template-template-pagina-utente .wp-block-image img,
.page-template-template-kit-request .wp-block-image img,
.page-template-template-kit-request-v2 .wp-block-image img,
.single-landing-page .wp-block-image img {
  width: 100%;
  max-width: 100%;
  border-radius: 20px;
  overflow: hidden;
}
.single-kit h4, .single-kit .h4,
.single-post h4,
.single-post .h4,
.single-story h4,
.single-story .h4,
.single-teacher h4,
.single-teacher .h4,
.single-webinar h4,
.single-webinar .h4,
.single-contest h4,
.single-contest .h4,
.single-pcto h4,
.single-pcto .h4,
.page-template-template-pagina-utente h4,
.page-template-template-pagina-utente .h4,
.page-template-template-kit-request h4,
.page-template-template-kit-request .h4,
.page-template-template-kit-request-v2 h4,
.page-template-template-kit-request-v2 .h4,
.single-landing-page h4,
.single-landing-page .h4 {
  color: #f29a5f;
  text-transform: uppercase;
  vertical-align: middle;
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 2px;
}
.single-kit h4 .ci::before, .single-kit .h4 .ci::before,
.single-post h4 .ci::before,
.single-post .h4 .ci::before,
.single-story h4 .ci::before,
.single-story .h4 .ci::before,
.single-teacher h4 .ci::before,
.single-teacher .h4 .ci::before,
.single-webinar h4 .ci::before,
.single-webinar .h4 .ci::before,
.single-contest h4 .ci::before,
.single-contest .h4 .ci::before,
.single-pcto h4 .ci::before,
.single-pcto .h4 .ci::before,
.page-template-template-pagina-utente h4 .ci::before,
.page-template-template-pagina-utente .h4 .ci::before,
.page-template-template-kit-request h4 .ci::before,
.page-template-template-kit-request .h4 .ci::before,
.page-template-template-kit-request-v2 h4 .ci::before,
.page-template-template-kit-request-v2 .h4 .ci::before,
.single-landing-page h4 .ci::before,
.single-landing-page .h4 .ci::before {
  width: 1.5rem;
  height: 1.5rem;
  margin-bottom: -0.25rem;
  margin-right: 0.15rem;
  --color: #f29a5f;
}
.single-kit .ci-van,
.single-kit .ci-hand,
.single-kit .ci-clock,
.single-post .ci-van,
.single-post .ci-hand,
.single-post .ci-clock,
.single-story .ci-van,
.single-story .ci-hand,
.single-story .ci-clock,
.single-teacher .ci-van,
.single-teacher .ci-hand,
.single-teacher .ci-clock,
.single-webinar .ci-van,
.single-webinar .ci-hand,
.single-webinar .ci-clock,
.single-contest .ci-van,
.single-contest .ci-hand,
.single-contest .ci-clock,
.single-pcto .ci-van,
.single-pcto .ci-hand,
.single-pcto .ci-clock,
.page-template-template-pagina-utente .ci-van,
.page-template-template-pagina-utente .ci-hand,
.page-template-template-pagina-utente .ci-clock,
.page-template-template-kit-request .ci-van,
.page-template-template-kit-request .ci-hand,
.page-template-template-kit-request .ci-clock,
.page-template-template-kit-request-v2 .ci-van,
.page-template-template-kit-request-v2 .ci-hand,
.page-template-template-kit-request-v2 .ci-clock,
.single-landing-page .ci-van,
.single-landing-page .ci-hand,
.single-landing-page .ci-clock {
  font-size: 1.6rem;
}
.single-kit .ci-van::before,
.single-kit .ci-hand::before,
.single-kit .ci-clock::before,
.single-post .ci-van::before,
.single-post .ci-hand::before,
.single-post .ci-clock::before,
.single-story .ci-van::before,
.single-story .ci-hand::before,
.single-story .ci-clock::before,
.single-teacher .ci-van::before,
.single-teacher .ci-hand::before,
.single-teacher .ci-clock::before,
.single-webinar .ci-van::before,
.single-webinar .ci-hand::before,
.single-webinar .ci-clock::before,
.single-contest .ci-van::before,
.single-contest .ci-hand::before,
.single-contest .ci-clock::before,
.single-pcto .ci-van::before,
.single-pcto .ci-hand::before,
.single-pcto .ci-clock::before,
.page-template-template-pagina-utente .ci-van::before,
.page-template-template-pagina-utente .ci-hand::before,
.page-template-template-pagina-utente .ci-clock::before,
.page-template-template-kit-request .ci-van::before,
.page-template-template-kit-request .ci-hand::before,
.page-template-template-kit-request .ci-clock::before,
.page-template-template-kit-request-v2 .ci-van::before,
.page-template-template-kit-request-v2 .ci-hand::before,
.page-template-template-kit-request-v2 .ci-clock::before,
.single-landing-page .ci-van::before,
.single-landing-page .ci-hand::before,
.single-landing-page .ci-clock::before {
  margin-left: 0.25rem;
  position: relative;
  bottom: -0.2em;
}
.single-kit .content-title,
.single-post .content-title,
.single-story .content-title,
.single-teacher .content-title,
.single-webinar .content-title,
.single-contest .content-title,
.single-pcto .content-title,
.page-template-template-pagina-utente .content-title,
.page-template-template-kit-request .content-title,
.page-template-template-kit-request-v2 .content-title,
.single-landing-page .content-title {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 800;
}
@media (min-width: 1200px) {
  .single-kit .content-title,
  .single-post .content-title,
  .single-story .content-title,
  .single-teacher .content-title,
  .single-webinar .content-title,
  .single-contest .content-title,
  .single-pcto .content-title,
  .page-template-template-pagina-utente .content-title,
  .page-template-template-kit-request .content-title,
  .page-template-template-kit-request-v2 .content-title,
  .single-landing-page .content-title {
    font-size: 4rem;
  }
}
.single-kit .content-subtitle,
.single-post .content-subtitle,
.single-story .content-subtitle,
.single-teacher .content-subtitle,
.single-webinar .content-subtitle,
.single-contest .content-subtitle,
.single-pcto .content-subtitle,
.page-template-template-pagina-utente .content-subtitle,
.page-template-template-kit-request .content-subtitle,
.page-template-template-kit-request-v2 .content-subtitle,
.single-landing-page .content-subtitle {
  font-size: calc(1.4rem + 1.8vw);
  font-weight: 700;
  color: #f29a5f;
}
@media (min-width: 1200px) {
  .single-kit .content-subtitle,
  .single-post .content-subtitle,
  .single-story .content-subtitle,
  .single-teacher .content-subtitle,
  .single-webinar .content-subtitle,
  .single-contest .content-subtitle,
  .single-pcto .content-subtitle,
  .page-template-template-pagina-utente .content-subtitle,
  .page-template-template-kit-request .content-subtitle,
  .page-template-template-kit-request-v2 .content-subtitle,
  .single-landing-page .content-subtitle {
    font-size: 2.75rem;
  }
}
.single-kit .content,
.single-post .content,
.single-story .content,
.single-teacher .content,
.single-webinar .content,
.single-contest .content,
.single-pcto .content,
.page-template-template-pagina-utente .content,
.page-template-template-kit-request .content,
.page-template-template-kit-request-v2 .content,
.single-landing-page .content {
  font-size: calc(1.265rem + 0.18vw);
}
@media (min-width: 1200px) {
  .single-kit .content,
  .single-post .content,
  .single-story .content,
  .single-teacher .content,
  .single-webinar .content,
  .single-contest .content,
  .single-pcto .content,
  .page-template-template-pagina-utente .content,
  .page-template-template-kit-request .content,
  .page-template-template-kit-request-v2 .content,
  .single-landing-page .content {
    font-size: 1.4rem;
  }
}
.single-kit h3.section-title, .single-kit .section-title.h3,
.single-post h3.section-title,
.single-post .section-title.h3,
.single-story h3.section-title,
.single-story .section-title.h3,
.single-teacher h3.section-title,
.single-teacher .section-title.h3,
.single-webinar h3.section-title,
.single-webinar .section-title.h3,
.single-contest h3.section-title,
.single-contest .section-title.h3,
.single-pcto h3.section-title,
.single-pcto .section-title.h3,
.page-template-template-pagina-utente h3.section-title,
.page-template-template-pagina-utente .section-title.h3,
.page-template-template-kit-request h3.section-title,
.page-template-template-kit-request .section-title.h3,
.page-template-template-kit-request-v2 h3.section-title,
.page-template-template-kit-request-v2 .section-title.h3,
.single-landing-page h3.section-title,
.single-landing-page .section-title.h3 {
  margin-top: 3rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--pageFgColor, #f29a5f);
  color: var(--pageFgColor, #f29a5f);
  width: 100%;
  text-transform: uppercase;
  vertical-align: middle;
  font-size: 1.25rem;
  font-weight: 700;
}
.single-kit .box-props,
.single-post .box-props,
.single-story .box-props,
.single-teacher .box-props,
.single-webinar .box-props,
.single-contest .box-props,
.single-pcto .box-props,
.page-template-template-pagina-utente .box-props,
.page-template-template-kit-request .box-props,
.page-template-template-kit-request-v2 .box-props,
.single-landing-page .box-props {
  border: 1px solid #f29a5f;
  border-radius: 20px;
  padding: 1rem;
}
.single-kit .box-props .prop-row,
.single-post .box-props .prop-row,
.single-story .box-props .prop-row,
.single-teacher .box-props .prop-row,
.single-webinar .box-props .prop-row,
.single-contest .box-props .prop-row,
.single-pcto .box-props .prop-row,
.page-template-template-pagina-utente .box-props .prop-row,
.page-template-template-kit-request .box-props .prop-row,
.page-template-template-kit-request-v2 .box-props .prop-row,
.single-landing-page .box-props .prop-row {
  font-size: calc(1.265rem + 0.18vw);
}
@media (min-width: 1200px) {
  .single-kit .box-props .prop-row,
  .single-post .box-props .prop-row,
  .single-story .box-props .prop-row,
  .single-teacher .box-props .prop-row,
  .single-webinar .box-props .prop-row,
  .single-contest .box-props .prop-row,
  .single-pcto .box-props .prop-row,
  .page-template-template-pagina-utente .box-props .prop-row,
  .page-template-template-kit-request .box-props .prop-row,
  .page-template-template-kit-request-v2 .box-props .prop-row,
  .single-landing-page .box-props .prop-row {
    font-size: 1.4rem;
  }
}
.single-kit .box-props .prop-row h4, .single-kit .box-props .prop-row .h4,
.single-post .box-props .prop-row h4,
.single-post .box-props .prop-row .h4,
.single-story .box-props .prop-row h4,
.single-story .box-props .prop-row .h4,
.single-teacher .box-props .prop-row h4,
.single-teacher .box-props .prop-row .h4,
.single-webinar .box-props .prop-row h4,
.single-webinar .box-props .prop-row .h4,
.single-contest .box-props .prop-row h4,
.single-contest .box-props .prop-row .h4,
.single-pcto .box-props .prop-row h4,
.single-pcto .box-props .prop-row .h4,
.page-template-template-pagina-utente .box-props .prop-row h4,
.page-template-template-pagina-utente .box-props .prop-row .h4,
.page-template-template-kit-request .box-props .prop-row h4,
.page-template-template-kit-request .box-props .prop-row .h4,
.page-template-template-kit-request-v2 .box-props .prop-row h4,
.page-template-template-kit-request-v2 .box-props .prop-row .h4,
.single-landing-page .box-props .prop-row h4,
.single-landing-page .box-props .prop-row .h4 {
  -webkit-user-select: none;
          user-select: none;
}
.single-kit .box-props .prop-row h4 > i, .single-kit .box-props .prop-row .h4 > i,
.single-post .box-props .prop-row h4 > i,
.single-post .box-props .prop-row .h4 > i,
.single-story .box-props .prop-row h4 > i,
.single-story .box-props .prop-row .h4 > i,
.single-teacher .box-props .prop-row h4 > i,
.single-teacher .box-props .prop-row .h4 > i,
.single-webinar .box-props .prop-row h4 > i,
.single-webinar .box-props .prop-row .h4 > i,
.single-contest .box-props .prop-row h4 > i,
.single-contest .box-props .prop-row .h4 > i,
.single-pcto .box-props .prop-row h4 > i,
.single-pcto .box-props .prop-row .h4 > i,
.page-template-template-pagina-utente .box-props .prop-row h4 > i,
.page-template-template-pagina-utente .box-props .prop-row .h4 > i,
.page-template-template-kit-request .box-props .prop-row h4 > i,
.page-template-template-kit-request .box-props .prop-row .h4 > i,
.page-template-template-kit-request-v2 .box-props .prop-row h4 > i,
.page-template-template-kit-request-v2 .box-props .prop-row .h4 > i,
.single-landing-page .box-props .prop-row h4 > i,
.single-landing-page .box-props .prop-row .h4 > i {
  font-weight: 600;
}
.single-kit .box-props .prop-row h4 .prop-icon, .single-kit .box-props .prop-row .h4 .prop-icon,
.single-post .box-props .prop-row h4 .prop-icon,
.single-post .box-props .prop-row .h4 .prop-icon,
.single-story .box-props .prop-row h4 .prop-icon,
.single-story .box-props .prop-row .h4 .prop-icon,
.single-teacher .box-props .prop-row h4 .prop-icon,
.single-teacher .box-props .prop-row .h4 .prop-icon,
.single-webinar .box-props .prop-row h4 .prop-icon,
.single-webinar .box-props .prop-row .h4 .prop-icon,
.single-contest .box-props .prop-row h4 .prop-icon,
.single-contest .box-props .prop-row .h4 .prop-icon,
.single-pcto .box-props .prop-row h4 .prop-icon,
.single-pcto .box-props .prop-row .h4 .prop-icon,
.page-template-template-pagina-utente .box-props .prop-row h4 .prop-icon,
.page-template-template-pagina-utente .box-props .prop-row .h4 .prop-icon,
.page-template-template-kit-request .box-props .prop-row h4 .prop-icon,
.page-template-template-kit-request .box-props .prop-row .h4 .prop-icon,
.page-template-template-kit-request-v2 .box-props .prop-row h4 .prop-icon,
.page-template-template-kit-request-v2 .box-props .prop-row .h4 .prop-icon,
.single-landing-page .box-props .prop-row h4 .prop-icon,
.single-landing-page .box-props .prop-row .h4 .prop-icon {
  max-width: 24px;
}
.single-kit .box-props .prop-row:last-child p,
.single-post .box-props .prop-row:last-child p,
.single-story .box-props .prop-row:last-child p,
.single-teacher .box-props .prop-row:last-child p,
.single-webinar .box-props .prop-row:last-child p,
.single-contest .box-props .prop-row:last-child p,
.single-pcto .box-props .prop-row:last-child p,
.page-template-template-pagina-utente .box-props .prop-row:last-child p,
.page-template-template-kit-request .box-props .prop-row:last-child p,
.page-template-template-kit-request-v2 .box-props .prop-row:last-child p,
.single-landing-page .box-props .prop-row:last-child p {
  margin-bottom: 0;
}
.single-kit .box-props .ci-speaker,
.single-kit .box-props .ci-kit,
.single-post .box-props .ci-speaker,
.single-post .box-props .ci-kit,
.single-story .box-props .ci-speaker,
.single-story .box-props .ci-kit,
.single-teacher .box-props .ci-speaker,
.single-teacher .box-props .ci-kit,
.single-webinar .box-props .ci-speaker,
.single-webinar .box-props .ci-kit,
.single-contest .box-props .ci-speaker,
.single-contest .box-props .ci-kit,
.single-pcto .box-props .ci-speaker,
.single-pcto .box-props .ci-kit,
.page-template-template-pagina-utente .box-props .ci-speaker,
.page-template-template-pagina-utente .box-props .ci-kit,
.page-template-template-kit-request .box-props .ci-speaker,
.page-template-template-kit-request .box-props .ci-kit,
.page-template-template-kit-request-v2 .box-props .ci-speaker,
.page-template-template-kit-request-v2 .box-props .ci-kit,
.single-landing-page .box-props .ci-speaker,
.single-landing-page .box-props .ci-kit {
  font-size: 1.2em;
  position: relative;
  top: 2px;
}
.single-kit .box-props .ci-clock,
.single-post .box-props .ci-clock,
.single-story .box-props .ci-clock,
.single-teacher .box-props .ci-clock,
.single-webinar .box-props .ci-clock,
.single-contest .box-props .ci-clock,
.single-pcto .box-props .ci-clock,
.page-template-template-pagina-utente .box-props .ci-clock,
.page-template-template-kit-request .box-props .ci-clock,
.page-template-template-kit-request-v2 .box-props .ci-clock,
.single-landing-page .box-props .ci-clock {
  font-size: 1em;
  position: relative;
  bottom: 2px;
  right: 3px;
}
.single-kit .kit-components,
.single-post .kit-components,
.single-story .kit-components,
.single-teacher .kit-components,
.single-webinar .kit-components,
.single-contest .kit-components,
.single-pcto .kit-components,
.page-template-template-pagina-utente .kit-components,
.page-template-template-kit-request .kit-components,
.page-template-template-kit-request-v2 .kit-components,
.single-landing-page .kit-components {
  font-size: calc(1.265rem + 0.18vw);
}
@media (min-width: 1200px) {
  .single-kit .kit-components,
  .single-post .kit-components,
  .single-story .kit-components,
  .single-teacher .kit-components,
  .single-webinar .kit-components,
  .single-contest .kit-components,
  .single-pcto .kit-components,
  .page-template-template-pagina-utente .kit-components,
  .page-template-template-kit-request .kit-components,
  .page-template-template-kit-request-v2 .kit-components,
  .single-landing-page .kit-components {
    font-size: 1.4rem;
  }
}
.single-kit .kit-components .ci,
.single-post .kit-components .ci,
.single-story .kit-components .ci,
.single-teacher .kit-components .ci,
.single-webinar .kit-components .ci,
.single-contest .kit-components .ci,
.single-pcto .kit-components .ci,
.page-template-template-pagina-utente .kit-components .ci,
.page-template-template-kit-request .kit-components .ci,
.page-template-template-kit-request-v2 .kit-components .ci,
.single-landing-page .kit-components .ci {
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .single-kit .kit-components .ci,
  .single-post .kit-components .ci,
  .single-story .kit-components .ci,
  .single-teacher .kit-components .ci,
  .single-webinar .kit-components .ci,
  .single-contest .kit-components .ci,
  .single-pcto .kit-components .ci,
  .page-template-template-pagina-utente .kit-components .ci,
  .page-template-template-kit-request .kit-components .ci,
  .page-template-template-kit-request-v2 .kit-components .ci,
  .single-landing-page .kit-components .ci {
    font-size: 5rem;
  }
}
.single-kit .kit-components .ci.ci-locandina, .single-kit .kit-components .ci.ci-circolare,
.single-post .kit-components .ci.ci-locandina,
.single-post .kit-components .ci.ci-circolare,
.single-story .kit-components .ci.ci-locandina,
.single-story .kit-components .ci.ci-circolare,
.single-teacher .kit-components .ci.ci-locandina,
.single-teacher .kit-components .ci.ci-circolare,
.single-webinar .kit-components .ci.ci-locandina,
.single-webinar .kit-components .ci.ci-circolare,
.single-contest .kit-components .ci.ci-locandina,
.single-contest .kit-components .ci.ci-circolare,
.single-pcto .kit-components .ci.ci-locandina,
.single-pcto .kit-components .ci.ci-circolare,
.page-template-template-pagina-utente .kit-components .ci.ci-locandina,
.page-template-template-pagina-utente .kit-components .ci.ci-circolare,
.page-template-template-kit-request .kit-components .ci.ci-locandina,
.page-template-template-kit-request .kit-components .ci.ci-circolare,
.page-template-template-kit-request-v2 .kit-components .ci.ci-locandina,
.page-template-template-kit-request-v2 .kit-components .ci.ci-circolare,
.single-landing-page .kit-components .ci.ci-locandina,
.single-landing-page .kit-components .ci.ci-circolare {
  font-size: calc(1.585rem + 4.02vw);
  margin-left: 0.1rem;
}
@media (min-width: 1200px) {
  .single-kit .kit-components .ci.ci-locandina, .single-kit .kit-components .ci.ci-circolare,
  .single-post .kit-components .ci.ci-locandina,
  .single-post .kit-components .ci.ci-circolare,
  .single-story .kit-components .ci.ci-locandina,
  .single-story .kit-components .ci.ci-circolare,
  .single-teacher .kit-components .ci.ci-locandina,
  .single-teacher .kit-components .ci.ci-circolare,
  .single-webinar .kit-components .ci.ci-locandina,
  .single-webinar .kit-components .ci.ci-circolare,
  .single-contest .kit-components .ci.ci-locandina,
  .single-contest .kit-components .ci.ci-circolare,
  .single-pcto .kit-components .ci.ci-locandina,
  .single-pcto .kit-components .ci.ci-circolare,
  .page-template-template-pagina-utente .kit-components .ci.ci-locandina,
  .page-template-template-pagina-utente .kit-components .ci.ci-circolare,
  .page-template-template-kit-request .kit-components .ci.ci-locandina,
  .page-template-template-kit-request .kit-components .ci.ci-circolare,
  .page-template-template-kit-request-v2 .kit-components .ci.ci-locandina,
  .page-template-template-kit-request-v2 .kit-components .ci.ci-circolare,
  .single-landing-page .kit-components .ci.ci-locandina,
  .single-landing-page .kit-components .ci.ci-circolare {
    font-size: 4.6rem;
  }
}
.single-kit .kit-components .ci.ci-busta,
.single-post .kit-components .ci.ci-busta,
.single-story .kit-components .ci.ci-busta,
.single-teacher .kit-components .ci.ci-busta,
.single-webinar .kit-components .ci.ci-busta,
.single-contest .kit-components .ci.ci-busta,
.single-pcto .kit-components .ci.ci-busta,
.page-template-template-pagina-utente .kit-components .ci.ci-busta,
.page-template-template-kit-request .kit-components .ci.ci-busta,
.page-template-template-kit-request-v2 .kit-components .ci.ci-busta,
.single-landing-page .kit-components .ci.ci-busta {
  font-size: calc(1.585rem + 4.02vw);
  margin-left: 0.4rem;
}
@media (min-width: 1200px) {
  .single-kit .kit-components .ci.ci-busta,
  .single-post .kit-components .ci.ci-busta,
  .single-story .kit-components .ci.ci-busta,
  .single-teacher .kit-components .ci.ci-busta,
  .single-webinar .kit-components .ci.ci-busta,
  .single-contest .kit-components .ci.ci-busta,
  .single-pcto .kit-components .ci.ci-busta,
  .page-template-template-pagina-utente .kit-components .ci.ci-busta,
  .page-template-template-kit-request .kit-components .ci.ci-busta,
  .page-template-template-kit-request-v2 .kit-components .ci.ci-busta,
  .single-landing-page .kit-components .ci.ci-busta {
    font-size: 4.6rem;
  }
}
.single-kit .splide.preview-slider,
.single-post .splide.preview-slider,
.single-story .splide.preview-slider,
.single-teacher .splide.preview-slider,
.single-webinar .splide.preview-slider,
.single-contest .splide.preview-slider,
.single-pcto .splide.preview-slider,
.page-template-template-pagina-utente .splide.preview-slider,
.page-template-template-kit-request .splide.preview-slider,
.page-template-template-kit-request-v2 .splide.preview-slider,
.single-landing-page .splide.preview-slider {
  padding-bottom: 6rem;
}
.single-kit .splide.custom-navigation .splide-controls,
.single-post .splide.custom-navigation .splide-controls,
.single-story .splide.custom-navigation .splide-controls,
.single-teacher .splide.custom-navigation .splide-controls,
.single-webinar .splide.custom-navigation .splide-controls,
.single-contest .splide.custom-navigation .splide-controls,
.single-pcto .splide.custom-navigation .splide-controls,
.page-template-template-pagina-utente .splide.custom-navigation .splide-controls,
.page-template-template-kit-request .splide.custom-navigation .splide-controls,
.page-template-template-kit-request-v2 .splide.custom-navigation .splide-controls,
.single-landing-page .splide.custom-navigation .splide-controls {
  --controlsColor: #f29a5f;
}
@media (max-width: 1023.98px) {
  .single-kit h3.section-title, .single-kit .section-title.h3,
  .single-post h3.section-title,
  .single-post .section-title.h3,
  .single-story h3.section-title,
  .single-story .section-title.h3,
  .single-teacher h3.section-title,
  .single-teacher .section-title.h3,
  .single-webinar h3.section-title,
  .single-webinar .section-title.h3,
  .single-contest h3.section-title,
  .single-contest .section-title.h3,
  .single-pcto h3.section-title,
  .single-pcto .section-title.h3,
  .page-template-template-pagina-utente h3.section-title,
  .page-template-template-pagina-utente .section-title.h3,
  .page-template-template-kit-request h3.section-title,
  .page-template-template-kit-request .section-title.h3,
  .page-template-template-kit-request-v2 h3.section-title,
  .page-template-template-kit-request-v2 .section-title.h3,
  .single-landing-page h3.section-title,
  .single-landing-page .section-title.h3 {
    margin-top: 2rem;
  }
  .single-kit .splide.preview-slider,
  .single-post .splide.preview-slider,
  .single-story .splide.preview-slider,
  .single-teacher .splide.preview-slider,
  .single-webinar .splide.preview-slider,
  .single-contest .splide.preview-slider,
  .single-pcto .splide.preview-slider,
  .page-template-template-pagina-utente .splide.preview-slider,
  .page-template-template-kit-request .splide.preview-slider,
  .page-template-template-kit-request-v2 .splide.preview-slider,
  .single-landing-page .splide.preview-slider {
    width: 100%;
    aspect-ratio: 16/10;
    height: auto;
    padding-bottom: 0;
  }
  .single-kit .splide.custom-navigation .splide-controls,
  .single-post .splide.custom-navigation .splide-controls,
  .single-story .splide.custom-navigation .splide-controls,
  .single-teacher .splide.custom-navigation .splide-controls,
  .single-webinar .splide.custom-navigation .splide-controls,
  .single-contest .splide.custom-navigation .splide-controls,
  .single-pcto .splide.custom-navigation .splide-controls,
  .page-template-template-pagina-utente .splide.custom-navigation .splide-controls,
  .page-template-template-kit-request .splide.custom-navigation .splide-controls,
  .page-template-template-kit-request-v2 .splide.custom-navigation .splide-controls,
  .single-landing-page .splide.custom-navigation .splide-controls {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .single-kit .splide.custom-navigation .splide-controls .splide__arrow,
  .single-post .splide.custom-navigation .splide-controls .splide__arrow,
  .single-story .splide.custom-navigation .splide-controls .splide__arrow,
  .single-teacher .splide.custom-navigation .splide-controls .splide__arrow,
  .single-webinar .splide.custom-navigation .splide-controls .splide__arrow,
  .single-contest .splide.custom-navigation .splide-controls .splide__arrow,
  .single-pcto .splide.custom-navigation .splide-controls .splide__arrow,
  .page-template-template-pagina-utente .splide.custom-navigation .splide-controls .splide__arrow,
  .page-template-template-kit-request .splide.custom-navigation .splide-controls .splide__arrow,
  .page-template-template-kit-request-v2 .splide.custom-navigation .splide-controls .splide__arrow,
  .single-landing-page .splide.custom-navigation .splide-controls .splide__arrow {
    display: block !important;
    margin: 0;
  }
}
.single-kit .speakers img,
.single-post .speakers img,
.single-story .speakers img,
.single-teacher .speakers img,
.single-webinar .speakers img,
.single-contest .speakers img,
.single-pcto .speakers img,
.page-template-template-pagina-utente .speakers img,
.page-template-template-kit-request .speakers img,
.page-template-template-kit-request-v2 .speakers img,
.single-landing-page .speakers img {
  width: 10rem;
  aspect-ratio: 1;
  object-fit: cover;
}
.single-kit .speakers p,
.single-post .speakers p,
.single-story .speakers p,
.single-teacher .speakers p,
.single-webinar .speakers p,
.single-contest .speakers p,
.single-pcto .speakers p,
.page-template-template-pagina-utente .speakers p,
.page-template-template-kit-request .speakers p,
.page-template-template-kit-request-v2 .speakers p,
.single-landing-page .speakers p {
  font-size: 1.4rem;
}
.single-kit ul.tags-list li,
.single-post ul.tags-list li,
.single-story ul.tags-list li,
.single-teacher ul.tags-list li,
.single-webinar ul.tags-list li,
.single-contest ul.tags-list li,
.single-pcto ul.tags-list li,
.page-template-template-pagina-utente ul.tags-list li,
.page-template-template-kit-request ul.tags-list li,
.page-template-template-kit-request-v2 ul.tags-list li,
.single-landing-page ul.tags-list li {
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
}
.single-kit .read-more,
.single-post .read-more,
.single-story .read-more,
.single-teacher .read-more,
.single-webinar .read-more,
.single-contest .read-more,
.single-pcto .read-more,
.page-template-template-pagina-utente .read-more,
.page-template-template-kit-request .read-more,
.page-template-template-kit-request-v2 .read-more,
.single-landing-page .read-more {
  position: relative;
  margin-top: -9rem;
  padding-top: 10rem;
  z-index: 1;
  background-color: var(--pageBgColor);
  background: linear-gradient(0deg, var(--pageBgColor) 0%, var(--pageBgColor) 50%, rgba(0, 212, 255, 0) 100%);
}
.single-kit.single-kit .preview-slider,
.single-post.single-kit .preview-slider,
.single-story.single-kit .preview-slider,
.single-teacher.single-kit .preview-slider,
.single-webinar.single-kit .preview-slider,
.single-contest.single-kit .preview-slider,
.single-pcto.single-kit .preview-slider,
.page-template-template-pagina-utente.single-kit .preview-slider,
.page-template-template-kit-request.single-kit .preview-slider,
.page-template-template-kit-request-v2.single-kit .preview-slider,
.single-landing-page.single-kit .preview-slider {
  height: 800px;
}
.single-kit .colors-blue,
.single-post .colors-blue,
.single-story .colors-blue,
.single-teacher .colors-blue,
.single-webinar .colors-blue,
.single-contest .colors-blue,
.single-pcto .colors-blue,
.page-template-template-pagina-utente .colors-blue,
.page-template-template-kit-request .colors-blue,
.page-template-template-kit-request-v2 .colors-blue,
.single-landing-page .colors-blue {
  --pageBgColor: #bad4fe;
  --pageFgColor: #5f9fe7;
}
.single-kit .colors-yellow,
.single-post .colors-yellow,
.single-story .colors-yellow,
.single-teacher .colors-yellow,
.single-webinar .colors-yellow,
.single-contest .colors-yellow,
.single-pcto .colors-yellow,
.page-template-template-pagina-utente .colors-yellow,
.page-template-template-kit-request .colors-yellow,
.page-template-template-kit-request-v2 .colors-yellow,
.single-landing-page .colors-yellow {
  --pageBgColor: #fedfc1;
  --pageFgColor: #f29a5f;
}
.single-kit .colors-salmon,
.single-post .colors-salmon,
.single-story .colors-salmon,
.single-teacher .colors-salmon,
.single-webinar .colors-salmon,
.single-contest .colors-salmon,
.single-pcto .colors-salmon,
.page-template-template-pagina-utente .colors-salmon,
.page-template-template-kit-request .colors-salmon,
.page-template-template-kit-request-v2 .colors-salmon,
.single-landing-page .colors-salmon {
  --pageBgColor: #fbc8bb;
  --pageFgColor: #d27366;
}
.single-kit .colors-pink,
.single-post .colors-pink,
.single-story .colors-pink,
.single-teacher .colors-pink,
.single-webinar .colors-pink,
.single-contest .colors-pink,
.single-pcto .colors-pink,
.page-template-template-pagina-utente .colors-pink,
.page-template-template-kit-request .colors-pink,
.page-template-template-kit-request-v2 .colors-pink,
.single-landing-page .colors-pink {
  --pageBgColor: #ffd7f3;
  --pageFgColor: #d16bb7;
}
.single-kit .colors-green,
.single-post .colors-green,
.single-story .colors-green,
.single-teacher .colors-green,
.single-webinar .colors-green,
.single-contest .colors-green,
.single-pcto .colors-green,
.page-template-template-pagina-utente .colors-green,
.page-template-template-kit-request .colors-green,
.page-template-template-kit-request-v2 .colors-green,
.single-landing-page .colors-green {
  --pageBgColor: #c2efc8;
  --pageFgColor: #51ad9d;
}
body.page-template-default main {
  background-color: #bad4fe !important;
}
body.page-template-default h1, body.page-template-default .h1 {
  color: #4b4b95;
  font-weight: 800;
}
body.page-template-default #iubenda_policy {
  font-family: museo-sans, serif !important;
}
body.page-template-default #iubenda_policy .iub_content {
  padding: 10px 0;
}
.single-teacher,
.page-template-template-pagina-utente {
  --pageBgColor: #ffd7f3;
  --pageFgColor: #d16bb7;
}
.single-teacher .page-header-wrapper .page-header,
.page-template-template-pagina-utente .page-header-wrapper .page-header {
  height: calc(max(250px, 40vh) + 30px);
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0) 35%);
}
@media (max-width: 1023.98px) {
  .single-teacher .page-header-wrapper .page-header,
  .page-template-template-pagina-utente .page-header-wrapper .page-header {
    height: auto;
  }
  .single-teacher .page-header-wrapper .page-header .container,
  .page-template-template-pagina-utente .page-header-wrapper .page-header .container {
    padding-bottom: 2.5rem;
  }
}
@media (max-width: 1023.98px) {
  .single-teacher .page-header-wrapper,
  .page-template-template-pagina-utente .page-header-wrapper {
    margin-bottom: 2rem !important;
  }
  .single-teacher .page-header-wrapper.btn-edit-cover,
  .page-template-template-pagina-utente .page-header-wrapper.btn-edit-cover {
    zoom: 0.85;
  }
}
.single-teacher .page-header-wrapper .page-header-picture,
.page-template-template-pagina-utente .page-header-wrapper .page-header-picture {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
}
@media (min-width: 1024px) {
  .single-teacher .page-header-wrapper .page-header-picture,
  .page-template-template-pagina-utente .page-header-wrapper .page-header-picture {
    position: absolute;
    left: 0;
    bottom: -100px;
    margin-right: 1.5rem;
  }
}
@media (max-width: 1023.98px) {
  .single-teacher .page-header-wrapper .page-header-picture,
  .page-template-template-pagina-utente .page-header-wrapper .page-header-picture {
    position: relative;
    margin: 2rem auto;
  }
}
.single-teacher .page-header-wrapper .page-header-picture .btn-edit,
.page-template-template-pagina-utente .page-header-wrapper .page-header-picture .btn-edit {
  position: absolute;
  padding: 0;
  z-index: 3;
  bottom: 12px;
  right: 12px;
}
@media (min-width: 1024px) {
  .single-teacher .page-header-wrapper .page-header-footer,
  .page-template-template-pagina-utente .page-header-wrapper .page-header-footer {
    position: absolute;
    padding-top: 1.5rem;
  }
}
@media (max-width: 1023.98px) {
  .single-teacher .page-header-wrapper .page-header-footer,
  .page-template-template-pagina-utente .page-header-wrapper .page-header-footer {
    color: #ffffff;
  }
}
.single-teacher .page-header-wrapper.has-picture, .single-teacher .page-header-wrapper.has-footer,
.page-template-template-pagina-utente .page-header-wrapper.has-picture,
.page-template-template-pagina-utente .page-header-wrapper.has-footer {
  margin-bottom: 100px;
}
.single-teacher .page-header-wrapper.has-picture .page-header-content,
.page-template-template-pagina-utente .page-header-wrapper.has-picture .page-header-content {
  overflow: visible;
  padding-left: 220px;
}
@media (max-width: 1023.98px) {
  .single-teacher .page-header-wrapper.has-picture .page-header-content,
  .page-template-template-pagina-utente .page-header-wrapper.has-picture .page-header-content {
    text-align: center;
    overflow: visible;
    padding-left: 0;
  }
}
.single-teacher .teacher-info,
.page-template-template-pagina-utente .teacher-info {
  border: 2px solid var(--pageFgColor, #d16bb7);
  padding: 1.35rem;
  border-radius: 20px;
  margin: 0 -1.35rem;
}
.single-teacher .teacher-info .teacher-info-icon,
.page-template-template-pagina-utente .teacher-info .teacher-info-icon {
  margin-right: 1rem;
}
.single-teacher .teacher-info .teacher-info-title,
.page-template-template-pagina-utente .teacher-info .teacher-info-title {
  text-transform: uppercase;
  color: var(--pageFgColor, #d16bb7);
  font-size: 1.45rem;
  margin-top: -5px;
  font-weight: 700;
}
.single-teacher .teacher-info .teacher-info-title > .btn, .single-teacher .teacher-info .gform_wrapper .teacher-info-title > input[type=submit], .gform_wrapper .single-teacher .teacher-info .teacher-info-title > input[type=submit], .single-teacher .teacher-info .gform_wrapper .teacher-info-title > .button, .gform_wrapper .single-teacher .teacher-info .teacher-info-title > .button,
.page-template-template-pagina-utente .teacher-info .teacher-info-title > .btn,
.page-template-template-pagina-utente .teacher-info .gform_wrapper .teacher-info-title > input[type=submit],
.gform_wrapper .page-template-template-pagina-utente .teacher-info .teacher-info-title > input[type=submit],
.page-template-template-pagina-utente .teacher-info .gform_wrapper .teacher-info-title > .button,
.gform_wrapper .page-template-template-pagina-utente .teacher-info .teacher-info-title > .button {
  bottom: 0.25rem;
  left: 1rem;
}
.single-teacher .teacher-info .teacher-info-title > .ci,
.page-template-template-pagina-utente .teacher-info .teacher-info-title > .ci {
  font-size: 1.5em;
}
.single-teacher .teacher-info .teacher-info-title > .ci::before,
.page-template-template-pagina-utente .teacher-info .teacher-info-title > .ci::before {
  position: relative;
  top: 5px;
}
.single-teacher .teacher-info .teacher-info-description,
.page-template-template-pagina-utente .teacher-info .teacher-info-description {
  opacity: 1;
  font-size: 1.4rem;
}
.single-teacher .teacher-info .teacher-info-description .splide .splide__pagination,
.page-template-template-pagina-utente .teacher-info .teacher-info-description .splide .splide__pagination {
  bottom: 0;
}
.single-teacher .teacher-info .teacher-info-description .splide .splide__pagination .splide__pagination__page,
.page-template-template-pagina-utente .teacher-info .teacher-info-description .splide .splide__pagination .splide__pagination__page {
  border: 1px solid #4b4b95;
  background-color: transparent;
}
.single-teacher .teacher-info .teacher-info-description .splide .splide__pagination .splide__pagination__page.is-active,
.page-template-template-pagina-utente .teacher-info .teacher-info-description .splide .splide__pagination .splide__pagination__page.is-active {
  background-color: #4b4b95;
}
.single-teacher .teacher-info .teacher-award-icon-img,
.page-template-template-pagina-utente .teacher-info .teacher-award-icon-img {
  width: 5rem;
}
.single-teacher .vue-activity-list .activity-date,
.page-template-template-pagina-utente .vue-activity-list .activity-date {
  color: var(--pageFgColor, #d16bb7);
}
.single-teacher .vue-activity-list hr,
.page-template-template-pagina-utente .vue-activity-list hr {
  border-top: 1px solid var(--pageFgColor, #d16bb7);
}
.single-teacher .profile-edit-btns .btn, .single-teacher .profile-edit-btns .gform_wrapper input[type=submit], .gform_wrapper .single-teacher .profile-edit-btns input[type=submit], .single-teacher .profile-edit-btns .gform_wrapper .button, .gform_wrapper .single-teacher .profile-edit-btns .button,
.page-template-template-pagina-utente .profile-edit-btns .btn,
.page-template-template-pagina-utente .profile-edit-btns .gform_wrapper input[type=submit],
.gform_wrapper .page-template-template-pagina-utente .profile-edit-btns input[type=submit],
.page-template-template-pagina-utente .profile-edit-btns .gform_wrapper .button,
.gform_wrapper .page-template-template-pagina-utente .profile-edit-btns .button {
  text-transform: none;
}
.single-teacher .profile-edit-btns .btn .ci, .single-teacher .profile-edit-btns .gform_wrapper input[type=submit] .ci, .gform_wrapper .single-teacher .profile-edit-btns input[type=submit] .ci, .single-teacher .profile-edit-btns .gform_wrapper .button .ci, .gform_wrapper .single-teacher .profile-edit-btns .button .ci,
.page-template-template-pagina-utente .profile-edit-btns .btn .ci,
.page-template-template-pagina-utente .profile-edit-btns .gform_wrapper input[type=submit] .ci,
.gform_wrapper .page-template-template-pagina-utente .profile-edit-btns input[type=submit] .ci,
.page-template-template-pagina-utente .profile-edit-btns .gform_wrapper .button .ci,
.gform_wrapper .page-template-template-pagina-utente .profile-edit-btns .button .ci {
  font-weight: 600;
  font-size: 1.35rem;
  margin-right: 0.25rem;
}
.single-teacher .profile-edit-btns .btn .ci::before, .single-teacher .profile-edit-btns .gform_wrapper input[type=submit] .ci::before, .gform_wrapper .single-teacher .profile-edit-btns input[type=submit] .ci::before, .single-teacher .profile-edit-btns .gform_wrapper .button .ci::before, .gform_wrapper .single-teacher .profile-edit-btns .button .ci::before,
.page-template-template-pagina-utente .profile-edit-btns .btn .ci::before,
.page-template-template-pagina-utente .profile-edit-btns .gform_wrapper input[type=submit] .ci::before,
.gform_wrapper .page-template-template-pagina-utente .profile-edit-btns input[type=submit] .ci::before,
.page-template-template-pagina-utente .profile-edit-btns .gform_wrapper .button .ci::before,
.gform_wrapper .page-template-template-pagina-utente .profile-edit-btns .button .ci::before {
  margin-left: 0;
  position: relative;
  bottom: -0.2em;
}
.single-teacher .card-cta-storia,
.page-template-template-pagina-utente .card-cta-storia {
  border: 2px dashed var(--pageFgColor);
  background: none;
  color: var(--pageFgColor);
}
.single-teacher .card-cta-storia h3, .single-teacher .card-cta-storia .h3,
.page-template-template-pagina-utente .card-cta-storia h3,
.page-template-template-pagina-utente .card-cta-storia .h3 {
  font-size: 1.55rem;
  font-weight: 700;
}
.single-teacher .card-cta-storia h3 .ci, .single-teacher .card-cta-storia .h3 .ci,
.page-template-template-pagina-utente .card-cta-storia h3 .ci,
.page-template-template-pagina-utente .card-cta-storia .h3 .ci {
  font-size: 4rem;
  font-weight: normal;
}
.single-teacher .card-cta-storia::before,
.page-template-template-pagina-utente .card-cta-storia::before {
  content: " ";
  border-radius: 1rem;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--pageFgColor);
  opacity: 0.1;
}
.single-teacher .toggle-selector .btn, .single-teacher .toggle-selector .gform_wrapper input[type=submit], .gform_wrapper .single-teacher .toggle-selector input[type=submit], .single-teacher .toggle-selector .gform_wrapper .button, .gform_wrapper .single-teacher .toggle-selector .button,
.page-template-template-pagina-utente .toggle-selector .btn,
.page-template-template-pagina-utente .toggle-selector .gform_wrapper input[type=submit],
.gform_wrapper .page-template-template-pagina-utente .toggle-selector input[type=submit],
.page-template-template-pagina-utente .toggle-selector .gform_wrapper .button,
.gform_wrapper .page-template-template-pagina-utente .toggle-selector .button {
  padding: 0.35rem 1.35rem;
}
.single-teacher .toggle-selector .btn.btn-active, .single-teacher .toggle-selector .gform_wrapper input.btn-active[type=submit], .gform_wrapper .single-teacher .toggle-selector input.btn-active[type=submit], .single-teacher .toggle-selector .gform_wrapper .btn-active.button, .gform_wrapper .single-teacher .toggle-selector .btn-active.button,
.page-template-template-pagina-utente .toggle-selector .btn.btn-active,
.page-template-template-pagina-utente .toggle-selector .gform_wrapper input.btn-active[type=submit],
.gform_wrapper .page-template-template-pagina-utente .toggle-selector input.btn-active[type=submit],
.page-template-template-pagina-utente .toggle-selector .gform_wrapper .btn-active.button,
.gform_wrapper .page-template-template-pagina-utente .toggle-selector .btn-active.button {
  z-index: 2;
  color: #ffffff;
}
.single-teacher .toggle-selector .btn.btn-active:hover, .single-teacher .toggle-selector .gform_wrapper input.btn-active[type=submit]:hover, .gform_wrapper .single-teacher .toggle-selector input.btn-active[type=submit]:hover, .single-teacher .toggle-selector .gform_wrapper .btn-active.button:hover, .gform_wrapper .single-teacher .toggle-selector .btn-active.button:hover,
.page-template-template-pagina-utente .toggle-selector .btn.btn-active:hover,
.page-template-template-pagina-utente .toggle-selector .gform_wrapper input.btn-active[type=submit]:hover,
.gform_wrapper .page-template-template-pagina-utente .toggle-selector input.btn-active[type=submit]:hover,
.page-template-template-pagina-utente .toggle-selector .gform_wrapper .btn-active.button:hover,
.gform_wrapper .page-template-template-pagina-utente .toggle-selector .btn-active.button:hover {
  color: var(--btnFgColor);
}
.single-teacher .toggle-selector .btn:not(.btn-active), .single-teacher .toggle-selector .gform_wrapper input[type=submit]:not(.btn-active), .gform_wrapper .single-teacher .toggle-selector input[type=submit]:not(.btn-active), .single-teacher .toggle-selector .gform_wrapper .button:not(.btn-active), .gform_wrapper .single-teacher .toggle-selector .button:not(.btn-active),
.page-template-template-pagina-utente .toggle-selector .btn:not(.btn-active),
.page-template-template-pagina-utente .toggle-selector .gform_wrapper input[type=submit]:not(.btn-active),
.gform_wrapper .page-template-template-pagina-utente .toggle-selector input[type=submit]:not(.btn-active),
.page-template-template-pagina-utente .toggle-selector .gform_wrapper .button:not(.btn-active),
.gform_wrapper .page-template-template-pagina-utente .toggle-selector .button:not(.btn-active) {
  background-color: var(--btnBgColor);
  color: var(--btnFgColor);
}
.single-teacher .toggle-selector .btn:not(.btn-active):hover, .single-teacher .toggle-selector .gform_wrapper input[type=submit]:not(.btn-active):hover, .gform_wrapper .single-teacher .toggle-selector input[type=submit]:not(.btn-active):hover, .single-teacher .toggle-selector .gform_wrapper .button:not(.btn-active):hover, .gform_wrapper .single-teacher .toggle-selector .button:not(.btn-active):hover,
.page-template-template-pagina-utente .toggle-selector .btn:not(.btn-active):hover,
.page-template-template-pagina-utente .toggle-selector .gform_wrapper input[type=submit]:not(.btn-active):hover,
.gform_wrapper .page-template-template-pagina-utente .toggle-selector input[type=submit]:not(.btn-active):hover,
.page-template-template-pagina-utente .toggle-selector .gform_wrapper .button:not(.btn-active):hover,
.gform_wrapper .page-template-template-pagina-utente .toggle-selector .button:not(.btn-active):hover {
  color: #ffffff;
  background-color: var(--btnFgColor);
}
.single-teacher .toggle-selector .btn:not(:first-child):not(.btn-active), .single-teacher .toggle-selector .gform_wrapper input[type=submit]:not(:first-child):not(.btn-active), .gform_wrapper .single-teacher .toggle-selector input[type=submit]:not(:first-child):not(.btn-active), .single-teacher .toggle-selector .gform_wrapper .button:not(:first-child):not(.btn-active), .gform_wrapper .single-teacher .toggle-selector .button:not(:first-child):not(.btn-active),
.page-template-template-pagina-utente .toggle-selector .btn:not(:first-child):not(.btn-active),
.page-template-template-pagina-utente .toggle-selector .gform_wrapper input[type=submit]:not(:first-child):not(.btn-active),
.gform_wrapper .page-template-template-pagina-utente .toggle-selector input[type=submit]:not(:first-child):not(.btn-active),
.page-template-template-pagina-utente .toggle-selector .gform_wrapper .button:not(:first-child):not(.btn-active),
.gform_wrapper .page-template-template-pagina-utente .toggle-selector .button:not(:first-child):not(.btn-active) {
  margin-left: -1.35rem;
  padding-left: 2.25rem;
  border-radius: 0 2rem 2rem 0;
}
.gform_wrapper input[type=text],
.gform_wrapper input[type=date],
.gform_wrapper input[type=email],
.gform_wrapper input[type=number],
.gform_wrapper select,
.gform_wrapper textarea {
  background-color: #e7e8f0;
  border-color: #e7e8f0 default;
  border-radius: 10px;
  padding: 0.8rem 1.2rem;
  font-size: 1.25rem;
  border: 0;
}
.gform_wrapper legend {
  font-size: 1.25rem;
  text-transform: uppercase;
  color: #4b4b95;
  font-weight: 600;
  margin-top: 1rem;
  margin-bottom: 0;
}
.gform_wrapper label {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #4b4b95;
  font-weight: 600;
  margin-bottom: 0;
}
.gform_wrapper input[type=submit] {
  margin: 0 auto;
}
.gform_wrapper .gfield_required_text {
  font-style: normal;
  color: #f65d5d;
}
.gform_wrapper .gfield_description {
  margin-top: 0 !important;
  padding: 0.5rem 0 1rem 0 !important;
}
.gform_confirmation_wrapper .gform_confirmation_message {
  text-align: center;
  padding: 2rem 0;
  color: #4b4b95;
  font-weight: bold;
}
.validation_message {
  border: 0 !important;
  background: transparent !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
